// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    car_GetById(id: number, cancelToken?: CancelToken): Promise<CarEntity> {
        let url_ = this.baseUrl + "/api/Car/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCar_GetById(_response);
        });
    }

    protected processCar_GetById(response: AxiosResponse): Promise<CarEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CarEntity.fromJS(resultData200);
            return Promise.resolve<CarEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarEntity>(null as any);
    }

    car_Delete(id: number, cancelToken?: CancelToken): Promise<ApiResultOfCarEntity> {
        let url_ = this.baseUrl + "/api/Car/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCar_Delete(_response);
        });
    }

    protected processCar_Delete(response: AxiosResponse): Promise<ApiResultOfCarEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCarEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCarEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCarEntity>(null as any);
    }

    car_GetAll( cancelToken?: CancelToken): Promise<CarEntity[]> {
        let url_ = this.baseUrl + "/api/Car";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCar_GetAll(_response);
        });
    }

    protected processCar_GetAll(response: AxiosResponse): Promise<CarEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CarEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarEntity[]>(null as any);
    }

    car_Create(item: CarEntity, cancelToken?: CancelToken): Promise<ApiResultOfCarEntity> {
        let url_ = this.baseUrl + "/api/Car";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCar_Create(_response);
        });
    }

    protected processCar_Create(response: AxiosResponse): Promise<ApiResultOfCarEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCarEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCarEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCarEntity>(null as any);
    }

    car_Update(item: CarEntity, cancelToken?: CancelToken): Promise<ApiResultOfCarEntity> {
        let url_ = this.baseUrl + "/api/Car";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCar_Update(_response);
        });
    }

    protected processCar_Update(response: AxiosResponse): Promise<ApiResultOfCarEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCarEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCarEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCarEntity>(null as any);
    }

    carPlanning_GetById(id?: number | undefined, cancelToken?: CancelToken): Promise<CarPlanningEntity> {
        let url_ = this.baseUrl + "/api/CarPlanning?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCarPlanning_GetById(_response);
        });
    }

    protected processCarPlanning_GetById(response: AxiosResponse): Promise<CarPlanningEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CarPlanningEntity.fromJS(resultData200);
            return Promise.resolve<CarPlanningEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarPlanningEntity>(null as any);
    }

    carPlanning_Create(item: CarPlanningEntity, cancelToken?: CancelToken): Promise<ApiResultOfCarPlanningEntity> {
        let url_ = this.baseUrl + "/api/CarPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCarPlanning_Create(_response);
        });
    }

    protected processCarPlanning_Create(response: AxiosResponse): Promise<ApiResultOfCarPlanningEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCarPlanningEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCarPlanningEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCarPlanningEntity>(null as any);
    }

    carPlanning_Update(item: CarPlanningEntity, cancelToken?: CancelToken): Promise<ApiResultOfCarPlanningEntity> {
        let url_ = this.baseUrl + "/api/CarPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCarPlanning_Update(_response);
        });
    }

    protected processCarPlanning_Update(response: AxiosResponse): Promise<ApiResultOfCarPlanningEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCarPlanningEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCarPlanningEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCarPlanningEntity>(null as any);
    }

    carPlanning_GetAll(date: string | null, cancelToken?: CancelToken): Promise<CarPlanningEntity[]> {
        let url_ = this.baseUrl + "/api/CarPlanning/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCarPlanning_GetAll(_response);
        });
    }

    protected processCarPlanning_GetAll(response: AxiosResponse): Promise<CarPlanningEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarPlanningEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CarPlanningEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarPlanningEntity[]>(null as any);
    }

    carPlanning_GetAllListMode(date: string | null, cancelToken?: CancelToken): Promise<CarPlanningEntity[]> {
        let url_ = this.baseUrl + "/api/CarPlanning/GetAllListMode/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCarPlanning_GetAllListMode(_response);
        });
    }

    protected processCarPlanning_GetAllListMode(response: AxiosResponse): Promise<CarPlanningEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarPlanningEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CarPlanningEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarPlanningEntity[]>(null as any);
    }

    carPlanning_CreateOrUpdateListMode(item: CarTableListViewModel[], date: string | null, cancelToken?: CancelToken): Promise<ApiResultOfListOfCarPlanningEntity> {
        let url_ = this.baseUrl + "/api/CarPlanning/CreateOrUpdateListMode/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCarPlanning_CreateOrUpdateListMode(_response);
        });
    }

    protected processCarPlanning_CreateOrUpdateListMode(response: AxiosResponse): Promise<ApiResultOfListOfCarPlanningEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfListOfCarPlanningEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfListOfCarPlanningEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfListOfCarPlanningEntity>(null as any);
    }

    carPlanning_Delete(id: number, cancelToken?: CancelToken): Promise<ApiResultOfCarPlanningEntity> {
        let url_ = this.baseUrl + "/api/CarPlanning/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCarPlanning_Delete(_response);
        });
    }

    protected processCarPlanning_Delete(response: AxiosResponse): Promise<ApiResultOfCarPlanningEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCarPlanningEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCarPlanningEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCarPlanningEntity>(null as any);
    }

    carPlanning_RemoveOrderItem(id: string, planningId: number, cancelToken?: CancelToken): Promise<ApiResultOfCarPlanningEntity> {
        let url_ = this.baseUrl + "/api/CarPlanning/RemoveOrderItem/{id}/{planningId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (planningId === undefined || planningId === null)
            throw new Error("The parameter 'planningId' must be defined.");
        url_ = url_.replace("{planningId}", encodeURIComponent("" + planningId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCarPlanning_RemoveOrderItem(_response);
        });
    }

    protected processCarPlanning_RemoveOrderItem(response: AxiosResponse): Promise<ApiResultOfCarPlanningEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCarPlanningEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCarPlanningEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCarPlanningEntity>(null as any);
    }

    carPlanning_GetAllByIds(ids: number[], cancelToken?: CancelToken): Promise<CarPlanningEntity[]> {
        let url_ = this.baseUrl + "/api/CarPlanning/GetAllByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCarPlanning_GetAllByIds(_response);
        });
    }

    protected processCarPlanning_GetAllByIds(response: AxiosResponse): Promise<CarPlanningEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarPlanningEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CarPlanningEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarPlanningEntity[]>(null as any);
    }

    companyDetail_Get( cancelToken?: CancelToken): Promise<CompanyDetails> {
        let url_ = this.baseUrl + "/api/CompanyDetail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompanyDetail_Get(_response);
        });
    }

    protected processCompanyDetail_Get(response: AxiosResponse): Promise<CompanyDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompanyDetails.fromJS(resultData200);
            return Promise.resolve<CompanyDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyDetails>(null as any);
    }

    companyDetail_Update(item: CompanyDetails, cancelToken?: CancelToken): Promise<ApiResultOfCompanyDetails> {
        let url_ = this.baseUrl + "/api/CompanyDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompanyDetail_Update(_response);
        });
    }

    protected processCompanyDetail_Update(response: AxiosResponse): Promise<ApiResultOfCompanyDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCompanyDetails.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCompanyDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCompanyDetails>(null as any);
    }

    customer_CheckExistensCompanyNr(companynr: string | null, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Customer/CheckExistensCompanyNr/{companynr}";
        if (companynr === undefined || companynr === null)
            throw new Error("The parameter 'companynr' must be defined.");
        url_ = url_.replace("{companynr}", encodeURIComponent("" + companynr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomer_CheckExistensCompanyNr(_response);
        });
    }

    protected processCustomer_CheckExistensCompanyNr(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    customer_GetById(id: string, withDeliveryAddress: boolean, withPriceTemplate: boolean, withProducts: boolean, isOrderPage: boolean, cancelToken?: CancelToken): Promise<CustomerEntity> {
        let url_ = this.baseUrl + "/api/Customer/{id}/{withDeliveryAddress}/{withPriceTemplate}/{withProducts}/{isOrderPage}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (withDeliveryAddress === undefined || withDeliveryAddress === null)
            throw new Error("The parameter 'withDeliveryAddress' must be defined.");
        url_ = url_.replace("{withDeliveryAddress}", encodeURIComponent("" + withDeliveryAddress));
        if (withPriceTemplate === undefined || withPriceTemplate === null)
            throw new Error("The parameter 'withPriceTemplate' must be defined.");
        url_ = url_.replace("{withPriceTemplate}", encodeURIComponent("" + withPriceTemplate));
        if (withProducts === undefined || withProducts === null)
            throw new Error("The parameter 'withProducts' must be defined.");
        url_ = url_.replace("{withProducts}", encodeURIComponent("" + withProducts));
        if (isOrderPage === undefined || isOrderPage === null)
            throw new Error("The parameter 'isOrderPage' must be defined.");
        url_ = url_.replace("{isOrderPage}", encodeURIComponent("" + isOrderPage));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomer_GetById(_response);
        });
    }

    protected processCustomer_GetById(response: AxiosResponse): Promise<CustomerEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerEntity.fromJS(resultData200);
            return Promise.resolve<CustomerEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerEntity>(null as any);
    }

    customer_GetAll(isEnabled: boolean, withDeliveryAddress: boolean, withPriceTemplate: boolean, withProducts: boolean, isOrderPage: boolean, cancelToken?: CancelToken): Promise<CustomerEntity[]> {
        let url_ = this.baseUrl + "/api/Customer/GetAll/{isEnabled}/{withDeliveryAddress}/{withPriceTemplate}/{withProducts}/{isOrderPage}";
        if (isEnabled === undefined || isEnabled === null)
            throw new Error("The parameter 'isEnabled' must be defined.");
        url_ = url_.replace("{isEnabled}", encodeURIComponent("" + isEnabled));
        if (withDeliveryAddress === undefined || withDeliveryAddress === null)
            throw new Error("The parameter 'withDeliveryAddress' must be defined.");
        url_ = url_.replace("{withDeliveryAddress}", encodeURIComponent("" + withDeliveryAddress));
        if (withPriceTemplate === undefined || withPriceTemplate === null)
            throw new Error("The parameter 'withPriceTemplate' must be defined.");
        url_ = url_.replace("{withPriceTemplate}", encodeURIComponent("" + withPriceTemplate));
        if (withProducts === undefined || withProducts === null)
            throw new Error("The parameter 'withProducts' must be defined.");
        url_ = url_.replace("{withProducts}", encodeURIComponent("" + withProducts));
        if (isOrderPage === undefined || isOrderPage === null)
            throw new Error("The parameter 'isOrderPage' must be defined.");
        url_ = url_.replace("{isOrderPage}", encodeURIComponent("" + isOrderPage));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomer_GetAll(_response);
        });
    }

    protected processCustomer_GetAll(response: AxiosResponse): Promise<CustomerEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerEntity[]>(null as any);
    }

    customer_Create(item: CustomerEntity, cancelToken?: CancelToken): Promise<ApiResultOfCustomerEntity> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomer_Create(_response);
        });
    }

    protected processCustomer_Create(response: AxiosResponse): Promise<ApiResultOfCustomerEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCustomerEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCustomerEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCustomerEntity>(null as any);
    }

    customer_Update(item: CustomerEntity, id?: string | undefined, cancelToken?: CancelToken): Promise<ApiResultOfCustomerEntity> {
        let url_ = this.baseUrl + "/api/Customer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomer_Update(_response);
        });
    }

    protected processCustomer_Update(response: AxiosResponse): Promise<ApiResultOfCustomerEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCustomerEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCustomerEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCustomerEntity>(null as any);
    }

    customer_Delete(id: string, cancelToken?: CancelToken): Promise<ApiResultOfCustomerEntity> {
        let url_ = this.baseUrl + "/api/Customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomer_Delete(_response);
        });
    }

    protected processCustomer_Delete(response: AxiosResponse): Promise<ApiResultOfCustomerEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCustomerEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCustomerEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCustomerEntity>(null as any);
    }

    employee_GetAllSellers(isActive: boolean, cancelToken?: CancelToken): Promise<EmployeeEntity[]> {
        let url_ = this.baseUrl + "/api/Employee/GetAllSellers/{isActive}";
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployee_GetAllSellers(_response);
        });
    }

    protected processEmployee_GetAllSellers(response: AxiosResponse): Promise<EmployeeEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmployeeEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeEntity[]>(null as any);
    }

    employee_GetAllBuyers(isActive: boolean, cancelToken?: CancelToken): Promise<EmployeeEntity[]> {
        let url_ = this.baseUrl + "/api/Employee/GetAllBuyers/{isActive}";
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployee_GetAllBuyers(_response);
        });
    }

    protected processEmployee_GetAllBuyers(response: AxiosResponse): Promise<EmployeeEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmployeeEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeEntity[]>(null as any);
    }

    employee_GetAllDrivers(isActive: boolean, cancelToken?: CancelToken): Promise<EmployeeEntity[]> {
        let url_ = this.baseUrl + "/api/Employee/GetAllDrivers/{isActive}";
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployee_GetAllDrivers(_response);
        });
    }

    protected processEmployee_GetAllDrivers(response: AxiosResponse): Promise<EmployeeEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmployeeEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeEntity[]>(null as any);
    }

    employee_GetById(id: string, cancelToken?: CancelToken): Promise<EmployeeEntity> {
        let url_ = this.baseUrl + "/api/Employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployee_GetById(_response);
        });
    }

    protected processEmployee_GetById(response: AxiosResponse): Promise<EmployeeEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeEntity.fromJS(resultData200);
            return Promise.resolve<EmployeeEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeEntity>(null as any);
    }

    employee_GetAll( cancelToken?: CancelToken): Promise<EmployeeEntity[]> {
        let url_ = this.baseUrl + "/api/Employee";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployee_GetAll(_response);
        });
    }

    protected processEmployee_GetAll(response: AxiosResponse): Promise<EmployeeEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmployeeEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeEntity[]>(null as any);
    }

    employee_Create(item: EmployeeEntity, cancelToken?: CancelToken): Promise<ApiResultOfEmployeeEntity> {
        let url_ = this.baseUrl + "/api/Employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployee_Create(_response);
        });
    }

    protected processEmployee_Create(response: AxiosResponse): Promise<ApiResultOfEmployeeEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfEmployeeEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfEmployeeEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfEmployeeEntity>(null as any);
    }

    employee_Update(item: EmployeeEntity, cancelToken?: CancelToken): Promise<ApiResultOfEmployeeEntity> {
        let url_ = this.baseUrl + "/api/Employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployee_Update(_response);
        });
    }

    protected processEmployee_Update(response: AxiosResponse): Promise<ApiResultOfEmployeeEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfEmployeeEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfEmployeeEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfEmployeeEntity>(null as any);
    }

    employee_Delete(email: string | null, cancelToken?: CancelToken): Promise<ApiResultOfEmployeeEntity> {
        let url_ = this.baseUrl + "/api/Employee/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployee_Delete(_response);
        });
    }

    protected processEmployee_Delete(response: AxiosResponse): Promise<ApiResultOfEmployeeEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfEmployeeEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfEmployeeEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfEmployeeEntity>(null as any);
    }

    fortnox_GetAllCustomers(filter: CustomerSearch, cancelToken?: CancelToken): Promise<CustomerSubset[]> {
        let url_ = this.baseUrl + "/api/Fortnox/GetAllCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_GetAllCustomers(_response);
        });
    }

    protected processFortnox_GetAllCustomers(response: AxiosResponse): Promise<CustomerSubset[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerSubset.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerSubset[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSubset[]>(null as any);
    }

    fortnox_GetCustomers(filter: CustomerSearch, cancelToken?: CancelToken): Promise<EntityCollectionOfCustomerSubset> {
        let url_ = this.baseUrl + "/api/Fortnox/GetCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_GetCustomers(_response);
        });
    }

    protected processFortnox_GetCustomers(response: AxiosResponse): Promise<EntityCollectionOfCustomerSubset> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCollectionOfCustomerSubset.fromJS(resultData200);
            return Promise.resolve<EntityCollectionOfCustomerSubset>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCollectionOfCustomerSubset>(null as any);
    }

    fortnox_CloneAllCustomersToFortnox(filter: CustomerSearch, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Fortnox/CloneAllCustomersToFortnox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_CloneAllCustomersToFortnox(_response);
        });
    }

    protected processFortnox_CloneAllCustomersToFortnox(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    fortnox_CreateCustomer(item: CustomerEntity, cancelToken?: CancelToken): Promise<Customer3> {
        let url_ = this.baseUrl + "/api/Fortnox/CreateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_CreateCustomer(_response);
        });
    }

    protected processFortnox_CreateCustomer(response: AxiosResponse): Promise<Customer3> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Customer3.fromJS(resultData200);
            return Promise.resolve<Customer3>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Customer3>(null as any);
    }

    fortnox_SendInvoiceList(id: number[], cancelToken?: CancelToken): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/api/Fortnox/SendInvoiceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_SendInvoiceList(_response);
        });
    }

    protected processFortnox_SendInvoiceList(response: AxiosResponse): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Invoice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    fortnox_BookKeepInvoiceList(id: number[], cancelToken?: CancelToken): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/api/Fortnox/BookKeepInvoiceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_BookKeepInvoiceList(_response);
        });
    }

    protected processFortnox_BookKeepInvoiceList(response: AxiosResponse): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Invoice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    fortnox_CreateInvoiceById(ids: number[], cancelToken?: CancelToken): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/api/Fortnox/CreateInvoiceById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_CreateInvoiceById(_response);
        });
    }

    protected processFortnox_CreateInvoiceById(response: AxiosResponse): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Invoice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    fortnox_CreditInvoiceList(id: number[], cancelToken?: CancelToken): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/api/Fortnox/CreditInvoiceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_CreditInvoiceList(_response);
        });
    }

    protected processFortnox_CreditInvoiceList(response: AxiosResponse): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Invoice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    fortnox_CancelInvoiceList(id: number[], cancelToken?: CancelToken): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/api/Fortnox/CancelInvoiceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_CancelInvoiceList(_response);
        });
    }

    protected processFortnox_CancelInvoiceList(response: AxiosResponse): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Invoice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    fortnox_GetAllInvoices(filter: InvoiceSearch, cancelToken?: CancelToken): Promise<InvoiceSubset[]> {
        let url_ = this.baseUrl + "/api/Fortnox/GetAllInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_GetAllInvoices(_response);
        });
    }

    protected processFortnox_GetAllInvoices(response: AxiosResponse): Promise<InvoiceSubset[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceSubset.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvoiceSubset[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceSubset[]>(null as any);
    }

    fortnox_GetAllInvoicesNotGenerated( cancelToken?: CancelToken): Promise<InvoiceEntity[]> {
        let url_ = this.baseUrl + "/api/Fortnox/GetAllInvoicesNotGenerated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_GetAllInvoicesNotGenerated(_response);
        });
    }

    protected processFortnox_GetAllInvoicesNotGenerated(response: AxiosResponse): Promise<InvoiceEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvoiceEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceEntity[]>(null as any);
    }

    fortnox_GetInvoices(filter: InvoiceSearch, cancelToken?: CancelToken): Promise<EntityCollectionOfInvoiceSubset> {
        let url_ = this.baseUrl + "/api/Fortnox/GetInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_GetInvoices(_response);
        });
    }

    protected processFortnox_GetInvoices(response: AxiosResponse): Promise<EntityCollectionOfInvoiceSubset> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCollectionOfInvoiceSubset.fromJS(resultData200);
            return Promise.resolve<EntityCollectionOfInvoiceSubset>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCollectionOfInvoiceSubset>(null as any);
    }

    fortnox_CreateInvoiceList(payload: InvoiceEntity[], cancelToken?: CancelToken): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/api/Fortnox/CreateInvoiceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_CreateInvoiceList(_response);
        });
    }

    protected processFortnox_CreateInvoiceList(response: AxiosResponse): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Invoice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    fortnox_DownloadInvoiceById(id: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Fortnox/DownloadInvoiceById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_DownloadInvoiceById(_response);
        });
    }

    protected processFortnox_DownloadInvoiceById(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    fortnox_GetAllArticles(filter: ArticleSearch, cancelToken?: CancelToken): Promise<ArticleSubset[]> {
        let url_ = this.baseUrl + "/api/Fortnox/GetAllArticles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_GetAllArticles(_response);
        });
    }

    protected processFortnox_GetAllArticles(response: AxiosResponse): Promise<ArticleSubset[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleSubset.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ArticleSubset[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleSubset[]>(null as any);
    }

    fortnox_GetArticles(filter: ArticleSearch, cancelToken?: CancelToken): Promise<EntityCollectionOfArticleSubset> {
        let url_ = this.baseUrl + "/api/Fortnox/GetArticles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_GetArticles(_response);
        });
    }

    protected processFortnox_GetArticles(response: AxiosResponse): Promise<EntityCollectionOfArticleSubset> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCollectionOfArticleSubset.fromJS(resultData200);
            return Promise.resolve<EntityCollectionOfArticleSubset>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCollectionOfArticleSubset>(null as any);
    }

    fortnox_CloneAllArticlesToFortnox(filter: ArticleSearch, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Fortnox/CloneAllArticlesToFortnox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_CloneAllArticlesToFortnox(_response);
        });
    }

    protected processFortnox_CloneAllArticlesToFortnox(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    fortnox_CreateArticle(item: ProductEntity, cancelToken?: CancelToken): Promise<Article3> {
        let url_ = this.baseUrl + "/api/Fortnox/CreateArticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFortnox_CreateArticle(_response);
        });
    }

    protected processFortnox_CreateArticle(response: AxiosResponse): Promise<Article3> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Article3.fromJS(resultData200);
            return Promise.resolve<Article3>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article3>(null as any);
    }

    invoice_GetById(id: number, cancelToken?: CancelToken): Promise<InvoiceEntity> {
        let url_ = this.baseUrl + "/api/Invoice/GetByInvoiceId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_GetById(_response);
        });
    }

    protected processInvoice_GetById(response: AxiosResponse): Promise<InvoiceEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceEntity.fromJS(resultData200);
            return Promise.resolve<InvoiceEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceEntity>(null as any);
    }

    invoice_GetAll(date: string | null, cancelToken?: CancelToken): Promise<InvoiceEntity[]> {
        let url_ = this.baseUrl + "/api/Invoice/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_GetAll(_response);
        });
    }

    protected processInvoice_GetAll(response: AxiosResponse): Promise<InvoiceEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvoiceEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceEntity[]>(null as any);
    }

    invoice_Create(item: InvoiceEntity, cancelToken?: CancelToken): Promise<ApiResultOfInvoiceEntity> {
        let url_ = this.baseUrl + "/api/Invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_Create(_response);
        });
    }

    protected processInvoice_Create(response: AxiosResponse): Promise<ApiResultOfInvoiceEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfInvoiceEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfInvoiceEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfInvoiceEntity>(null as any);
    }

    invoice_CreateAll(items: InvoiceEntity[], cancelToken?: CancelToken): Promise<ApiResultOfListOfInvoiceEntity> {
        let url_ = this.baseUrl + "/api/Invoice/CreateAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_CreateAll(_response);
        });
    }

    protected processInvoice_CreateAll(response: AxiosResponse): Promise<ApiResultOfListOfInvoiceEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfListOfInvoiceEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfListOfInvoiceEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfListOfInvoiceEntity>(null as any);
    }

    invoice_Delete(id: number, cancelToken?: CancelToken): Promise<ApiResultOfInvoiceEntity> {
        let url_ = this.baseUrl + "/api/Invoice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_Delete(_response);
        });
    }

    protected processInvoice_Delete(response: AxiosResponse): Promise<ApiResultOfInvoiceEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfInvoiceEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfInvoiceEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfInvoiceEntity>(null as any);
    }

    offer_GetAllOffersByDate(date: string | null, cancelToken?: CancelToken): Promise<OrderEntity[]> {
        let url_ = this.baseUrl + "/api/Offer/GetAllOffersByDate/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOffer_GetAllOffersByDate(_response);
        });
    }

    protected processOffer_GetAllOffersByDate(response: AxiosResponse): Promise<OrderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderEntity[]>(null as any);
    }

    offer_GetAllOffers( cancelToken?: CancelToken): Promise<OrderEntity[]> {
        let url_ = this.baseUrl + "/api/Offer/GetAllOffers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOffer_GetAllOffers(_response);
        });
    }

    protected processOffer_GetAllOffers(response: AxiosResponse): Promise<OrderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderEntity[]>(null as any);
    }

    offer_GetCustomerOfferByFilterMode(customerFk: string, cancelToken?: CancelToken): Promise<OrderEntity[]> {
        let url_ = this.baseUrl + "/api/Offer/GetCustomerOfferByFilterMode/{customerFk}";
        if (customerFk === undefined || customerFk === null)
            throw new Error("The parameter 'customerFk' must be defined.");
        url_ = url_.replace("{customerFk}", encodeURIComponent("" + customerFk));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOffer_GetCustomerOfferByFilterMode(_response);
        });
    }

    protected processOffer_GetCustomerOfferByFilterMode(response: AxiosResponse): Promise<OrderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderEntity[]>(null as any);
    }

    order_GetOrderByIds(orderIds: string[], cancelToken?: CancelToken): Promise<OrderEntity[]> {
        let url_ = this.baseUrl + "/api/Order/GetOrderByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrder_GetOrderByIds(_response);
        });
    }

    protected processOrder_GetOrderByIds(response: AxiosResponse): Promise<OrderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderEntity[]>(null as any);
    }

    order_GetOrderById(orderId: string, cancelToken?: CancelToken): Promise<OrderEntity> {
        let url_ = this.baseUrl + "/api/Order/GetOrderById/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrder_GetOrderById(_response);
        });
    }

    protected processOrder_GetOrderById(response: AxiosResponse): Promise<OrderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderEntity.fromJS(resultData200);
            return Promise.resolve<OrderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderEntity>(null as any);
    }

    order_GetAllOrdersByDate(date: string | null, cancelToken?: CancelToken): Promise<OrderEntity[]> {
        let url_ = this.baseUrl + "/api/Order/GetAllOrdersByDate/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrder_GetAllOrdersByDate(_response);
        });
    }

    protected processOrder_GetAllOrdersByDate(response: AxiosResponse): Promise<OrderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderEntity[]>(null as any);
    }

    order_Get(customerFk: string, date: string | null, cancelToken?: CancelToken): Promise<OrderEntity[]> {
        let url_ = this.baseUrl + "/api/Order/{customerFk}/{date}";
        if (customerFk === undefined || customerFk === null)
            throw new Error("The parameter 'customerFk' must be defined.");
        url_ = url_.replace("{customerFk}", encodeURIComponent("" + customerFk));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrder_Get(_response);
        });
    }

    protected processOrder_Get(response: AxiosResponse): Promise<OrderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderEntity[]>(null as any);
    }

    order_Create(item: OrderEntity, cancelToken?: CancelToken): Promise<ApiResultOfOrderEntity> {
        let url_ = this.baseUrl + "/api/Order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrder_Create(_response);
        });
    }

    protected processOrder_Create(response: AxiosResponse): Promise<ApiResultOfOrderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfOrderEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfOrderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfOrderEntity>(null as any);
    }

    order_Update(item: OrderEntity, cancelToken?: CancelToken): Promise<ApiResultOfOrderEntity> {
        let url_ = this.baseUrl + "/api/Order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrder_Update(_response);
        });
    }

    protected processOrder_Update(response: AxiosResponse): Promise<ApiResultOfOrderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfOrderEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfOrderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfOrderEntity>(null as any);
    }

    order_CreditProductStock(product: OrderProductCreditDto, cancelToken?: CancelToken): Promise<ApiResultOfGuid> {
        let url_ = this.baseUrl + "/api/Order/CreditProductStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrder_CreditProductStock(_response);
        });
    }

    protected processOrder_CreditProductStock(response: AxiosResponse): Promise<ApiResultOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfGuid.fromJS(resultData200);
            return Promise.resolve<ApiResultOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfGuid>(null as any);
    }

    order_Delete(id: string | null, resetStock: boolean, cancelToken?: CancelToken): Promise<ApiResultOfOrderEntity> {
        let url_ = this.baseUrl + "/api/Order/{id}/{resetStock}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (resetStock === undefined || resetStock === null)
            throw new Error("The parameter 'resetStock' must be defined.");
        url_ = url_.replace("{resetStock}", encodeURIComponent("" + resetStock));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrder_Delete(_response);
        });
    }

    protected processOrder_Delete(response: AxiosResponse): Promise<ApiResultOfOrderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfOrderEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfOrderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfOrderEntity>(null as any);
    }

    order_GetAllOrdersByFilterMode(filterMode: number, date: string, cancelToken?: CancelToken): Promise<OrderEntity[]> {
        let url_ = this.baseUrl + "/api/Order/GetAllOrdersByFilterMode/{filterMode}/{date}";
        if (filterMode === undefined || filterMode === null)
            throw new Error("The parameter 'filterMode' must be defined.");
        url_ = url_.replace("{filterMode}", encodeURIComponent("" + filterMode));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrder_GetAllOrdersByFilterMode(_response);
        });
    }

    protected processOrder_GetAllOrdersByFilterMode(response: AxiosResponse): Promise<OrderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderEntity[]>(null as any);
    }

    order_GetCustomerOrderByFilterMode(customerFk: string, filterMode: number, date: string, cancelToken?: CancelToken): Promise<OrderEntity[]> {
        let url_ = this.baseUrl + "/api/Order/GetCustomerOrderByFilterMode/{customerFk}/{filterMode}/{date}";
        if (customerFk === undefined || customerFk === null)
            throw new Error("The parameter 'customerFk' must be defined.");
        url_ = url_.replace("{customerFk}", encodeURIComponent("" + customerFk));
        if (filterMode === undefined || filterMode === null)
            throw new Error("The parameter 'filterMode' must be defined.");
        url_ = url_.replace("{filterMode}", encodeURIComponent("" + filterMode));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrder_GetCustomerOrderByFilterMode(_response);
        });
    }

    protected processOrder_GetCustomerOrderByFilterMode(response: AxiosResponse): Promise<OrderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderEntity[]>(null as any);
    }

    order_UpdateOrderPrintingStatusByIds(orderIds: string[], isDeliveryNote?: boolean | undefined, isToggleStatus?: boolean | undefined, cancelToken?: CancelToken): Promise<ApiResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Order/UpdateOrderPrintingStatusByIds?";
        if (isDeliveryNote === null)
            throw new Error("The parameter 'isDeliveryNote' cannot be null.");
        else if (isDeliveryNote !== undefined)
            url_ += "isDeliveryNote=" + encodeURIComponent("" + isDeliveryNote) + "&";
        if (isToggleStatus === null)
            throw new Error("The parameter 'isToggleStatus' cannot be null.");
        else if (isToggleStatus !== undefined)
            url_ += "isToggleStatus=" + encodeURIComponent("" + isToggleStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrder_UpdateOrderPrintingStatusByIds(_response);
        });
    }

    protected processOrder_UpdateOrderPrintingStatusByIds(response: AxiosResponse): Promise<ApiResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfBoolean>(null as any);
    }

    orderProduct_GetAllOrdersByProductId(productId: string, cancelToken?: CancelToken): Promise<OrderDTO[]> {
        let url_ = this.baseUrl + "/api/OrderProduct/GetAllOrdersByProductId/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderProduct_GetAllOrdersByProductId(_response);
        });
    }

    protected processOrderProduct_GetAllOrdersByProductId(response: AxiosResponse): Promise<OrderDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDTO[]>(null as any);
    }

    orderProduct_GetAllOrderedProductsByCustomerId(customerId: string, cancelToken?: CancelToken): Promise<OrderProductDTO[]> {
        let url_ = this.baseUrl + "/api/OrderProduct/GetAllOrderedProductsByCustomerId/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderProduct_GetAllOrderedProductsByCustomerId(_response);
        });
    }

    protected processOrderProduct_GetAllOrderedProductsByCustomerId(response: AxiosResponse): Promise<OrderProductDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderProductDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderProductDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderProductDTO[]>(null as any);
    }

    pdf_PrintDeliveryNote(orderIdList: string[], cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pdf/PrintDeliveryNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderIdList);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPdf_PrintDeliveryNote(_response);
        });
    }

    protected processPdf_PrintDeliveryNote(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    pdf_PrintPickList(orderIdList: string[], cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pdf/PrintPickList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderIdList);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPdf_PrintPickList(_response);
        });
    }

    protected processPdf_PrintPickList(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    pdf_PrintFreezeList(orderIdList: string[], cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pdf/PrintFreezeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderIdList);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPdf_PrintFreezeList(_response);
        });
    }

    protected processPdf_PrintFreezeList(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    pdf_PrintFreezeSummaryList(orderIdList: string[], cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pdf/PrintFreezeSummaryList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderIdList);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPdf_PrintFreezeSummaryList(_response);
        });
    }

    protected processPdf_PrintFreezeSummaryList(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    pdf_PrintOfferList(orderIdList: string[], cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pdf/PrintOfferList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderIdList);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPdf_PrintOfferList(_response);
        });
    }

    protected processPdf_PrintOfferList(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    priceTemplate_GetById(id: string, cancelToken?: CancelToken): Promise<PriceTemplateViewModel> {
        let url_ = this.baseUrl + "/api/PriceTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPriceTemplate_GetById(_response);
        });
    }

    protected processPriceTemplate_GetById(response: AxiosResponse): Promise<PriceTemplateViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PriceTemplateViewModel.fromJS(resultData200);
            return Promise.resolve<PriceTemplateViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriceTemplateViewModel>(null as any);
    }

    priceTemplate_Delete(id: string, cancelToken?: CancelToken): Promise<ApiResultOfPriceTemplateViewModel> {
        let url_ = this.baseUrl + "/api/PriceTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPriceTemplate_Delete(_response);
        });
    }

    protected processPriceTemplate_Delete(response: AxiosResponse): Promise<ApiResultOfPriceTemplateViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfPriceTemplateViewModel.fromJS(resultData200);
            return Promise.resolve<ApiResultOfPriceTemplateViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfPriceTemplateViewModel>(null as any);
    }

    priceTemplate_GetAll( cancelToken?: CancelToken): Promise<PriceTemplateViewModel[]> {
        let url_ = this.baseUrl + "/api/PriceTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPriceTemplate_GetAll(_response);
        });
    }

    protected processPriceTemplate_GetAll(response: AxiosResponse): Promise<PriceTemplateViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriceTemplateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PriceTemplateViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriceTemplateViewModel[]>(null as any);
    }

    priceTemplate_Create(item: PriceTemplateViewModel, cancelToken?: CancelToken): Promise<ApiResultOfPriceTemplateViewModel> {
        let url_ = this.baseUrl + "/api/PriceTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPriceTemplate_Create(_response);
        });
    }

    protected processPriceTemplate_Create(response: AxiosResponse): Promise<ApiResultOfPriceTemplateViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfPriceTemplateViewModel.fromJS(resultData200);
            return Promise.resolve<ApiResultOfPriceTemplateViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfPriceTemplateViewModel>(null as any);
    }

    priceTemplate_Update(item: PriceTemplateViewModel, cancelToken?: CancelToken): Promise<ApiResultOfPriceTemplateViewModel> {
        let url_ = this.baseUrl + "/api/PriceTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPriceTemplate_Update(_response);
        });
    }

    protected processPriceTemplate_Update(response: AxiosResponse): Promise<ApiResultOfPriceTemplateViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfPriceTemplateViewModel.fromJS(resultData200);
            return Promise.resolve<ApiResultOfPriceTemplateViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfPriceTemplateViewModel>(null as any);
    }

    priceTemplate_UpdatePrice(priceTemplateId: string, productId: string, price?: number | undefined, cancelToken?: CancelToken): Promise<ApiResultOfPriceTemplateViewModel> {
        let url_ = this.baseUrl + "/api/PriceTemplate/UpdatePrice/{priceTemplateId}/{productId}?";
        if (priceTemplateId === undefined || priceTemplateId === null)
            throw new Error("The parameter 'priceTemplateId' must be defined.");
        url_ = url_.replace("{priceTemplateId}", encodeURIComponent("" + priceTemplateId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (price === null)
            throw new Error("The parameter 'price' cannot be null.");
        else if (price !== undefined)
            url_ += "price=" + encodeURIComponent("" + price) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPriceTemplate_UpdatePrice(_response);
        });
    }

    protected processPriceTemplate_UpdatePrice(response: AxiosResponse): Promise<ApiResultOfPriceTemplateViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfPriceTemplateViewModel.fromJS(resultData200);
            return Promise.resolve<ApiResultOfPriceTemplateViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfPriceTemplateViewModel>(null as any);
    }

    product_GetAllByProviderFk(providerFk: string, cancelToken?: CancelToken): Promise<ProductEntity[]> {
        let url_ = this.baseUrl + "/api/Product/GetAllByProviderFk/{providerFk}";
        if (providerFk === undefined || providerFk === null)
            throw new Error("The parameter 'providerFk' must be defined.");
        url_ = url_.replace("{providerFk}", encodeURIComponent("" + providerFk));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProduct_GetAllByProviderFk(_response);
        });
    }

    protected processProduct_GetAllByProviderFk(response: AxiosResponse): Promise<ProductEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductEntity[]>(null as any);
    }

    product_GetById(id: string, cancelToken?: CancelToken): Promise<ProductEntity> {
        let url_ = this.baseUrl + "/api/Product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProduct_GetById(_response);
        });
    }

    protected processProduct_GetById(response: AxiosResponse): Promise<ProductEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductEntity.fromJS(resultData200);
            return Promise.resolve<ProductEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductEntity>(null as any);
    }

    product_Delete(id: string, cancelToken?: CancelToken): Promise<ApiResultOfProductEntity> {
        let url_ = this.baseUrl + "/api/Product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProduct_Delete(_response);
        });
    }

    protected processProduct_Delete(response: AxiosResponse): Promise<ApiResultOfProductEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfProductEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfProductEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfProductEntity>(null as any);
    }

    product_GetAll( cancelToken?: CancelToken): Promise<ProductEntity[]> {
        let url_ = this.baseUrl + "/api/Product";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProduct_GetAll(_response);
        });
    }

    protected processProduct_GetAll(response: AxiosResponse): Promise<ProductEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductEntity[]>(null as any);
    }

    product_Create(item: ProductEntity, cancelToken?: CancelToken): Promise<ApiResultOfProductEntity> {
        let url_ = this.baseUrl + "/api/Product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProduct_Create(_response);
        });
    }

    protected processProduct_Create(response: AxiosResponse): Promise<ApiResultOfProductEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfProductEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfProductEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfProductEntity>(null as any);
    }

    product_Update(item: ProductEntity, cancelToken?: CancelToken): Promise<ApiResultOfProductEntity> {
        let url_ = this.baseUrl + "/api/Product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProduct_Update(_response);
        });
    }

    protected processProduct_Update(response: AxiosResponse): Promise<ApiResultOfProductEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfProductEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfProductEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfProductEntity>(null as any);
    }

    product_UpdateMinPointDays(productId?: string | undefined, minPointDays?: number | undefined, cancelToken?: CancelToken): Promise<ApiResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Product/UpdateMinPointDays?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (minPointDays === null)
            throw new Error("The parameter 'minPointDays' cannot be null.");
        else if (minPointDays !== undefined)
            url_ += "minPointDays=" + encodeURIComponent("" + minPointDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProduct_UpdateMinPointDays(_response);
        });
    }

    protected processProduct_UpdateMinPointDays(response: AxiosResponse): Promise<ApiResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfBoolean>(null as any);
    }

    product_ToogleCustomerFavorite(customerId?: string | undefined, productId?: string | undefined, isFavorite?: boolean | undefined, cancelToken?: CancelToken): Promise<ApiResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Product/ToogleCustomerFavorite?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (isFavorite === null)
            throw new Error("The parameter 'isFavorite' cannot be null.");
        else if (isFavorite !== undefined)
            url_ += "isFavorite=" + encodeURIComponent("" + isFavorite) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProduct_ToogleCustomerFavorite(_response);
        });
    }

    protected processProduct_ToogleCustomerFavorite(response: AxiosResponse): Promise<ApiResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfBoolean>(null as any);
    }

    product_UpdateProductStock(productId?: string | undefined, amountToUpdate?: number | undefined, cancelToken?: CancelToken): Promise<ApiResultOfDouble> {
        let url_ = this.baseUrl + "/api/Product/UpdateProductStock?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (amountToUpdate === null)
            throw new Error("The parameter 'amountToUpdate' cannot be null.");
        else if (amountToUpdate !== undefined)
            url_ += "amountToUpdate=" + encodeURIComponent("" + amountToUpdate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProduct_UpdateProductStock(_response);
        });
    }

    protected processProduct_UpdateProductStock(response: AxiosResponse): Promise<ApiResultOfDouble> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfDouble.fromJS(resultData200);
            return Promise.resolve<ApiResultOfDouble>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfDouble>(null as any);
    }

    product_ExportProductLogsToExcel(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Product/ExportProductLogsToExcel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProduct_ExportProductLogsToExcel(_response);
        });
    }

    protected processProduct_ExportProductLogsToExcel(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    provider_GetById(id: string, cancelToken?: CancelToken): Promise<ProviderEntity> {
        let url_ = this.baseUrl + "/api/Provider/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProvider_GetById(_response);
        });
    }

    protected processProvider_GetById(response: AxiosResponse): Promise<ProviderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProviderEntity.fromJS(resultData200);
            return Promise.resolve<ProviderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderEntity>(null as any);
    }

    provider_Delete(id: string, cancelToken?: CancelToken): Promise<ApiResultOfProviderEntity> {
        let url_ = this.baseUrl + "/api/Provider/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProvider_Delete(_response);
        });
    }

    protected processProvider_Delete(response: AxiosResponse): Promise<ApiResultOfProviderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfProviderEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfProviderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfProviderEntity>(null as any);
    }

    provider_GetAll( cancelToken?: CancelToken): Promise<ProviderEntity[]> {
        let url_ = this.baseUrl + "/api/Provider";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProvider_GetAll(_response);
        });
    }

    protected processProvider_GetAll(response: AxiosResponse): Promise<ProviderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProviderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProviderEntity[]>(null as any);
    }

    provider_Create(item: ProviderEntity, cancelToken?: CancelToken): Promise<ApiResultOfProviderEntity> {
        let url_ = this.baseUrl + "/api/Provider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProvider_Create(_response);
        });
    }

    protected processProvider_Create(response: AxiosResponse): Promise<ApiResultOfProviderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfProviderEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfProviderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfProviderEntity>(null as any);
    }

    provider_Update(item: ProviderEntity, cancelToken?: CancelToken): Promise<ApiResultOfProviderEntity> {
        let url_ = this.baseUrl + "/api/Provider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProvider_Update(_response);
        });
    }

    protected processProvider_Update(response: AxiosResponse): Promise<ApiResultOfProviderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfProviderEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfProviderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfProviderEntity>(null as any);
    }

    providerProductLog_Create(item: Provider_Product_LogEntity, cancelToken?: CancelToken): Promise<ApiResultOfProvider_Product_LogEntity> {
        let url_ = this.baseUrl + "/api/ProviderProductLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProviderProductLog_Create(_response);
        });
    }

    protected processProviderProductLog_Create(response: AxiosResponse): Promise<ApiResultOfProvider_Product_LogEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfProvider_Product_LogEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfProvider_Product_LogEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfProvider_Product_LogEntity>(null as any);
    }

    purchase_GetAllProductByIds(withParent: boolean, productIds: string[], cancelToken?: CancelToken): Promise<PurchaseProductEntity[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetAllProductByIds/{withParent}";
        if (withParent === undefined || withParent === null)
            throw new Error("The parameter 'withParent' must be defined.");
        url_ = url_.replace("{withParent}", encodeURIComponent("" + withParent));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchase_GetAllProductByIds(_response);
        });
    }

    protected processPurchase_GetAllProductByIds(response: AxiosResponse): Promise<PurchaseProductEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PurchaseProductEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PurchaseProductEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaseProductEntity[]>(null as any);
    }

    purchase_GetProductById(withParent: boolean, productId?: string | undefined, cancelToken?: CancelToken): Promise<PurchaseProductEntity> {
        let url_ = this.baseUrl + "/api/Purchase/GetProductById/{withParent}?";
        if (withParent === undefined || withParent === null)
            throw new Error("The parameter 'withParent' must be defined.");
        url_ = url_.replace("{withParent}", encodeURIComponent("" + withParent));
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchase_GetProductById(_response);
        });
    }

    protected processPurchase_GetProductById(response: AxiosResponse): Promise<PurchaseProductEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchaseProductEntity.fromJS(resultData200);
            return Promise.resolve<PurchaseProductEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaseProductEntity>(null as any);
    }

    purchase_GetAll( cancelToken?: CancelToken): Promise<PurchaseEntity[]> {
        let url_ = this.baseUrl + "/api/Purchase";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchase_GetAll(_response);
        });
    }

    protected processPurchase_GetAll(response: AxiosResponse): Promise<PurchaseEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PurchaseEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PurchaseEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaseEntity[]>(null as any);
    }

    purchase_Create(item: PurchaseEntity, cancelToken?: CancelToken): Promise<ApiResultOfPurchaseEntity> {
        let url_ = this.baseUrl + "/api/Purchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchase_Create(_response);
        });
    }

    protected processPurchase_Create(response: AxiosResponse): Promise<ApiResultOfPurchaseEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfPurchaseEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfPurchaseEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfPurchaseEntity>(null as any);
    }

    purchase_Update(item: PurchaseEntity, cancelToken?: CancelToken): Promise<ApiResultOfPurchaseEntity> {
        let url_ = this.baseUrl + "/api/Purchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchase_Update(_response);
        });
    }

    protected processPurchase_Update(response: AxiosResponse): Promise<ApiResultOfPurchaseEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfPurchaseEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfPurchaseEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfPurchaseEntity>(null as any);
    }

    purchase_GetById(id: string, cancelToken?: CancelToken): Promise<PurchaseEntity> {
        let url_ = this.baseUrl + "/api/Purchase/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchase_GetById(_response);
        });
    }

    protected processPurchase_GetById(response: AxiosResponse): Promise<PurchaseEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchaseEntity.fromJS(resultData200);
            return Promise.resolve<PurchaseEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaseEntity>(null as any);
    }

    purchase_Delete(id: string, cancelToken?: CancelToken): Promise<ApiResultOfPurchaseEntity> {
        let url_ = this.baseUrl + "/api/Purchase/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchase_Delete(_response);
        });
    }

    protected processPurchase_Delete(response: AxiosResponse): Promise<ApiResultOfPurchaseEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfPurchaseEntity.fromJS(resultData200);
            return Promise.resolve<ApiResultOfPurchaseEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfPurchaseEntity>(null as any);
    }

    role_GetAll( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Role";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRole_GetAll(_response);
        });
    }

    protected processRole_GetAll(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    smartOrder_AskProductsForCustomer(customerId: string, cancelToken?: CancelToken): Promise<AskProductResponse> {
        let url_ = this.baseUrl + "/api/SmartOrder/AskProductsForCustomer/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSmartOrder_AskProductsForCustomer(_response);
        });
    }

    protected processSmartOrder_AskProductsForCustomer(response: AxiosResponse): Promise<AskProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AskProductResponse.fromJS(resultData200);
            return Promise.resolve<AskProductResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AskProductResponse>(null as any);
    }

    stock_GetStockData(dt: string, cancelToken?: CancelToken): Promise<StockViewModel[]> {
        let url_ = this.baseUrl + "/api/Stock/GetStockData/{dt}";
        if (dt === undefined || dt === null)
            throw new Error("The parameter 'dt' must be defined.");
        url_ = url_.replace("{dt}", encodeURIComponent("" + dt));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStock_GetStockData(_response);
        });
    }

    protected processStock_GetStockData(response: AxiosResponse): Promise<StockViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StockViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockViewModel[]>(null as any);
    }

    stockValue_GetStockValueData( cancelToken?: CancelToken): Promise<StockValueViewModel[]> {
        let url_ = this.baseUrl + "/api/StockValue";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockValue_GetStockValueData(_response);
        });
    }

    protected processStockValue_GetStockValueData(response: AxiosResponse): Promise<StockValueViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockValueViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StockValueViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockValueViewModel[]>(null as any);
    }

    user_ToggleAccountStatus(email: string | null, isActive?: boolean | undefined, cancelToken?: CancelToken): Promise<ApiResultOfBoolean> {
        let url_ = this.baseUrl + "/api/User/ToggleAccountStatus/{email}?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUser_ToggleAccountStatus(_response);
        });
    }

    protected processUser_ToggleAccountStatus(response: AxiosResponse): Promise<ApiResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfBoolean>(null as any);
    }

    user_PasswordChange(email: string | null, password?: string | null | undefined, cancelToken?: CancelToken): Promise<ApiResultOfString> {
        let url_ = this.baseUrl + "/api/User/PasswordChange/{email}?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUser_PasswordChange(_response);
        });
    }

    protected processUser_PasswordChange(response: AxiosResponse): Promise<ApiResultOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfString.fromJS(resultData200);
            return Promise.resolve<ApiResultOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfString>(null as any);
    }
}

export class CarEntity implements ICarEntity {
    id!: number;
    name?: string | null;
    brand?: string | null;
    model?: string | null;
    numberPlate?: string | null;
    width!: number;
    height!: number;
    length!: number;
    maxLoad!: number;
    isEnabled!: boolean;
    plannings?: CarPlanningEntity[] | null;

    constructor(data?: ICarEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.numberPlate = _data["numberPlate"] !== undefined ? _data["numberPlate"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.length = _data["length"] !== undefined ? _data["length"] : <any>null;
            this.maxLoad = _data["maxLoad"] !== undefined ? _data["maxLoad"] : <any>null;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : <any>null;
            if (Array.isArray(_data["plannings"])) {
                this.plannings = [] as any;
                for (let item of _data["plannings"])
                    this.plannings!.push(CarPlanningEntity.fromJS(item));
            }
            else {
                this.plannings = <any>null;
            }
        }
    }

    static fromJS(data: any): CarEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CarEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["numberPlate"] = this.numberPlate !== undefined ? this.numberPlate : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["length"] = this.length !== undefined ? this.length : <any>null;
        data["maxLoad"] = this.maxLoad !== undefined ? this.maxLoad : <any>null;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
        if (Array.isArray(this.plannings)) {
            data["plannings"] = [];
            for (let item of this.plannings)
                data["plannings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICarEntity {
    id: number;
    name?: string | null;
    brand?: string | null;
    model?: string | null;
    numberPlate?: string | null;
    width: number;
    height: number;
    length: number;
    maxLoad: number;
    isEnabled: boolean;
    plannings?: CarPlanningEntity[] | null;
}

export class CarPlanningEntity implements ICarPlanningEntity {
    id!: number;
    carNr!: number;
    transportDateTime!: string;
    deliveredDateTime?: string | null;
    status!: DeliveryStatusEnums;
    driverAlias?: string | null;
    driverFk?: string | null;
    totalWeight!: number;
    car?: CarEntity | null;
    carFk?: number | null;
    orders?: OrderEntity[] | null;
    tempOrderIds?: string[] | null;
    selectedForPrint!: boolean;

    constructor(data?: ICarPlanningEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.carNr = _data["carNr"] !== undefined ? _data["carNr"] : <any>null;
            this.transportDateTime = _data["transportDateTime"] !== undefined ? _data["transportDateTime"] : <any>null;
            this.deliveredDateTime = _data["deliveredDateTime"] !== undefined ? _data["deliveredDateTime"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.driverAlias = _data["driverAlias"] !== undefined ? _data["driverAlias"] : <any>null;
            this.driverFk = _data["driverFk"] !== undefined ? _data["driverFk"] : <any>null;
            this.totalWeight = _data["totalWeight"] !== undefined ? _data["totalWeight"] : <any>null;
            this.car = _data["car"] ? CarEntity.fromJS(_data["car"]) : <any>null;
            this.carFk = _data["carFk"] !== undefined ? _data["carFk"] : <any>null;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderEntity.fromJS(item));
            }
            else {
                this.orders = <any>null;
            }
            if (Array.isArray(_data["tempOrderIds"])) {
                this.tempOrderIds = [] as any;
                for (let item of _data["tempOrderIds"])
                    this.tempOrderIds!.push(item);
            }
            else {
                this.tempOrderIds = <any>null;
            }
            this.selectedForPrint = _data["selectedForPrint"] !== undefined ? _data["selectedForPrint"] : <any>null;
        }
    }

    static fromJS(data: any): CarPlanningEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CarPlanningEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["carNr"] = this.carNr !== undefined ? this.carNr : <any>null;
        data["transportDateTime"] = this.transportDateTime !== undefined ? this.transportDateTime : <any>null;
        data["deliveredDateTime"] = this.deliveredDateTime !== undefined ? this.deliveredDateTime : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["driverAlias"] = this.driverAlias !== undefined ? this.driverAlias : <any>null;
        data["driverFk"] = this.driverFk !== undefined ? this.driverFk : <any>null;
        data["totalWeight"] = this.totalWeight !== undefined ? this.totalWeight : <any>null;
        data["car"] = this.car ? this.car.toJSON() : <any>null;
        data["carFk"] = this.carFk !== undefined ? this.carFk : <any>null;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.tempOrderIds)) {
            data["tempOrderIds"] = [];
            for (let item of this.tempOrderIds)
                data["tempOrderIds"].push(item);
        }
        data["selectedForPrint"] = this.selectedForPrint !== undefined ? this.selectedForPrint : <any>null;
        return data;
    }
}

export interface ICarPlanningEntity {
    id: number;
    carNr: number;
    transportDateTime: string;
    deliveredDateTime?: string | null;
    status: DeliveryStatusEnums;
    driverAlias?: string | null;
    driverFk?: string | null;
    totalWeight: number;
    car?: CarEntity | null;
    carFk?: number | null;
    orders?: OrderEntity[] | null;
    tempOrderIds?: string[] | null;
    selectedForPrint: boolean;
}

export enum DeliveryStatusEnums {
    NotDeliverd = 0,
    InTransit = 1,
    Delivered = 2,
}

export class OrderEntity implements IOrderEntity {
    id!: string;
    orderId?: string | null;
    customerMode!: UserModeEnum;
    notes?: string | null;
    deliveryMode!: DeliveryModeEnums;
    orderStatus!: OrderStatusEnums;
    paymentStatus!: PaymentStatusEnums;
    customerFK!: string;
    customer?: CustomerEntity | null;
    deliveryAddressFK?: string | null;
    sellerFK?: string | null;
    sellerAlias?: string | null;
    products?: OrderProductEntity[] | null;
    deliveryDate!: string;
    offerValidDate?: string | null;
    currency?: string | null;
    createdDate!: string;
    createdBy?: string | null;
    invoiceFk?: number | null;
    invoice?: InvoiceEntity | null;
    printedDeliveryNote!: boolean;
    printedPickList!: boolean;
    isLocked!: boolean;
    carPlanning?: CarPlanningEntity | null;
    carPlanningFk?: number | null;
    totalWeight!: number;
    isOutDated!: boolean;
    selectedForPrint!: boolean;

    constructor(data?: IOrderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : <any>null;
            this.customerMode = _data["customerMode"] !== undefined ? _data["customerMode"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.deliveryMode = _data["deliveryMode"] !== undefined ? _data["deliveryMode"] : <any>null;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : <any>null;
            this.paymentStatus = _data["paymentStatus"] !== undefined ? _data["paymentStatus"] : <any>null;
            this.customerFK = _data["customerFK"] !== undefined ? _data["customerFK"] : <any>null;
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>null;
            this.deliveryAddressFK = _data["deliveryAddressFK"] !== undefined ? _data["deliveryAddressFK"] : <any>null;
            this.sellerFK = _data["sellerFK"] !== undefined ? _data["sellerFK"] : <any>null;
            this.sellerAlias = _data["sellerAlias"] !== undefined ? _data["sellerAlias"] : <any>null;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(OrderProductEntity.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
            this.deliveryDate = _data["deliveryDate"] !== undefined ? _data["deliveryDate"] : <any>null;
            this.offerValidDate = _data["offerValidDate"] !== undefined ? _data["offerValidDate"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.createdDate = _data["createdDate"] !== undefined ? _data["createdDate"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.invoiceFk = _data["invoiceFk"] !== undefined ? _data["invoiceFk"] : <any>null;
            this.invoice = _data["invoice"] ? InvoiceEntity.fromJS(_data["invoice"]) : <any>null;
            this.printedDeliveryNote = _data["printedDeliveryNote"] !== undefined ? _data["printedDeliveryNote"] : <any>null;
            this.printedPickList = _data["printedPickList"] !== undefined ? _data["printedPickList"] : <any>null;
            this.isLocked = _data["isLocked"] !== undefined ? _data["isLocked"] : <any>null;
            this.carPlanning = _data["carPlanning"] ? CarPlanningEntity.fromJS(_data["carPlanning"]) : <any>null;
            this.carPlanningFk = _data["carPlanningFk"] !== undefined ? _data["carPlanningFk"] : <any>null;
            this.totalWeight = _data["totalWeight"] !== undefined ? _data["totalWeight"] : <any>null;
            this.isOutDated = _data["isOutDated"] !== undefined ? _data["isOutDated"] : <any>null;
            this.selectedForPrint = _data["selectedForPrint"] !== undefined ? _data["selectedForPrint"] : <any>null;
        }
    }

    static fromJS(data: any): OrderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["orderId"] = this.orderId !== undefined ? this.orderId : <any>null;
        data["customerMode"] = this.customerMode !== undefined ? this.customerMode : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["deliveryMode"] = this.deliveryMode !== undefined ? this.deliveryMode : <any>null;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : <any>null;
        data["paymentStatus"] = this.paymentStatus !== undefined ? this.paymentStatus : <any>null;
        data["customerFK"] = this.customerFK !== undefined ? this.customerFK : <any>null;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>null;
        data["deliveryAddressFK"] = this.deliveryAddressFK !== undefined ? this.deliveryAddressFK : <any>null;
        data["sellerFK"] = this.sellerFK !== undefined ? this.sellerFK : <any>null;
        data["sellerAlias"] = this.sellerAlias !== undefined ? this.sellerAlias : <any>null;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["deliveryDate"] = this.deliveryDate !== undefined ? this.deliveryDate : <any>null;
        data["offerValidDate"] = this.offerValidDate !== undefined ? this.offerValidDate : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["createdDate"] = this.createdDate !== undefined ? this.createdDate : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["invoiceFk"] = this.invoiceFk !== undefined ? this.invoiceFk : <any>null;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>null;
        data["printedDeliveryNote"] = this.printedDeliveryNote !== undefined ? this.printedDeliveryNote : <any>null;
        data["printedPickList"] = this.printedPickList !== undefined ? this.printedPickList : <any>null;
        data["isLocked"] = this.isLocked !== undefined ? this.isLocked : <any>null;
        data["carPlanning"] = this.carPlanning ? this.carPlanning.toJSON() : <any>null;
        data["carPlanningFk"] = this.carPlanningFk !== undefined ? this.carPlanningFk : <any>null;
        data["totalWeight"] = this.totalWeight !== undefined ? this.totalWeight : <any>null;
        data["isOutDated"] = this.isOutDated !== undefined ? this.isOutDated : <any>null;
        data["selectedForPrint"] = this.selectedForPrint !== undefined ? this.selectedForPrint : <any>null;
        return data;
    }
}

export interface IOrderEntity {
    id: string;
    orderId?: string | null;
    customerMode: UserModeEnum;
    notes?: string | null;
    deliveryMode: DeliveryModeEnums;
    orderStatus: OrderStatusEnums;
    paymentStatus: PaymentStatusEnums;
    customerFK: string;
    customer?: CustomerEntity | null;
    deliveryAddressFK?: string | null;
    sellerFK?: string | null;
    sellerAlias?: string | null;
    products?: OrderProductEntity[] | null;
    deliveryDate: string;
    offerValidDate?: string | null;
    currency?: string | null;
    createdDate: string;
    createdBy?: string | null;
    invoiceFk?: number | null;
    invoice?: InvoiceEntity | null;
    printedDeliveryNote: boolean;
    printedPickList: boolean;
    isLocked: boolean;
    carPlanning?: CarPlanningEntity | null;
    carPlanningFk?: number | null;
    totalWeight: number;
    isOutDated: boolean;
    selectedForPrint: boolean;
}

export enum UserModeEnum {
    Developer = 0,
    Employee = 1,
    Customer = 2,
}

export enum DeliveryModeEnums {
    Hamta = 0,
    Bilbud = 1,
    Kurrir = 2,
}

export enum OrderStatusEnums {
    Pending = 0,
    Transit = 3,
    Delivered = 4,
    Invoiced = 5,
    Offer = 6,
}

export enum PaymentStatusEnums {
    Pending = 0,
    Failed = 1,
    Refunded = 2,
    Paid = 3,
    Cancelled = 4,
}

export class CustomerEntity implements ICustomerEntity {
    id!: string;
    customerMode!: CustomerModeEnums;
    companyType!: CompanyEnums;
    customerNo?: string | null;
    companyNo?: string | null;
    companyName?: string | null;
    vatNo?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    address?: string | null;
    address2?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    webUrl?: string | null;
    notes?: string | null;
    isEndabled!: boolean;
    showPriceInShippingNote!: boolean;
    deliveryCondition?: string | null;
    deliveryMode!: DeliveryModeEnums;
    invoiceMode!: InvoiceEnums;
    invoiceEmail?: string | null;
    invoiceDueDays!: number;
    creditLimit!: number;
    currency?: string | null;
    priceTemplateFk?: string | null;
    priceTemplate?: PriceTemplateEntity | null;
    isUserCreated!: boolean;
    userId?: string | null;
    addresses?: DeliveryAddressEntity[] | null;
    orders?: OrderEntity[] | null;
    sellerId!: string;
    customer_Products?: Join_Customer_Product[] | null;

    constructor(data?: ICustomerEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.customerMode = _data["customerMode"] !== undefined ? _data["customerMode"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : <any>null;
            this.companyNo = _data["companyNo"] !== undefined ? _data["companyNo"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.vatNo = _data["vatNo"] !== undefined ? _data["vatNo"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.webUrl = _data["webUrl"] !== undefined ? _data["webUrl"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.isEndabled = _data["isEndabled"] !== undefined ? _data["isEndabled"] : <any>null;
            this.showPriceInShippingNote = _data["showPriceInShippingNote"] !== undefined ? _data["showPriceInShippingNote"] : <any>null;
            this.deliveryCondition = _data["deliveryCondition"] !== undefined ? _data["deliveryCondition"] : <any>null;
            this.deliveryMode = _data["deliveryMode"] !== undefined ? _data["deliveryMode"] : <any>null;
            this.invoiceMode = _data["invoiceMode"] !== undefined ? _data["invoiceMode"] : <any>null;
            this.invoiceEmail = _data["invoiceEmail"] !== undefined ? _data["invoiceEmail"] : <any>null;
            this.invoiceDueDays = _data["invoiceDueDays"] !== undefined ? _data["invoiceDueDays"] : <any>null;
            this.creditLimit = _data["creditLimit"] !== undefined ? _data["creditLimit"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.priceTemplateFk = _data["priceTemplateFk"] !== undefined ? _data["priceTemplateFk"] : <any>null;
            this.priceTemplate = _data["priceTemplate"] ? PriceTemplateEntity.fromJS(_data["priceTemplate"]) : <any>null;
            this.isUserCreated = _data["isUserCreated"] !== undefined ? _data["isUserCreated"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(DeliveryAddressEntity.fromJS(item));
            }
            else {
                this.addresses = <any>null;
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderEntity.fromJS(item));
            }
            else {
                this.orders = <any>null;
            }
            this.sellerId = _data["sellerId"] !== undefined ? _data["sellerId"] : <any>null;
            if (Array.isArray(_data["customer_Products"])) {
                this.customer_Products = [] as any;
                for (let item of _data["customer_Products"])
                    this.customer_Products!.push(Join_Customer_Product.fromJS(item));
            }
            else {
                this.customer_Products = <any>null;
            }
        }
    }

    static fromJS(data: any): CustomerEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["customerMode"] = this.customerMode !== undefined ? this.customerMode : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : <any>null;
        data["companyNo"] = this.companyNo !== undefined ? this.companyNo : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["vatNo"] = this.vatNo !== undefined ? this.vatNo : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["webUrl"] = this.webUrl !== undefined ? this.webUrl : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["isEndabled"] = this.isEndabled !== undefined ? this.isEndabled : <any>null;
        data["showPriceInShippingNote"] = this.showPriceInShippingNote !== undefined ? this.showPriceInShippingNote : <any>null;
        data["deliveryCondition"] = this.deliveryCondition !== undefined ? this.deliveryCondition : <any>null;
        data["deliveryMode"] = this.deliveryMode !== undefined ? this.deliveryMode : <any>null;
        data["invoiceMode"] = this.invoiceMode !== undefined ? this.invoiceMode : <any>null;
        data["invoiceEmail"] = this.invoiceEmail !== undefined ? this.invoiceEmail : <any>null;
        data["invoiceDueDays"] = this.invoiceDueDays !== undefined ? this.invoiceDueDays : <any>null;
        data["creditLimit"] = this.creditLimit !== undefined ? this.creditLimit : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["priceTemplateFk"] = this.priceTemplateFk !== undefined ? this.priceTemplateFk : <any>null;
        data["priceTemplate"] = this.priceTemplate ? this.priceTemplate.toJSON() : <any>null;
        data["isUserCreated"] = this.isUserCreated !== undefined ? this.isUserCreated : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["sellerId"] = this.sellerId !== undefined ? this.sellerId : <any>null;
        if (Array.isArray(this.customer_Products)) {
            data["customer_Products"] = [];
            for (let item of this.customer_Products)
                data["customer_Products"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerEntity {
    id: string;
    customerMode: CustomerModeEnums;
    companyType: CompanyEnums;
    customerNo?: string | null;
    companyNo?: string | null;
    companyName?: string | null;
    vatNo?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    address?: string | null;
    address2?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    webUrl?: string | null;
    notes?: string | null;
    isEndabled: boolean;
    showPriceInShippingNote: boolean;
    deliveryCondition?: string | null;
    deliveryMode: DeliveryModeEnums;
    invoiceMode: InvoiceEnums;
    invoiceEmail?: string | null;
    invoiceDueDays: number;
    creditLimit: number;
    currency?: string | null;
    priceTemplateFk?: string | null;
    priceTemplate?: PriceTemplateEntity | null;
    isUserCreated: boolean;
    userId?: string | null;
    addresses?: DeliveryAddressEntity[] | null;
    orders?: OrderEntity[] | null;
    sellerId: string;
    customer_Products?: Join_Customer_Product[] | null;
}

export enum CustomerModeEnums {
    Company = 0,
    Private = 1,
}

export enum CompanyEnums {
    EnskildNaringsverksamhet = 0,
    Aktiebolag = 1,
    Handelsbolag = 2,
    Kommanditbolag = 3,
    EkonomiskForening = 4,
    IdeellForening = 5,
    Samfallighetsforening = 6,
}

export enum InvoiceEnums {
    Email = 0,
    Print = 1,
}

export abstract class BaseEntity implements IBaseEntity {
    id!: string;
    entityState!: EntityState;

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.entityState = _data["entityState"] !== undefined ? _data["entityState"] : <any>null;
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["entityState"] = this.entityState !== undefined ? this.entityState : <any>null;
        return data;
    }
}

export interface IBaseEntity {
    id: string;
    entityState: EntityState;
}

export class PriceTemplateEntity extends BaseEntity implements IPriceTemplateEntity {
    name?: string | null;
    currencyISO?: string | null;
    priceTemplate_Products?: Join_PriceTemplate_Product[] | null;
    customers?: CustomerEntity[] | null;

    constructor(data?: IPriceTemplateEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.currencyISO = _data["currencyISO"] !== undefined ? _data["currencyISO"] : <any>null;
            if (Array.isArray(_data["priceTemplate_Products"])) {
                this.priceTemplate_Products = [] as any;
                for (let item of _data["priceTemplate_Products"])
                    this.priceTemplate_Products!.push(Join_PriceTemplate_Product.fromJS(item));
            }
            else {
                this.priceTemplate_Products = <any>null;
            }
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(CustomerEntity.fromJS(item));
            }
            else {
                this.customers = <any>null;
            }
        }
    }

    static fromJS(data: any): PriceTemplateEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PriceTemplateEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["currencyISO"] = this.currencyISO !== undefined ? this.currencyISO : <any>null;
        if (Array.isArray(this.priceTemplate_Products)) {
            data["priceTemplate_Products"] = [];
            for (let item of this.priceTemplate_Products)
                data["priceTemplate_Products"].push(item.toJSON());
        }
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPriceTemplateEntity extends IBaseEntity {
    name?: string | null;
    currencyISO?: string | null;
    priceTemplate_Products?: Join_PriceTemplate_Product[] | null;
    customers?: CustomerEntity[] | null;
}

export class Join_PriceTemplate_Product implements IJoin_PriceTemplate_Product {
    price!: number;
    productId!: string;
    product?: ProductEntity | null;
    priceTemplateId!: string;
    priceTemplate?: PriceTemplateEntity | null;

    constructor(data?: IJoin_PriceTemplate_Product) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.product = _data["product"] ? ProductEntity.fromJS(_data["product"]) : <any>null;
            this.priceTemplateId = _data["priceTemplateId"] !== undefined ? _data["priceTemplateId"] : <any>null;
            this.priceTemplate = _data["priceTemplate"] ? PriceTemplateEntity.fromJS(_data["priceTemplate"]) : <any>null;
        }
    }

    static fromJS(data: any): Join_PriceTemplate_Product {
        data = typeof data === 'object' ? data : {};
        let result = new Join_PriceTemplate_Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        data["priceTemplateId"] = this.priceTemplateId !== undefined ? this.priceTemplateId : <any>null;
        data["priceTemplate"] = this.priceTemplate ? this.priceTemplate.toJSON() : <any>null;
        return data;
    }
}

export interface IJoin_PriceTemplate_Product {
    price: number;
    productId: string;
    product?: ProductEntity | null;
    priceTemplateId: string;
    priceTemplate?: PriceTemplateEntity | null;
}

export class ProductEntity implements IProductEntity {
    id!: string;
    productNumber?: string | null;
    name?: string | null;
    designation?: string | null;
    description?: string | null;
    tags?: string[] | null;
    productType!: ProductTypeEnums;
    vat!: number;
    unit!: ProductUnitEnums;
    quantityInUnit!: number;
    barCode?: string | null;
    qrCode?: string | null;
    storageLocation?: string | null;
    priceIncoming!: number;
    priceBase!: number;
    pricePrivate!: number;
    packingSorting!: number;
    inStock!: number;
    weight!: number;
    averageWeight!: number;
    grossWeight!: number;
    cartonPieces!: number;
    cartonWeight!: number;
    minPointDays!: number;
    mainProviderFk!: string;
    status!: ProductStatusEnums;
    provider_Products?: Join_Provider_Product[] | null;
    priceTemplate_Products?: Join_PriceTemplate_Product[] | null;
    customer_Products?: Join_Customer_Product[] | null;
    productHistory?: ProductLogEntity[] | null;
    productPurchaseHistory?: PurchaseProductLogEntity[] | null;
    price!: number;
    orderList?: PurchaseProductEntity[] | null;

    constructor(data?: IProductEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.designation = _data["designation"] !== undefined ? _data["designation"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = <any>null;
            }
            this.productType = _data["productType"] !== undefined ? _data["productType"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.quantityInUnit = _data["quantityInUnit"] !== undefined ? _data["quantityInUnit"] : <any>null;
            this.barCode = _data["barCode"] !== undefined ? _data["barCode"] : <any>null;
            this.qrCode = _data["qrCode"] !== undefined ? _data["qrCode"] : <any>null;
            this.storageLocation = _data["storageLocation"] !== undefined ? _data["storageLocation"] : <any>null;
            this.priceIncoming = _data["priceIncoming"] !== undefined ? _data["priceIncoming"] : <any>null;
            this.priceBase = _data["priceBase"] !== undefined ? _data["priceBase"] : <any>null;
            this.pricePrivate = _data["pricePrivate"] !== undefined ? _data["pricePrivate"] : <any>null;
            this.packingSorting = _data["packingSorting"] !== undefined ? _data["packingSorting"] : <any>null;
            this.inStock = _data["inStock"] !== undefined ? _data["inStock"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
            this.averageWeight = _data["averageWeight"] !== undefined ? _data["averageWeight"] : <any>null;
            this.grossWeight = _data["grossWeight"] !== undefined ? _data["grossWeight"] : <any>null;
            this.cartonPieces = _data["cartonPieces"] !== undefined ? _data["cartonPieces"] : <any>null;
            this.cartonWeight = _data["cartonWeight"] !== undefined ? _data["cartonWeight"] : <any>null;
            this.minPointDays = _data["minPointDays"] !== undefined ? _data["minPointDays"] : <any>null;
            this.mainProviderFk = _data["mainProviderFk"] !== undefined ? _data["mainProviderFk"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["provider_Products"])) {
                this.provider_Products = [] as any;
                for (let item of _data["provider_Products"])
                    this.provider_Products!.push(Join_Provider_Product.fromJS(item));
            }
            else {
                this.provider_Products = <any>null;
            }
            if (Array.isArray(_data["priceTemplate_Products"])) {
                this.priceTemplate_Products = [] as any;
                for (let item of _data["priceTemplate_Products"])
                    this.priceTemplate_Products!.push(Join_PriceTemplate_Product.fromJS(item));
            }
            else {
                this.priceTemplate_Products = <any>null;
            }
            if (Array.isArray(_data["customer_Products"])) {
                this.customer_Products = [] as any;
                for (let item of _data["customer_Products"])
                    this.customer_Products!.push(Join_Customer_Product.fromJS(item));
            }
            else {
                this.customer_Products = <any>null;
            }
            if (Array.isArray(_data["productHistory"])) {
                this.productHistory = [] as any;
                for (let item of _data["productHistory"])
                    this.productHistory!.push(ProductLogEntity.fromJS(item));
            }
            else {
                this.productHistory = <any>null;
            }
            if (Array.isArray(_data["productPurchaseHistory"])) {
                this.productPurchaseHistory = [] as any;
                for (let item of _data["productPurchaseHistory"])
                    this.productPurchaseHistory!.push(PurchaseProductLogEntity.fromJS(item));
            }
            else {
                this.productPurchaseHistory = <any>null;
            }
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            if (Array.isArray(_data["orderList"])) {
                this.orderList = [] as any;
                for (let item of _data["orderList"])
                    this.orderList!.push(PurchaseProductEntity.fromJS(item));
            }
            else {
                this.orderList = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ProductEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["designation"] = this.designation !== undefined ? this.designation : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["productType"] = this.productType !== undefined ? this.productType : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["quantityInUnit"] = this.quantityInUnit !== undefined ? this.quantityInUnit : <any>null;
        data["barCode"] = this.barCode !== undefined ? this.barCode : <any>null;
        data["qrCode"] = this.qrCode !== undefined ? this.qrCode : <any>null;
        data["storageLocation"] = this.storageLocation !== undefined ? this.storageLocation : <any>null;
        data["priceIncoming"] = this.priceIncoming !== undefined ? this.priceIncoming : <any>null;
        data["priceBase"] = this.priceBase !== undefined ? this.priceBase : <any>null;
        data["pricePrivate"] = this.pricePrivate !== undefined ? this.pricePrivate : <any>null;
        data["packingSorting"] = this.packingSorting !== undefined ? this.packingSorting : <any>null;
        data["inStock"] = this.inStock !== undefined ? this.inStock : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["averageWeight"] = this.averageWeight !== undefined ? this.averageWeight : <any>null;
        data["grossWeight"] = this.grossWeight !== undefined ? this.grossWeight : <any>null;
        data["cartonPieces"] = this.cartonPieces !== undefined ? this.cartonPieces : <any>null;
        data["cartonWeight"] = this.cartonWeight !== undefined ? this.cartonWeight : <any>null;
        data["minPointDays"] = this.minPointDays !== undefined ? this.minPointDays : <any>null;
        data["mainProviderFk"] = this.mainProviderFk !== undefined ? this.mainProviderFk : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.provider_Products)) {
            data["provider_Products"] = [];
            for (let item of this.provider_Products)
                data["provider_Products"].push(item.toJSON());
        }
        if (Array.isArray(this.priceTemplate_Products)) {
            data["priceTemplate_Products"] = [];
            for (let item of this.priceTemplate_Products)
                data["priceTemplate_Products"].push(item.toJSON());
        }
        if (Array.isArray(this.customer_Products)) {
            data["customer_Products"] = [];
            for (let item of this.customer_Products)
                data["customer_Products"].push(item.toJSON());
        }
        if (Array.isArray(this.productHistory)) {
            data["productHistory"] = [];
            for (let item of this.productHistory)
                data["productHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.productPurchaseHistory)) {
            data["productPurchaseHistory"] = [];
            for (let item of this.productPurchaseHistory)
                data["productPurchaseHistory"].push(item.toJSON());
        }
        data["price"] = this.price !== undefined ? this.price : <any>null;
        if (Array.isArray(this.orderList)) {
            data["orderList"] = [];
            for (let item of this.orderList)
                data["orderList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductEntity {
    id: string;
    productNumber?: string | null;
    name?: string | null;
    designation?: string | null;
    description?: string | null;
    tags?: string[] | null;
    productType: ProductTypeEnums;
    vat: number;
    unit: ProductUnitEnums;
    quantityInUnit: number;
    barCode?: string | null;
    qrCode?: string | null;
    storageLocation?: string | null;
    priceIncoming: number;
    priceBase: number;
    pricePrivate: number;
    packingSorting: number;
    inStock: number;
    weight: number;
    averageWeight: number;
    grossWeight: number;
    cartonPieces: number;
    cartonWeight: number;
    minPointDays: number;
    mainProviderFk: string;
    status: ProductStatusEnums;
    provider_Products?: Join_Provider_Product[] | null;
    priceTemplate_Products?: Join_PriceTemplate_Product[] | null;
    customer_Products?: Join_Customer_Product[] | null;
    productHistory?: ProductLogEntity[] | null;
    productPurchaseHistory?: PurchaseProductLogEntity[] | null;
    price: number;
    orderList?: PurchaseProductEntity[] | null;
}

export enum ProductTypeEnums {
    Dry = 0,
    Frozen = 1,
    Fridge = 2,
}

export enum ProductUnitEnums {
    Piece = 0,
    Kilo = 1,
    Carton = 2,
}

export enum ProductStatusEnums {
    Active = 0,
    NotActive = 1,
}

export class Join_Provider_Product implements IJoin_Provider_Product {
    price!: number;
    providerId!: string;
    provider?: ProviderEntity | null;
    productId!: string;
    product?: ProductEntity | null;
    logs?: Provider_Product_LogEntity[] | null;

    constructor(data?: IJoin_Provider_Product) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.providerId = _data["providerId"] !== undefined ? _data["providerId"] : <any>null;
            this.provider = _data["provider"] ? ProviderEntity.fromJS(_data["provider"]) : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.product = _data["product"] ? ProductEntity.fromJS(_data["product"]) : <any>null;
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(Provider_Product_LogEntity.fromJS(item));
            }
            else {
                this.logs = <any>null;
            }
        }
    }

    static fromJS(data: any): Join_Provider_Product {
        data = typeof data === 'object' ? data : {};
        let result = new Join_Provider_Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["providerId"] = this.providerId !== undefined ? this.providerId : <any>null;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJoin_Provider_Product {
    price: number;
    providerId: string;
    provider?: ProviderEntity | null;
    productId: string;
    product?: ProductEntity | null;
    logs?: Provider_Product_LogEntity[] | null;
}

export class ProviderEntity implements IProviderEntity {
    id!: string;
    customerNo?: string | null;
    companyNo?: string | null;
    companyName?: string | null;
    vatNo?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    address?: string | null;
    address2?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    webUrl?: string | null;
    buyerId!: string;
    creditAmount!: number;
    currency?: string | null;
    bankIban?: string | null;
    bankBic?: string | null;
    bankSwift?: string | null;
    bankGiro?: string | null;
    plusGiro?: string | null;
    notes?: string | null;
    isEnabled!: boolean;
    purchases?: PurchaseEntity[] | null;
    provider_Products?: Join_Provider_Product[] | null;

    constructor(data?: IProviderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : <any>null;
            this.companyNo = _data["companyNo"] !== undefined ? _data["companyNo"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.vatNo = _data["vatNo"] !== undefined ? _data["vatNo"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.webUrl = _data["webUrl"] !== undefined ? _data["webUrl"] : <any>null;
            this.buyerId = _data["buyerId"] !== undefined ? _data["buyerId"] : <any>null;
            this.creditAmount = _data["creditAmount"] !== undefined ? _data["creditAmount"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.bankIban = _data["bankIban"] !== undefined ? _data["bankIban"] : <any>null;
            this.bankBic = _data["bankBic"] !== undefined ? _data["bankBic"] : <any>null;
            this.bankSwift = _data["bankSwift"] !== undefined ? _data["bankSwift"] : <any>null;
            this.bankGiro = _data["bankGiro"] !== undefined ? _data["bankGiro"] : <any>null;
            this.plusGiro = _data["plusGiro"] !== undefined ? _data["plusGiro"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : <any>null;
            if (Array.isArray(_data["purchases"])) {
                this.purchases = [] as any;
                for (let item of _data["purchases"])
                    this.purchases!.push(PurchaseEntity.fromJS(item));
            }
            else {
                this.purchases = <any>null;
            }
            if (Array.isArray(_data["provider_Products"])) {
                this.provider_Products = [] as any;
                for (let item of _data["provider_Products"])
                    this.provider_Products!.push(Join_Provider_Product.fromJS(item));
            }
            else {
                this.provider_Products = <any>null;
            }
        }
    }

    static fromJS(data: any): ProviderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : <any>null;
        data["companyNo"] = this.companyNo !== undefined ? this.companyNo : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["vatNo"] = this.vatNo !== undefined ? this.vatNo : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["webUrl"] = this.webUrl !== undefined ? this.webUrl : <any>null;
        data["buyerId"] = this.buyerId !== undefined ? this.buyerId : <any>null;
        data["creditAmount"] = this.creditAmount !== undefined ? this.creditAmount : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["bankIban"] = this.bankIban !== undefined ? this.bankIban : <any>null;
        data["bankBic"] = this.bankBic !== undefined ? this.bankBic : <any>null;
        data["bankSwift"] = this.bankSwift !== undefined ? this.bankSwift : <any>null;
        data["bankGiro"] = this.bankGiro !== undefined ? this.bankGiro : <any>null;
        data["plusGiro"] = this.plusGiro !== undefined ? this.plusGiro : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
        if (Array.isArray(this.purchases)) {
            data["purchases"] = [];
            for (let item of this.purchases)
                data["purchases"].push(item.toJSON());
        }
        if (Array.isArray(this.provider_Products)) {
            data["provider_Products"] = [];
            for (let item of this.provider_Products)
                data["provider_Products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProviderEntity {
    id: string;
    customerNo?: string | null;
    companyNo?: string | null;
    companyName?: string | null;
    vatNo?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    address?: string | null;
    address2?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    webUrl?: string | null;
    buyerId: string;
    creditAmount: number;
    currency?: string | null;
    bankIban?: string | null;
    bankBic?: string | null;
    bankSwift?: string | null;
    bankGiro?: string | null;
    plusGiro?: string | null;
    notes?: string | null;
    isEnabled: boolean;
    purchases?: PurchaseEntity[] | null;
    provider_Products?: Join_Provider_Product[] | null;
}

export class PurchaseEntity implements IPurchaseEntity {
    id!: string;
    purchaseId?: string | null;
    provider?: ProviderEntity | null;
    providerFk?: string | null;
    products?: PurchaseProductEntity[] | null;
    sellerFK?: string | null;
    sellerAlias?: string | null;
    created!: string;
    arrivalAt?: string | null;
    checkedInAt?: string | null;
    status!: PurchaseStatusEnums;
    isCompleted!: boolean;

    constructor(data?: IPurchaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.purchaseId = _data["purchaseId"] !== undefined ? _data["purchaseId"] : <any>null;
            this.provider = _data["provider"] ? ProviderEntity.fromJS(_data["provider"]) : <any>null;
            this.providerFk = _data["providerFk"] !== undefined ? _data["providerFk"] : <any>null;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(PurchaseProductEntity.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
            this.sellerFK = _data["sellerFK"] !== undefined ? _data["sellerFK"] : <any>null;
            this.sellerAlias = _data["sellerAlias"] !== undefined ? _data["sellerAlias"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.arrivalAt = _data["arrivalAt"] !== undefined ? _data["arrivalAt"] : <any>null;
            this.checkedInAt = _data["checkedInAt"] !== undefined ? _data["checkedInAt"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.isCompleted = _data["isCompleted"] !== undefined ? _data["isCompleted"] : <any>null;
        }
    }

    static fromJS(data: any): PurchaseEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["purchaseId"] = this.purchaseId !== undefined ? this.purchaseId : <any>null;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>null;
        data["providerFk"] = this.providerFk !== undefined ? this.providerFk : <any>null;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["sellerFK"] = this.sellerFK !== undefined ? this.sellerFK : <any>null;
        data["sellerAlias"] = this.sellerAlias !== undefined ? this.sellerAlias : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["arrivalAt"] = this.arrivalAt !== undefined ? this.arrivalAt : <any>null;
        data["checkedInAt"] = this.checkedInAt !== undefined ? this.checkedInAt : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["isCompleted"] = this.isCompleted !== undefined ? this.isCompleted : <any>null;
        return data;
    }
}

export interface IPurchaseEntity {
    id: string;
    purchaseId?: string | null;
    provider?: ProviderEntity | null;
    providerFk?: string | null;
    products?: PurchaseProductEntity[] | null;
    sellerFK?: string | null;
    sellerAlias?: string | null;
    created: string;
    arrivalAt?: string | null;
    checkedInAt?: string | null;
    status: PurchaseStatusEnums;
    isCompleted: boolean;
}

export class PurchaseProductEntity implements IPurchaseProductEntity {
    id!: string;
    name?: string | null;
    productNumber?: string | null;
    unit!: PurchaseUnitEnums;
    quantity!: number;
    purchase?: PurchaseEntity | null;
    purchaseFk!: string;
    productFK!: string;
    price!: number;
    vat!: number;

    constructor(data?: IPurchaseProductEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.purchase = _data["purchase"] ? PurchaseEntity.fromJS(_data["purchase"]) : <any>null;
            this.purchaseFk = _data["purchaseFk"] !== undefined ? _data["purchaseFk"] : <any>null;
            this.productFK = _data["productFK"] !== undefined ? _data["productFK"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
        }
    }

    static fromJS(data: any): PurchaseProductEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseProductEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["purchase"] = this.purchase ? this.purchase.toJSON() : <any>null;
        data["purchaseFk"] = this.purchaseFk !== undefined ? this.purchaseFk : <any>null;
        data["productFK"] = this.productFK !== undefined ? this.productFK : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        return data;
    }
}

export interface IPurchaseProductEntity {
    id: string;
    name?: string | null;
    productNumber?: string | null;
    unit: PurchaseUnitEnums;
    quantity: number;
    purchase?: PurchaseEntity | null;
    purchaseFk: string;
    productFK: string;
    price: number;
    vat: number;
}

export enum PurchaseUnitEnums {
    Piece = 0,
    Kg = 1,
}

export enum PurchaseStatusEnums {
    NotReady = 0,
    Ready = 1,
    Ordered = 2,
    Delivered = 3,
}

export class Provider_Product_LogEntity implements IProvider_Product_LogEntity {
    id!: number;
    price?: number | null;
    toPrice?: number | null;
    updated!: string;
    updatedById?: string | null;
    updatedByName?: string | null;
    provider_Product?: Join_Provider_Product | null;

    constructor(data?: IProvider_Product_LogEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.toPrice = _data["toPrice"] !== undefined ? _data["toPrice"] : <any>null;
            this.updated = _data["updated"] !== undefined ? _data["updated"] : <any>null;
            this.updatedById = _data["updatedById"] !== undefined ? _data["updatedById"] : <any>null;
            this.updatedByName = _data["updatedByName"] !== undefined ? _data["updatedByName"] : <any>null;
            this.provider_Product = _data["provider_Product"] ? Join_Provider_Product.fromJS(_data["provider_Product"]) : <any>null;
        }
    }

    static fromJS(data: any): Provider_Product_LogEntity {
        data = typeof data === 'object' ? data : {};
        let result = new Provider_Product_LogEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["toPrice"] = this.toPrice !== undefined ? this.toPrice : <any>null;
        data["updated"] = this.updated !== undefined ? this.updated : <any>null;
        data["updatedById"] = this.updatedById !== undefined ? this.updatedById : <any>null;
        data["updatedByName"] = this.updatedByName !== undefined ? this.updatedByName : <any>null;
        data["provider_Product"] = this.provider_Product ? this.provider_Product.toJSON() : <any>null;
        return data;
    }
}

export interface IProvider_Product_LogEntity {
    id: number;
    price?: number | null;
    toPrice?: number | null;
    updated: string;
    updatedById?: string | null;
    updatedByName?: string | null;
    provider_Product?: Join_Provider_Product | null;
}

export class Join_Customer_Product implements IJoin_Customer_Product {
    isFavorite!: boolean;
    customerId!: string;
    customer?: CustomerEntity | null;
    productId!: string;
    product?: ProductEntity | null;

    constructor(data?: IJoin_Customer_Product) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFavorite = _data["isFavorite"] !== undefined ? _data["isFavorite"] : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.product = _data["product"] ? ProductEntity.fromJS(_data["product"]) : <any>null;
        }
    }

    static fromJS(data: any): Join_Customer_Product {
        data = typeof data === 'object' ? data : {};
        let result = new Join_Customer_Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFavorite"] = this.isFavorite !== undefined ? this.isFavorite : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        return data;
    }
}

export interface IJoin_Customer_Product {
    isFavorite: boolean;
    customerId: string;
    customer?: CustomerEntity | null;
    productId: string;
    product?: ProductEntity | null;
}

export class ProductLogEntity implements IProductLogEntity {
    id!: number;
    productNumber?: string | null;
    name?: string | null;
    designation?: string | null;
    description?: string | null;
    productType?: ProductTypeEnums | null;
    vat?: number | null;
    unit?: ProductUnitEnums | null;
    quantityInUnit?: number | null;
    barCode?: string | null;
    qrCode?: string | null;
    storageLocation?: string | null;
    priceIncoming?: number | null;
    priceBase?: number | null;
    pricePrivate?: number | null;
    packingSorting?: number | null;
    inStock?: number | null;
    weight?: number | null;
    averageWeight?: number | null;
    grossWeight?: number | null;
    cartonPieces?: number | null;
    cartonWeight?: number | null;
    minPointDays?: number | null;
    mainProviderFk?: string | null;
    status?: ProductStatusEnums | null;
    toProductNumber?: string | null;
    toName?: string | null;
    toDesignation?: string | null;
    toDescription?: string | null;
    toProductType?: ProductTypeEnums | null;
    toVat?: number | null;
    toUnit?: ProductUnitEnums | null;
    toQuantityInUnit?: number | null;
    toBarCode?: string | null;
    toQrCode?: string | null;
    toStorageLocation?: string | null;
    toPriceIncoming?: number | null;
    toPriceBase?: number | null;
    toPricePrivate?: number | null;
    toPackingSorting?: number | null;
    toInStock?: number | null;
    toWeight?: number | null;
    toAverageWeight?: number | null;
    toGrossWeight?: number | null;
    toCartonPieces?: number | null;
    toCartonWeight?: number | null;
    toMinPointDays?: number | null;
    toMainProviderFk?: string | null;
    toStatus?: ProductStatusEnums | null;
    created!: string;
    createdByEmail?: string | null;
    productFk!: string;
    product?: ProductEntity | null;

    constructor(data?: IProductLogEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.designation = _data["designation"] !== undefined ? _data["designation"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.quantityInUnit = _data["quantityInUnit"] !== undefined ? _data["quantityInUnit"] : <any>null;
            this.barCode = _data["barCode"] !== undefined ? _data["barCode"] : <any>null;
            this.qrCode = _data["qrCode"] !== undefined ? _data["qrCode"] : <any>null;
            this.storageLocation = _data["storageLocation"] !== undefined ? _data["storageLocation"] : <any>null;
            this.priceIncoming = _data["priceIncoming"] !== undefined ? _data["priceIncoming"] : <any>null;
            this.priceBase = _data["priceBase"] !== undefined ? _data["priceBase"] : <any>null;
            this.pricePrivate = _data["pricePrivate"] !== undefined ? _data["pricePrivate"] : <any>null;
            this.packingSorting = _data["packingSorting"] !== undefined ? _data["packingSorting"] : <any>null;
            this.inStock = _data["inStock"] !== undefined ? _data["inStock"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
            this.averageWeight = _data["averageWeight"] !== undefined ? _data["averageWeight"] : <any>null;
            this.grossWeight = _data["grossWeight"] !== undefined ? _data["grossWeight"] : <any>null;
            this.cartonPieces = _data["cartonPieces"] !== undefined ? _data["cartonPieces"] : <any>null;
            this.cartonWeight = _data["cartonWeight"] !== undefined ? _data["cartonWeight"] : <any>null;
            this.minPointDays = _data["minPointDays"] !== undefined ? _data["minPointDays"] : <any>null;
            this.mainProviderFk = _data["mainProviderFk"] !== undefined ? _data["mainProviderFk"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.toProductNumber = _data["toProductNumber"] !== undefined ? _data["toProductNumber"] : <any>null;
            this.toName = _data["toName"] !== undefined ? _data["toName"] : <any>null;
            this.toDesignation = _data["toDesignation"] !== undefined ? _data["toDesignation"] : <any>null;
            this.toDescription = _data["toDescription"] !== undefined ? _data["toDescription"] : <any>null;
            this.toProductType = _data["toProductType"] !== undefined ? _data["toProductType"] : <any>null;
            this.toVat = _data["toVat"] !== undefined ? _data["toVat"] : <any>null;
            this.toUnit = _data["toUnit"] !== undefined ? _data["toUnit"] : <any>null;
            this.toQuantityInUnit = _data["toQuantityInUnit"] !== undefined ? _data["toQuantityInUnit"] : <any>null;
            this.toBarCode = _data["toBarCode"] !== undefined ? _data["toBarCode"] : <any>null;
            this.toQrCode = _data["toQrCode"] !== undefined ? _data["toQrCode"] : <any>null;
            this.toStorageLocation = _data["toStorageLocation"] !== undefined ? _data["toStorageLocation"] : <any>null;
            this.toPriceIncoming = _data["toPriceIncoming"] !== undefined ? _data["toPriceIncoming"] : <any>null;
            this.toPriceBase = _data["toPriceBase"] !== undefined ? _data["toPriceBase"] : <any>null;
            this.toPricePrivate = _data["toPricePrivate"] !== undefined ? _data["toPricePrivate"] : <any>null;
            this.toPackingSorting = _data["toPackingSorting"] !== undefined ? _data["toPackingSorting"] : <any>null;
            this.toInStock = _data["toInStock"] !== undefined ? _data["toInStock"] : <any>null;
            this.toWeight = _data["toWeight"] !== undefined ? _data["toWeight"] : <any>null;
            this.toAverageWeight = _data["toAverageWeight"] !== undefined ? _data["toAverageWeight"] : <any>null;
            this.toGrossWeight = _data["toGrossWeight"] !== undefined ? _data["toGrossWeight"] : <any>null;
            this.toCartonPieces = _data["toCartonPieces"] !== undefined ? _data["toCartonPieces"] : <any>null;
            this.toCartonWeight = _data["toCartonWeight"] !== undefined ? _data["toCartonWeight"] : <any>null;
            this.toMinPointDays = _data["toMinPointDays"] !== undefined ? _data["toMinPointDays"] : <any>null;
            this.toMainProviderFk = _data["toMainProviderFk"] !== undefined ? _data["toMainProviderFk"] : <any>null;
            this.toStatus = _data["toStatus"] !== undefined ? _data["toStatus"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.createdByEmail = _data["createdByEmail"] !== undefined ? _data["createdByEmail"] : <any>null;
            this.productFk = _data["productFk"] !== undefined ? _data["productFk"] : <any>null;
            this.product = _data["product"] ? ProductEntity.fromJS(_data["product"]) : <any>null;
        }
    }

    static fromJS(data: any): ProductLogEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLogEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["designation"] = this.designation !== undefined ? this.designation : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["productType"] = this.productType !== undefined ? this.productType : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["quantityInUnit"] = this.quantityInUnit !== undefined ? this.quantityInUnit : <any>null;
        data["barCode"] = this.barCode !== undefined ? this.barCode : <any>null;
        data["qrCode"] = this.qrCode !== undefined ? this.qrCode : <any>null;
        data["storageLocation"] = this.storageLocation !== undefined ? this.storageLocation : <any>null;
        data["priceIncoming"] = this.priceIncoming !== undefined ? this.priceIncoming : <any>null;
        data["priceBase"] = this.priceBase !== undefined ? this.priceBase : <any>null;
        data["pricePrivate"] = this.pricePrivate !== undefined ? this.pricePrivate : <any>null;
        data["packingSorting"] = this.packingSorting !== undefined ? this.packingSorting : <any>null;
        data["inStock"] = this.inStock !== undefined ? this.inStock : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["averageWeight"] = this.averageWeight !== undefined ? this.averageWeight : <any>null;
        data["grossWeight"] = this.grossWeight !== undefined ? this.grossWeight : <any>null;
        data["cartonPieces"] = this.cartonPieces !== undefined ? this.cartonPieces : <any>null;
        data["cartonWeight"] = this.cartonWeight !== undefined ? this.cartonWeight : <any>null;
        data["minPointDays"] = this.minPointDays !== undefined ? this.minPointDays : <any>null;
        data["mainProviderFk"] = this.mainProviderFk !== undefined ? this.mainProviderFk : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["toProductNumber"] = this.toProductNumber !== undefined ? this.toProductNumber : <any>null;
        data["toName"] = this.toName !== undefined ? this.toName : <any>null;
        data["toDesignation"] = this.toDesignation !== undefined ? this.toDesignation : <any>null;
        data["toDescription"] = this.toDescription !== undefined ? this.toDescription : <any>null;
        data["toProductType"] = this.toProductType !== undefined ? this.toProductType : <any>null;
        data["toVat"] = this.toVat !== undefined ? this.toVat : <any>null;
        data["toUnit"] = this.toUnit !== undefined ? this.toUnit : <any>null;
        data["toQuantityInUnit"] = this.toQuantityInUnit !== undefined ? this.toQuantityInUnit : <any>null;
        data["toBarCode"] = this.toBarCode !== undefined ? this.toBarCode : <any>null;
        data["toQrCode"] = this.toQrCode !== undefined ? this.toQrCode : <any>null;
        data["toStorageLocation"] = this.toStorageLocation !== undefined ? this.toStorageLocation : <any>null;
        data["toPriceIncoming"] = this.toPriceIncoming !== undefined ? this.toPriceIncoming : <any>null;
        data["toPriceBase"] = this.toPriceBase !== undefined ? this.toPriceBase : <any>null;
        data["toPricePrivate"] = this.toPricePrivate !== undefined ? this.toPricePrivate : <any>null;
        data["toPackingSorting"] = this.toPackingSorting !== undefined ? this.toPackingSorting : <any>null;
        data["toInStock"] = this.toInStock !== undefined ? this.toInStock : <any>null;
        data["toWeight"] = this.toWeight !== undefined ? this.toWeight : <any>null;
        data["toAverageWeight"] = this.toAverageWeight !== undefined ? this.toAverageWeight : <any>null;
        data["toGrossWeight"] = this.toGrossWeight !== undefined ? this.toGrossWeight : <any>null;
        data["toCartonPieces"] = this.toCartonPieces !== undefined ? this.toCartonPieces : <any>null;
        data["toCartonWeight"] = this.toCartonWeight !== undefined ? this.toCartonWeight : <any>null;
        data["toMinPointDays"] = this.toMinPointDays !== undefined ? this.toMinPointDays : <any>null;
        data["toMainProviderFk"] = this.toMainProviderFk !== undefined ? this.toMainProviderFk : <any>null;
        data["toStatus"] = this.toStatus !== undefined ? this.toStatus : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["createdByEmail"] = this.createdByEmail !== undefined ? this.createdByEmail : <any>null;
        data["productFk"] = this.productFk !== undefined ? this.productFk : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        return data;
    }
}

export interface IProductLogEntity {
    id: number;
    productNumber?: string | null;
    name?: string | null;
    designation?: string | null;
    description?: string | null;
    productType?: ProductTypeEnums | null;
    vat?: number | null;
    unit?: ProductUnitEnums | null;
    quantityInUnit?: number | null;
    barCode?: string | null;
    qrCode?: string | null;
    storageLocation?: string | null;
    priceIncoming?: number | null;
    priceBase?: number | null;
    pricePrivate?: number | null;
    packingSorting?: number | null;
    inStock?: number | null;
    weight?: number | null;
    averageWeight?: number | null;
    grossWeight?: number | null;
    cartonPieces?: number | null;
    cartonWeight?: number | null;
    minPointDays?: number | null;
    mainProviderFk?: string | null;
    status?: ProductStatusEnums | null;
    toProductNumber?: string | null;
    toName?: string | null;
    toDesignation?: string | null;
    toDescription?: string | null;
    toProductType?: ProductTypeEnums | null;
    toVat?: number | null;
    toUnit?: ProductUnitEnums | null;
    toQuantityInUnit?: number | null;
    toBarCode?: string | null;
    toQrCode?: string | null;
    toStorageLocation?: string | null;
    toPriceIncoming?: number | null;
    toPriceBase?: number | null;
    toPricePrivate?: number | null;
    toPackingSorting?: number | null;
    toInStock?: number | null;
    toWeight?: number | null;
    toAverageWeight?: number | null;
    toGrossWeight?: number | null;
    toCartonPieces?: number | null;
    toCartonWeight?: number | null;
    toMinPointDays?: number | null;
    toMainProviderFk?: string | null;
    toStatus?: ProductStatusEnums | null;
    created: string;
    createdByEmail?: string | null;
    productFk: string;
    product?: ProductEntity | null;
}

export class PurchaseProductLogEntity implements IPurchaseProductLogEntity {
    id!: number;
    name?: string | null;
    productNumber?: string | null;
    unit?: PurchaseUnitEnums | null;
    quantity?: number | null;
    price?: number | null;
    vat?: number | null;
    toName?: string | null;
    toProductNumber?: string | null;
    toUnit?: PurchaseUnitEnums | null;
    toQuantity?: number | null;
    toPrice?: number | null;
    toVat?: number | null;
    created!: string;
    createdByEmail?: string | null;
    purchaseFk!: string;
    productFk!: string;
    product?: ProductEntity | null;

    constructor(data?: IPurchaseProductLogEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.toName = _data["toName"] !== undefined ? _data["toName"] : <any>null;
            this.toProductNumber = _data["toProductNumber"] !== undefined ? _data["toProductNumber"] : <any>null;
            this.toUnit = _data["toUnit"] !== undefined ? _data["toUnit"] : <any>null;
            this.toQuantity = _data["toQuantity"] !== undefined ? _data["toQuantity"] : <any>null;
            this.toPrice = _data["toPrice"] !== undefined ? _data["toPrice"] : <any>null;
            this.toVat = _data["toVat"] !== undefined ? _data["toVat"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.createdByEmail = _data["createdByEmail"] !== undefined ? _data["createdByEmail"] : <any>null;
            this.purchaseFk = _data["purchaseFk"] !== undefined ? _data["purchaseFk"] : <any>null;
            this.productFk = _data["productFk"] !== undefined ? _data["productFk"] : <any>null;
            this.product = _data["product"] ? ProductEntity.fromJS(_data["product"]) : <any>null;
        }
    }

    static fromJS(data: any): PurchaseProductLogEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseProductLogEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["toName"] = this.toName !== undefined ? this.toName : <any>null;
        data["toProductNumber"] = this.toProductNumber !== undefined ? this.toProductNumber : <any>null;
        data["toUnit"] = this.toUnit !== undefined ? this.toUnit : <any>null;
        data["toQuantity"] = this.toQuantity !== undefined ? this.toQuantity : <any>null;
        data["toPrice"] = this.toPrice !== undefined ? this.toPrice : <any>null;
        data["toVat"] = this.toVat !== undefined ? this.toVat : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["createdByEmail"] = this.createdByEmail !== undefined ? this.createdByEmail : <any>null;
        data["purchaseFk"] = this.purchaseFk !== undefined ? this.purchaseFk : <any>null;
        data["productFk"] = this.productFk !== undefined ? this.productFk : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        return data;
    }
}

export interface IPurchaseProductLogEntity {
    id: number;
    name?: string | null;
    productNumber?: string | null;
    unit?: PurchaseUnitEnums | null;
    quantity?: number | null;
    price?: number | null;
    vat?: number | null;
    toName?: string | null;
    toProductNumber?: string | null;
    toUnit?: PurchaseUnitEnums | null;
    toQuantity?: number | null;
    toPrice?: number | null;
    toVat?: number | null;
    created: string;
    createdByEmail?: string | null;
    purchaseFk: string;
    productFk: string;
    product?: ProductEntity | null;
}

/** The state in which an entity is being tracked by a context. */
export enum EntityState {
    Detached = 0,
    Unchanged = 1,
    Deleted = 2,
    Modified = 3,
    Added = 4,
}

export class DeliveryAddressEntity implements IDeliveryAddressEntity {
    id!: string;
    name?: string | null;
    address?: string | null;
    address2?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    isDefault!: boolean;
    deliveryTimeFrom?: string | null;
    deliveryTimeTo?: string | null;
    customerFk!: string;
    customer?: CustomerEntity | null;

    constructor(data?: IDeliveryAddressEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : <any>null;
            this.deliveryTimeFrom = _data["deliveryTimeFrom"] !== undefined ? _data["deliveryTimeFrom"] : <any>null;
            this.deliveryTimeTo = _data["deliveryTimeTo"] !== undefined ? _data["deliveryTimeTo"] : <any>null;
            this.customerFk = _data["customerFk"] !== undefined ? _data["customerFk"] : <any>null;
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>null;
        }
    }

    static fromJS(data: any): DeliveryAddressEntity {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryAddressEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : <any>null;
        data["deliveryTimeFrom"] = this.deliveryTimeFrom !== undefined ? this.deliveryTimeFrom : <any>null;
        data["deliveryTimeTo"] = this.deliveryTimeTo !== undefined ? this.deliveryTimeTo : <any>null;
        data["customerFk"] = this.customerFk !== undefined ? this.customerFk : <any>null;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>null;
        return data;
    }
}

export interface IDeliveryAddressEntity {
    id: string;
    name?: string | null;
    address?: string | null;
    address2?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    isDefault: boolean;
    deliveryTimeFrom?: string | null;
    deliveryTimeTo?: string | null;
    customerFk: string;
    customer?: CustomerEntity | null;
}

export class OrderProductEntity implements IOrderProductEntity {
    id!: string;
    name?: string | null;
    pieces!: number;
    packingSorting!: number;
    storageLocation?: string | null;
    quantity!: number;
    productType!: ProductTypeEnums;
    unit!: UnitEnums;
    price!: number;
    vat!: number;
    orderFK!: string;
    order?: OrderEntity | null;
    productFK!: string;
    weight!: number;
    cartonWeight!: number;
    productNumber?: string | null;
    notes?: string | null;
    piecesPrevious!: number;
    inStock!: number;
    lastPrice!: number;
    incomingPrice!: number;

    constructor(data?: IOrderProductEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.pieces = _data["pieces"] !== undefined ? _data["pieces"] : <any>null;
            this.packingSorting = _data["packingSorting"] !== undefined ? _data["packingSorting"] : <any>null;
            this.storageLocation = _data["storageLocation"] !== undefined ? _data["storageLocation"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.orderFK = _data["orderFK"] !== undefined ? _data["orderFK"] : <any>null;
            this.order = _data["order"] ? OrderEntity.fromJS(_data["order"]) : <any>null;
            this.productFK = _data["productFK"] !== undefined ? _data["productFK"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
            this.cartonWeight = _data["cartonWeight"] !== undefined ? _data["cartonWeight"] : <any>null;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.piecesPrevious = _data["piecesPrevious"] !== undefined ? _data["piecesPrevious"] : <any>null;
            this.inStock = _data["inStock"] !== undefined ? _data["inStock"] : <any>null;
            this.lastPrice = _data["lastPrice"] !== undefined ? _data["lastPrice"] : <any>null;
            this.incomingPrice = _data["incomingPrice"] !== undefined ? _data["incomingPrice"] : <any>null;
        }
    }

    static fromJS(data: any): OrderProductEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["pieces"] = this.pieces !== undefined ? this.pieces : <any>null;
        data["packingSorting"] = this.packingSorting !== undefined ? this.packingSorting : <any>null;
        data["storageLocation"] = this.storageLocation !== undefined ? this.storageLocation : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["productType"] = this.productType !== undefined ? this.productType : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["orderFK"] = this.orderFK !== undefined ? this.orderFK : <any>null;
        data["order"] = this.order ? this.order.toJSON() : <any>null;
        data["productFK"] = this.productFK !== undefined ? this.productFK : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["cartonWeight"] = this.cartonWeight !== undefined ? this.cartonWeight : <any>null;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["piecesPrevious"] = this.piecesPrevious !== undefined ? this.piecesPrevious : <any>null;
        data["inStock"] = this.inStock !== undefined ? this.inStock : <any>null;
        data["lastPrice"] = this.lastPrice !== undefined ? this.lastPrice : <any>null;
        data["incomingPrice"] = this.incomingPrice !== undefined ? this.incomingPrice : <any>null;
        return data;
    }
}

export interface IOrderProductEntity {
    id: string;
    name?: string | null;
    pieces: number;
    packingSorting: number;
    storageLocation?: string | null;
    quantity: number;
    productType: ProductTypeEnums;
    unit: UnitEnums;
    price: number;
    vat: number;
    orderFK: string;
    order?: OrderEntity | null;
    productFK: string;
    weight: number;
    cartonWeight: number;
    productNumber?: string | null;
    notes?: string | null;
    piecesPrevious: number;
    inStock: number;
    lastPrice: number;
    incomingPrice: number;
}

export enum UnitEnums {
    Piece = 0,
    Kilo = 1,
    Carton = 2,
}

export class InvoiceEntity implements IInvoiceEntity {
    id!: number;
    invoiceNumber?: string | null;
    customerNo?: string | null;
    customerName?: string | null;
    contactPerson?: string | null;
    sellerName?: string | null;
    amount!: number;
    amountIncVAT!: number;
    currency?: string | null;
    invoiceAddress?: string | null;
    invoiceAddress2?: string | null;
    invoiceZipCode?: string | null;
    invoiceCity?: string | null;
    invoiceCountry?: string | null;
    invoicePhone?: string | null;
    invoiceEmail?: string | null;
    deliveryAddress?: string | null;
    deliveryAddress2?: string | null;
    deliveryZipCode?: string | null;
    deliveryCity?: string | null;
    deliveryCountry?: string | null;
    deliveryPhone?: string | null;
    deliveryEmail?: string | null;
    status!: InvoiceStatusEnums;
    isLocked!: boolean;
    created!: string;
    paymentDue!: string;
    paymentDueDays!: number;
    interestRateDelay!: number;
    customerFK?: string | null;
    products?: InvoiceProductEntity[] | null;
    orders?: OrderEntity[] | null;
    vats?: VatViewModel[] | null;
    roundingPrice!: number;

    constructor(data?: IInvoiceEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : <any>null;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : <any>null;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : <any>null;
            this.contactPerson = _data["contactPerson"] !== undefined ? _data["contactPerson"] : <any>null;
            this.sellerName = _data["sellerName"] !== undefined ? _data["sellerName"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.amountIncVAT = _data["amountIncVAT"] !== undefined ? _data["amountIncVAT"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.invoiceAddress = _data["invoiceAddress"] !== undefined ? _data["invoiceAddress"] : <any>null;
            this.invoiceAddress2 = _data["invoiceAddress2"] !== undefined ? _data["invoiceAddress2"] : <any>null;
            this.invoiceZipCode = _data["invoiceZipCode"] !== undefined ? _data["invoiceZipCode"] : <any>null;
            this.invoiceCity = _data["invoiceCity"] !== undefined ? _data["invoiceCity"] : <any>null;
            this.invoiceCountry = _data["invoiceCountry"] !== undefined ? _data["invoiceCountry"] : <any>null;
            this.invoicePhone = _data["invoicePhone"] !== undefined ? _data["invoicePhone"] : <any>null;
            this.invoiceEmail = _data["invoiceEmail"] !== undefined ? _data["invoiceEmail"] : <any>null;
            this.deliveryAddress = _data["deliveryAddress"] !== undefined ? _data["deliveryAddress"] : <any>null;
            this.deliveryAddress2 = _data["deliveryAddress2"] !== undefined ? _data["deliveryAddress2"] : <any>null;
            this.deliveryZipCode = _data["deliveryZipCode"] !== undefined ? _data["deliveryZipCode"] : <any>null;
            this.deliveryCity = _data["deliveryCity"] !== undefined ? _data["deliveryCity"] : <any>null;
            this.deliveryCountry = _data["deliveryCountry"] !== undefined ? _data["deliveryCountry"] : <any>null;
            this.deliveryPhone = _data["deliveryPhone"] !== undefined ? _data["deliveryPhone"] : <any>null;
            this.deliveryEmail = _data["deliveryEmail"] !== undefined ? _data["deliveryEmail"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.isLocked = _data["isLocked"] !== undefined ? _data["isLocked"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.paymentDue = _data["paymentDue"] !== undefined ? _data["paymentDue"] : <any>null;
            this.paymentDueDays = _data["paymentDueDays"] !== undefined ? _data["paymentDueDays"] : <any>null;
            this.interestRateDelay = _data["interestRateDelay"] !== undefined ? _data["interestRateDelay"] : <any>null;
            this.customerFK = _data["customerFK"] !== undefined ? _data["customerFK"] : <any>null;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(InvoiceProductEntity.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderEntity.fromJS(item));
            }
            else {
                this.orders = <any>null;
            }
            if (Array.isArray(_data["vats"])) {
                this.vats = [] as any;
                for (let item of _data["vats"])
                    this.vats!.push(VatViewModel.fromJS(item));
            }
            else {
                this.vats = <any>null;
            }
            this.roundingPrice = _data["roundingPrice"] !== undefined ? _data["roundingPrice"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceEntity {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : <any>null;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : <any>null;
        data["customerName"] = this.customerName !== undefined ? this.customerName : <any>null;
        data["contactPerson"] = this.contactPerson !== undefined ? this.contactPerson : <any>null;
        data["sellerName"] = this.sellerName !== undefined ? this.sellerName : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["amountIncVAT"] = this.amountIncVAT !== undefined ? this.amountIncVAT : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["invoiceAddress"] = this.invoiceAddress !== undefined ? this.invoiceAddress : <any>null;
        data["invoiceAddress2"] = this.invoiceAddress2 !== undefined ? this.invoiceAddress2 : <any>null;
        data["invoiceZipCode"] = this.invoiceZipCode !== undefined ? this.invoiceZipCode : <any>null;
        data["invoiceCity"] = this.invoiceCity !== undefined ? this.invoiceCity : <any>null;
        data["invoiceCountry"] = this.invoiceCountry !== undefined ? this.invoiceCountry : <any>null;
        data["invoicePhone"] = this.invoicePhone !== undefined ? this.invoicePhone : <any>null;
        data["invoiceEmail"] = this.invoiceEmail !== undefined ? this.invoiceEmail : <any>null;
        data["deliveryAddress"] = this.deliveryAddress !== undefined ? this.deliveryAddress : <any>null;
        data["deliveryAddress2"] = this.deliveryAddress2 !== undefined ? this.deliveryAddress2 : <any>null;
        data["deliveryZipCode"] = this.deliveryZipCode !== undefined ? this.deliveryZipCode : <any>null;
        data["deliveryCity"] = this.deliveryCity !== undefined ? this.deliveryCity : <any>null;
        data["deliveryCountry"] = this.deliveryCountry !== undefined ? this.deliveryCountry : <any>null;
        data["deliveryPhone"] = this.deliveryPhone !== undefined ? this.deliveryPhone : <any>null;
        data["deliveryEmail"] = this.deliveryEmail !== undefined ? this.deliveryEmail : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["isLocked"] = this.isLocked !== undefined ? this.isLocked : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["paymentDue"] = this.paymentDue !== undefined ? this.paymentDue : <any>null;
        data["paymentDueDays"] = this.paymentDueDays !== undefined ? this.paymentDueDays : <any>null;
        data["interestRateDelay"] = this.interestRateDelay !== undefined ? this.interestRateDelay : <any>null;
        data["customerFK"] = this.customerFK !== undefined ? this.customerFK : <any>null;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.vats)) {
            data["vats"] = [];
            for (let item of this.vats)
                data["vats"].push(item.toJSON());
        }
        data["roundingPrice"] = this.roundingPrice !== undefined ? this.roundingPrice : <any>null;
        return data;
    }
}

export interface IInvoiceEntity {
    id: number;
    invoiceNumber?: string | null;
    customerNo?: string | null;
    customerName?: string | null;
    contactPerson?: string | null;
    sellerName?: string | null;
    amount: number;
    amountIncVAT: number;
    currency?: string | null;
    invoiceAddress?: string | null;
    invoiceAddress2?: string | null;
    invoiceZipCode?: string | null;
    invoiceCity?: string | null;
    invoiceCountry?: string | null;
    invoicePhone?: string | null;
    invoiceEmail?: string | null;
    deliveryAddress?: string | null;
    deliveryAddress2?: string | null;
    deliveryZipCode?: string | null;
    deliveryCity?: string | null;
    deliveryCountry?: string | null;
    deliveryPhone?: string | null;
    deliveryEmail?: string | null;
    status: InvoiceStatusEnums;
    isLocked: boolean;
    created: string;
    paymentDue: string;
    paymentDueDays: number;
    interestRateDelay: number;
    customerFK?: string | null;
    products?: InvoiceProductEntity[] | null;
    orders?: OrderEntity[] | null;
    vats?: VatViewModel[] | null;
    roundingPrice: number;
}

export enum InvoiceStatusEnums {
    Created = 0,
    Sent = 1,
    Paid = 2,
    Rejected = 3,
    Canceled = 4,
}

export class InvoiceProductEntity implements IInvoiceProductEntity {
    id!: number;
    partnumber?: string | null;
    name?: string | null;
    productType!: ProductTypeEnums;
    quantity!: number;
    unit!: UnitEnums;
    price!: number;
    weightInKg!: number;
    vat!: number;
    invoice?: InvoiceEntity | null;
    invoiceFk!: number;

    constructor(data?: IInvoiceProductEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.partnumber = _data["partnumber"] !== undefined ? _data["partnumber"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.weightInKg = _data["weightInKg"] !== undefined ? _data["weightInKg"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.invoice = _data["invoice"] ? InvoiceEntity.fromJS(_data["invoice"]) : <any>null;
            this.invoiceFk = _data["invoiceFk"] !== undefined ? _data["invoiceFk"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceProductEntity {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceProductEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["partnumber"] = this.partnumber !== undefined ? this.partnumber : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["productType"] = this.productType !== undefined ? this.productType : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["weightInKg"] = this.weightInKg !== undefined ? this.weightInKg : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>null;
        data["invoiceFk"] = this.invoiceFk !== undefined ? this.invoiceFk : <any>null;
        return data;
    }
}

export interface IInvoiceProductEntity {
    id: number;
    partnumber?: string | null;
    name?: string | null;
    productType: ProductTypeEnums;
    quantity: number;
    unit: UnitEnums;
    price: number;
    weightInKg: number;
    vat: number;
    invoice?: InvoiceEntity | null;
    invoiceFk: number;
}

export class VatViewModel implements IVatViewModel {
    vat!: number;
    total!: number;

    constructor(data?: IVatViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): VatViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VatViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        return data;
    }
}

export interface IVatViewModel {
    vat: number;
    total: number;
}

export class ApiResultOfCarEntity implements IApiResultOfCarEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: CarEntity | null;

    constructor(data?: IApiResultOfCarEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? CarEntity.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfCarEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfCarEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfCarEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: CarEntity | null;
}

export class ApiResultOfListOfCarPlanningEntity implements IApiResultOfListOfCarPlanningEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: CarPlanningEntity[] | null;

    constructor(data?: IApiResultOfListOfCarPlanningEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CarPlanningEntity.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): ApiResultOfListOfCarPlanningEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfListOfCarPlanningEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApiResultOfListOfCarPlanningEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: CarPlanningEntity[] | null;
}

export class CarTableListViewModel implements ICarTableListViewModel {
    id!: number;
    carNr!: number;
    totalWeight!: number;
    orders?: OrderEntity[] | null;
    tempOrderIds?: string[] | null;
    carFk!: number;
    driverAlias?: string | null;
    driverFk!: string;
    transportDateTime!: string;
    deliveredDateTime?: string | null;
    selectedForPrint!: boolean;

    constructor(data?: ICarTableListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.carNr = _data["carNr"] !== undefined ? _data["carNr"] : <any>null;
            this.totalWeight = _data["totalWeight"] !== undefined ? _data["totalWeight"] : <any>null;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderEntity.fromJS(item));
            }
            else {
                this.orders = <any>null;
            }
            if (Array.isArray(_data["tempOrderIds"])) {
                this.tempOrderIds = [] as any;
                for (let item of _data["tempOrderIds"])
                    this.tempOrderIds!.push(item);
            }
            else {
                this.tempOrderIds = <any>null;
            }
            this.carFk = _data["carFk"] !== undefined ? _data["carFk"] : <any>null;
            this.driverAlias = _data["driverAlias"] !== undefined ? _data["driverAlias"] : <any>null;
            this.driverFk = _data["driverFk"] !== undefined ? _data["driverFk"] : <any>null;
            this.transportDateTime = _data["transportDateTime"] !== undefined ? _data["transportDateTime"] : <any>null;
            this.deliveredDateTime = _data["deliveredDateTime"] !== undefined ? _data["deliveredDateTime"] : <any>null;
            this.selectedForPrint = _data["selectedForPrint"] !== undefined ? _data["selectedForPrint"] : <any>null;
        }
    }

    static fromJS(data: any): CarTableListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarTableListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["carNr"] = this.carNr !== undefined ? this.carNr : <any>null;
        data["totalWeight"] = this.totalWeight !== undefined ? this.totalWeight : <any>null;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.tempOrderIds)) {
            data["tempOrderIds"] = [];
            for (let item of this.tempOrderIds)
                data["tempOrderIds"].push(item);
        }
        data["carFk"] = this.carFk !== undefined ? this.carFk : <any>null;
        data["driverAlias"] = this.driverAlias !== undefined ? this.driverAlias : <any>null;
        data["driverFk"] = this.driverFk !== undefined ? this.driverFk : <any>null;
        data["transportDateTime"] = this.transportDateTime !== undefined ? this.transportDateTime : <any>null;
        data["deliveredDateTime"] = this.deliveredDateTime !== undefined ? this.deliveredDateTime : <any>null;
        data["selectedForPrint"] = this.selectedForPrint !== undefined ? this.selectedForPrint : <any>null;
        return data;
    }
}

export interface ICarTableListViewModel {
    id: number;
    carNr: number;
    totalWeight: number;
    orders?: OrderEntity[] | null;
    tempOrderIds?: string[] | null;
    carFk: number;
    driverAlias?: string | null;
    driverFk: string;
    transportDateTime: string;
    deliveredDateTime?: string | null;
    selectedForPrint: boolean;
}

export class ApiResultOfCarPlanningEntity implements IApiResultOfCarPlanningEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: CarPlanningEntity | null;

    constructor(data?: IApiResultOfCarPlanningEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? CarPlanningEntity.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfCarPlanningEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfCarPlanningEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfCarPlanningEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: CarPlanningEntity | null;
}

export class CompanyDetails implements ICompanyDetails {
    id!: number;
    vatNr?: string | null;
    companyNr?: string | null;
    companyName?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email1?: string | null;
    email2?: string | null;
    website?: string | null;
    bankGiro?: string | null;
    plusGiro?: string | null;
    iban?: string | null;
    invoiceMessage?: string | null;
    interestRateDelay!: number;

    constructor(data?: ICompanyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.vatNr = _data["vatNr"] !== undefined ? _data["vatNr"] : <any>null;
            this.companyNr = _data["companyNr"] !== undefined ? _data["companyNr"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : <any>null;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email1 = _data["email1"] !== undefined ? _data["email1"] : <any>null;
            this.email2 = _data["email2"] !== undefined ? _data["email2"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
            this.bankGiro = _data["bankGiro"] !== undefined ? _data["bankGiro"] : <any>null;
            this.plusGiro = _data["plusGiro"] !== undefined ? _data["plusGiro"] : <any>null;
            this.iban = _data["iban"] !== undefined ? _data["iban"] : <any>null;
            this.invoiceMessage = _data["invoiceMessage"] !== undefined ? _data["invoiceMessage"] : <any>null;
            this.interestRateDelay = _data["interestRateDelay"] !== undefined ? _data["interestRateDelay"] : <any>null;
        }
    }

    static fromJS(data: any): CompanyDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["vatNr"] = this.vatNr !== undefined ? this.vatNr : <any>null;
        data["companyNr"] = this.companyNr !== undefined ? this.companyNr : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : <any>null;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email1"] = this.email1 !== undefined ? this.email1 : <any>null;
        data["email2"] = this.email2 !== undefined ? this.email2 : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        data["bankGiro"] = this.bankGiro !== undefined ? this.bankGiro : <any>null;
        data["plusGiro"] = this.plusGiro !== undefined ? this.plusGiro : <any>null;
        data["iban"] = this.iban !== undefined ? this.iban : <any>null;
        data["invoiceMessage"] = this.invoiceMessage !== undefined ? this.invoiceMessage : <any>null;
        data["interestRateDelay"] = this.interestRateDelay !== undefined ? this.interestRateDelay : <any>null;
        return data;
    }
}

export interface ICompanyDetails {
    id: number;
    vatNr?: string | null;
    companyNr?: string | null;
    companyName?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email1?: string | null;
    email2?: string | null;
    website?: string | null;
    bankGiro?: string | null;
    plusGiro?: string | null;
    iban?: string | null;
    invoiceMessage?: string | null;
    interestRateDelay: number;
}

export class ApiResultOfCompanyDetails implements IApiResultOfCompanyDetails {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: CompanyDetails | null;

    constructor(data?: IApiResultOfCompanyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? CompanyDetails.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfCompanyDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfCompanyDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfCompanyDetails {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: CompanyDetails | null;
}

export class ApiResultOfCustomerEntity implements IApiResultOfCustomerEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: CustomerEntity | null;

    constructor(data?: IApiResultOfCustomerEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? CustomerEntity.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfCustomerEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfCustomerEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfCustomerEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: CustomerEntity | null;
}

export class EmployeeEntity extends BaseEntity implements IEmployeeEntity {
    employeeDate!: string;
    title!: GenderEnums;
    firstName?: string | null;
    lastName?: string | null;
    address?: string | null;
    city?: string | null;
    zipCode?: string | null;
    country?: string | null;
    email?: string | null;
    phone?: string | null;
    alias?: string | null;
    isEnabled!: boolean;
    roles?: string[] | null;
    password?: string | null;

    constructor(data?: IEmployeeEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employeeDate = _data["employeeDate"] !== undefined ? _data["employeeDate"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): EmployeeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeDate"] = this.employeeDate !== undefined ? this.employeeDate : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["password"] = this.password !== undefined ? this.password : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEmployeeEntity extends IBaseEntity {
    employeeDate: string;
    title: GenderEnums;
    firstName?: string | null;
    lastName?: string | null;
    address?: string | null;
    city?: string | null;
    zipCode?: string | null;
    country?: string | null;
    email?: string | null;
    phone?: string | null;
    alias?: string | null;
    isEnabled: boolean;
    roles?: string[] | null;
    password?: string | null;
}

export enum GenderEnums {
    None = 0,
    Mr = 1,
    Mrs = 2,
}

export class ApiResultOfEmployeeEntity implements IApiResultOfEmployeeEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: EmployeeEntity | null;

    constructor(data?: IApiResultOfEmployeeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? EmployeeEntity.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfEmployeeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfEmployeeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfEmployeeEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: EmployeeEntity | null;
}

export class CustomerSubset implements ICustomerSubset {
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    customerNumber?: string | null;
    email?: string | null;
    name?: string | null;
    organisationNumber?: string | null;
    phone?: string | null;
    zipCode?: string | null;
    url?: string | null;

    constructor(data?: ICustomerSubset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.organisationNumber = _data["organisationNumber"] !== undefined ? _data["organisationNumber"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.url = _data["@url"] !== undefined ? _data["@url"] : <any>null;
        }
    }

    static fromJS(data: any): CustomerSubset {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSubset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["organisationNumber"] = this.organisationNumber !== undefined ? this.organisationNumber : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["@url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface ICustomerSubset {
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    customerNumber?: string | null;
    email?: string | null;
    name?: string | null;
    organisationNumber?: string | null;
    phone?: string | null;
    zipCode?: string | null;
    url?: string | null;
}

export class BaseSearch implements IBaseSearch {
    lastModified?: string | null;
    financialYearID?: number | null;
    financialYearDate?: string | null;
    fromDate?: string | null;
    toDate?: string | null;
    sortOrder?: Order | null;
    limit?: number | null;
    page?: number | null;
    offset?: number | null;
    customParameters?: { [key: string]: string; } | null;

    constructor(data?: IBaseSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastModified = _data["lastModified"] !== undefined ? _data["lastModified"] : <any>null;
            this.financialYearID = _data["financialYearID"] !== undefined ? _data["financialYearID"] : <any>null;
            this.financialYearDate = _data["financialYearDate"] !== undefined ? _data["financialYearDate"] : <any>null;
            this.fromDate = _data["fromDate"] !== undefined ? _data["fromDate"] : <any>null;
            this.toDate = _data["toDate"] !== undefined ? _data["toDate"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            if (_data["customParameters"]) {
                this.customParameters = {} as any;
                for (let key in _data["customParameters"]) {
                    if (_data["customParameters"].hasOwnProperty(key))
                        (<any>this.customParameters)![key] = _data["customParameters"][key] !== undefined ? _data["customParameters"][key] : <any>null;
                }
            }
            else {
                this.customParameters = <any>null;
            }
        }
    }

    static fromJS(data: any): BaseSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BaseSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastModified"] = this.lastModified !== undefined ? this.lastModified : <any>null;
        data["financialYearID"] = this.financialYearID !== undefined ? this.financialYearID : <any>null;
        data["financialYearDate"] = this.financialYearDate !== undefined ? this.financialYearDate : <any>null;
        data["fromDate"] = this.fromDate !== undefined ? this.fromDate : <any>null;
        data["toDate"] = this.toDate !== undefined ? this.toDate : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        if (this.customParameters) {
            data["customParameters"] = {};
            for (let key in this.customParameters) {
                if (this.customParameters.hasOwnProperty(key))
                    (<any>data["customParameters"])[key] = this.customParameters[key] !== undefined ? this.customParameters[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IBaseSearch {
    lastModified?: string | null;
    financialYearID?: number | null;
    financialYearDate?: string | null;
    fromDate?: string | null;
    toDate?: string | null;
    sortOrder?: Order | null;
    limit?: number | null;
    page?: number | null;
    offset?: number | null;
    customParameters?: { [key: string]: string; } | null;
}

export class CustomerSearch extends BaseSearch implements ICustomerSearch {
    sortBy?: Customer | null;
    filterBy?: Customer2 | null;
    city?: string | null;
    customerNumber?: string | null;
    email?: string | null;
    gln?: string | null;
    glnDelivery?: string | null;
    name?: string | null;
    organisationNumber?: string | null;
    phone1?: string | null;
    zipCode?: string | null;

    constructor(data?: ICustomerSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : <any>null;
            this.filterBy = _data["filterBy"] !== undefined ? _data["filterBy"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.gln = _data["gln"] !== undefined ? _data["gln"] : <any>null;
            this.glnDelivery = _data["glnDelivery"] !== undefined ? _data["glnDelivery"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.organisationNumber = _data["organisationNumber"] !== undefined ? _data["organisationNumber"] : <any>null;
            this.phone1 = _data["phone1"] !== undefined ? _data["phone1"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
        }
    }

    static fromJS(data: any): CustomerSearch {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : <any>null;
        data["filterBy"] = this.filterBy !== undefined ? this.filterBy : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["gln"] = this.gln !== undefined ? this.gln : <any>null;
        data["glnDelivery"] = this.glnDelivery !== undefined ? this.glnDelivery : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["organisationNumber"] = this.organisationNumber !== undefined ? this.organisationNumber : <any>null;
        data["phone1"] = this.phone1 !== undefined ? this.phone1 : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerSearch extends IBaseSearch {
    sortBy?: Customer | null;
    filterBy?: Customer2 | null;
    city?: string | null;
    customerNumber?: string | null;
    email?: string | null;
    gln?: string | null;
    glnDelivery?: string | null;
    name?: string | null;
    organisationNumber?: string | null;
    phone1?: string | null;
    zipCode?: string | null;
}

export enum Customer {
    CustomerNumber = 0,
    Name = 1,
}

export enum Customer2 {
    Active = 0,
    Inactive = 1,
}

export enum Order {
    Ascending = 0,
    Descending = 1,
}

export class EntityCollectionOfCustomerSubset implements IEntityCollectionOfCustomerSubset {
    entities!: CustomerSubset[];
    metaInformation?: MetaInformation | null;
    totalResources!: number;
    totalPages!: number;
    currentPage!: number;

    constructor(data?: IEntityCollectionOfCustomerSubset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(CustomerSubset.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
            this.metaInformation = _data["metaInformation"] ? MetaInformation.fromJS(_data["metaInformation"]) : <any>null;
            this.totalResources = _data["totalResources"] !== undefined ? _data["totalResources"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : <any>null;
        }
    }

    static fromJS(data: any): EntityCollectionOfCustomerSubset {
        data = typeof data === 'object' ? data : {};
        let result = new EntityCollectionOfCustomerSubset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        data["metaInformation"] = this.metaInformation ? this.metaInformation.toJSON() : <any>null;
        data["totalResources"] = this.totalResources !== undefined ? this.totalResources : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : <any>null;
        return data;
    }
}

export interface IEntityCollectionOfCustomerSubset {
    entities: CustomerSubset[];
    metaInformation?: MetaInformation | null;
    totalResources: number;
    totalPages: number;
    currentPage: number;
}

export class MetaInformation implements IMetaInformation {
    totalResources!: number;
    totalPages!: number;
    currentPage!: number;

    constructor(data?: IMetaInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResources = _data["@TotalResources"] !== undefined ? _data["@TotalResources"] : <any>null;
            this.totalPages = _data["@TotalPages"] !== undefined ? _data["@TotalPages"] : <any>null;
            this.currentPage = _data["@CurrentPage"] !== undefined ? _data["@CurrentPage"] : <any>null;
        }
    }

    static fromJS(data: any): MetaInformation {
        data = typeof data === 'object' ? data : {};
        let result = new MetaInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@TotalResources"] = this.totalResources !== undefined ? this.totalResources : <any>null;
        data["@TotalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["@CurrentPage"] = this.currentPage !== undefined ? this.currentPage : <any>null;
        return data;
    }
}

export interface IMetaInformation {
    totalResources: number;
    totalPages: number;
    currentPage: number;
}

export class Customer3 implements ICustomer3 {
    url?: string | null;
    active?: boolean | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    country?: string | null;
    comments?: string | null;
    currency?: string | null;
    costCenter?: string | null;
    countryCode?: string | null;
    customerNumber?: string | null;
    defaultDeliveryTypes?: DefaultDeliveryTypes | null;
    defaultTemplates?: DefaultTemplates | null;
    deliveryAddress1?: string | null;
    deliveryAddress2?: string | null;
    deliveryCity?: string | null;
    deliveryCountry?: string | null;
    deliveryCountryCode?: string | null;
    deliveryFax?: string | null;
    deliveryName?: string | null;
    deliveryPhone1?: string | null;
    deliveryPhone2?: string | null;
    deliveryZipCode?: string | null;
    email?: string | null;
    emailInvoice?: string | null;
    emailInvoiceBCC?: string | null;
    emailInvoiceCC?: string | null;
    emailOffer?: string | null;
    emailOfferBCC?: string | null;
    emailOfferCC?: string | null;
    emailOrder?: string | null;
    emailOrderBCC?: string | null;
    emailOrderCC?: string | null;
    externalReference?: string | null;
    fax?: string | null;
    gln?: string | null;
    glnDelivery?: string | null;
    invoiceAdministrationFee?: number | null;
    invoiceDiscount?: number | null;
    invoiceFreight?: number | null;
    invoiceRemark?: string | null;
    name?: string | null;
    organisationNumber?: string | null;
    ourReference?: string | null;
    phone1?: string | null;
    phone2?: string | null;
    priceList?: string | null;
    project?: string | null;
    salesAccount?: string | null;
    showPriceVATIncluded?: boolean | null;
    termsOfDelivery?: string | null;
    termsOfPayment?: string | null;
    type?: CustomerType | null;
    vatNumber?: string | null;
    vatType?: CustomerVATType | null;
    visitingAddress?: string | null;
    visitingCity?: string | null;
    visitingCountry?: string | null;
    visitingCountryCode?: string | null;
    visitingZipCode?: string | null;
    www?: string | null;
    wayOfDelivery?: string | null;
    yourReference?: string | null;
    zipCode?: string | null;

    constructor(data?: ICustomer3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["@url"] !== undefined ? _data["@url"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.costCenter = _data["costCenter"] !== undefined ? _data["costCenter"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : <any>null;
            this.defaultDeliveryTypes = _data["defaultDeliveryTypes"] ? DefaultDeliveryTypes.fromJS(_data["defaultDeliveryTypes"]) : <any>null;
            this.defaultTemplates = _data["defaultTemplates"] ? DefaultTemplates.fromJS(_data["defaultTemplates"]) : <any>null;
            this.deliveryAddress1 = _data["deliveryAddress1"] !== undefined ? _data["deliveryAddress1"] : <any>null;
            this.deliveryAddress2 = _data["deliveryAddress2"] !== undefined ? _data["deliveryAddress2"] : <any>null;
            this.deliveryCity = _data["deliveryCity"] !== undefined ? _data["deliveryCity"] : <any>null;
            this.deliveryCountry = _data["deliveryCountry"] !== undefined ? _data["deliveryCountry"] : <any>null;
            this.deliveryCountryCode = _data["deliveryCountryCode"] !== undefined ? _data["deliveryCountryCode"] : <any>null;
            this.deliveryFax = _data["deliveryFax"] !== undefined ? _data["deliveryFax"] : <any>null;
            this.deliveryName = _data["deliveryName"] !== undefined ? _data["deliveryName"] : <any>null;
            this.deliveryPhone1 = _data["deliveryPhone1"] !== undefined ? _data["deliveryPhone1"] : <any>null;
            this.deliveryPhone2 = _data["deliveryPhone2"] !== undefined ? _data["deliveryPhone2"] : <any>null;
            this.deliveryZipCode = _data["deliveryZipCode"] !== undefined ? _data["deliveryZipCode"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.emailInvoice = _data["emailInvoice"] !== undefined ? _data["emailInvoice"] : <any>null;
            this.emailInvoiceBCC = _data["emailInvoiceBCC"] !== undefined ? _data["emailInvoiceBCC"] : <any>null;
            this.emailInvoiceCC = _data["emailInvoiceCC"] !== undefined ? _data["emailInvoiceCC"] : <any>null;
            this.emailOffer = _data["emailOffer"] !== undefined ? _data["emailOffer"] : <any>null;
            this.emailOfferBCC = _data["emailOfferBCC"] !== undefined ? _data["emailOfferBCC"] : <any>null;
            this.emailOfferCC = _data["emailOfferCC"] !== undefined ? _data["emailOfferCC"] : <any>null;
            this.emailOrder = _data["emailOrder"] !== undefined ? _data["emailOrder"] : <any>null;
            this.emailOrderBCC = _data["emailOrderBCC"] !== undefined ? _data["emailOrderBCC"] : <any>null;
            this.emailOrderCC = _data["emailOrderCC"] !== undefined ? _data["emailOrderCC"] : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.gln = _data["gln"] !== undefined ? _data["gln"] : <any>null;
            this.glnDelivery = _data["glnDelivery"] !== undefined ? _data["glnDelivery"] : <any>null;
            this.invoiceAdministrationFee = _data["invoiceAdministrationFee"] !== undefined ? _data["invoiceAdministrationFee"] : <any>null;
            this.invoiceDiscount = _data["invoiceDiscount"] !== undefined ? _data["invoiceDiscount"] : <any>null;
            this.invoiceFreight = _data["invoiceFreight"] !== undefined ? _data["invoiceFreight"] : <any>null;
            this.invoiceRemark = _data["invoiceRemark"] !== undefined ? _data["invoiceRemark"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.organisationNumber = _data["organisationNumber"] !== undefined ? _data["organisationNumber"] : <any>null;
            this.ourReference = _data["ourReference"] !== undefined ? _data["ourReference"] : <any>null;
            this.phone1 = _data["phone1"] !== undefined ? _data["phone1"] : <any>null;
            this.phone2 = _data["phone2"] !== undefined ? _data["phone2"] : <any>null;
            this.priceList = _data["priceList"] !== undefined ? _data["priceList"] : <any>null;
            this.project = _data["project"] !== undefined ? _data["project"] : <any>null;
            this.salesAccount = _data["salesAccount"] !== undefined ? _data["salesAccount"] : <any>null;
            this.showPriceVATIncluded = _data["showPriceVATIncluded"] !== undefined ? _data["showPriceVATIncluded"] : <any>null;
            this.termsOfDelivery = _data["termsOfDelivery"] !== undefined ? _data["termsOfDelivery"] : <any>null;
            this.termsOfPayment = _data["termsOfPayment"] !== undefined ? _data["termsOfPayment"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.vatNumber = _data["vatNumber"] !== undefined ? _data["vatNumber"] : <any>null;
            this.vatType = _data["vatType"] !== undefined ? _data["vatType"] : <any>null;
            this.visitingAddress = _data["visitingAddress"] !== undefined ? _data["visitingAddress"] : <any>null;
            this.visitingCity = _data["visitingCity"] !== undefined ? _data["visitingCity"] : <any>null;
            this.visitingCountry = _data["visitingCountry"] !== undefined ? _data["visitingCountry"] : <any>null;
            this.visitingCountryCode = _data["visitingCountryCode"] !== undefined ? _data["visitingCountryCode"] : <any>null;
            this.visitingZipCode = _data["visitingZipCode"] !== undefined ? _data["visitingZipCode"] : <any>null;
            this.www = _data["www"] !== undefined ? _data["www"] : <any>null;
            this.wayOfDelivery = _data["wayOfDelivery"] !== undefined ? _data["wayOfDelivery"] : <any>null;
            this.yourReference = _data["yourReference"] !== undefined ? _data["yourReference"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
        }
    }

    static fromJS(data: any): Customer3 {
        data = typeof data === 'object' ? data : {};
        let result = new Customer3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@url"] = this.url !== undefined ? this.url : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["costCenter"] = this.costCenter !== undefined ? this.costCenter : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : <any>null;
        data["defaultDeliveryTypes"] = this.defaultDeliveryTypes ? this.defaultDeliveryTypes.toJSON() : <any>null;
        data["defaultTemplates"] = this.defaultTemplates ? this.defaultTemplates.toJSON() : <any>null;
        data["deliveryAddress1"] = this.deliveryAddress1 !== undefined ? this.deliveryAddress1 : <any>null;
        data["deliveryAddress2"] = this.deliveryAddress2 !== undefined ? this.deliveryAddress2 : <any>null;
        data["deliveryCity"] = this.deliveryCity !== undefined ? this.deliveryCity : <any>null;
        data["deliveryCountry"] = this.deliveryCountry !== undefined ? this.deliveryCountry : <any>null;
        data["deliveryCountryCode"] = this.deliveryCountryCode !== undefined ? this.deliveryCountryCode : <any>null;
        data["deliveryFax"] = this.deliveryFax !== undefined ? this.deliveryFax : <any>null;
        data["deliveryName"] = this.deliveryName !== undefined ? this.deliveryName : <any>null;
        data["deliveryPhone1"] = this.deliveryPhone1 !== undefined ? this.deliveryPhone1 : <any>null;
        data["deliveryPhone2"] = this.deliveryPhone2 !== undefined ? this.deliveryPhone2 : <any>null;
        data["deliveryZipCode"] = this.deliveryZipCode !== undefined ? this.deliveryZipCode : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["emailInvoice"] = this.emailInvoice !== undefined ? this.emailInvoice : <any>null;
        data["emailInvoiceBCC"] = this.emailInvoiceBCC !== undefined ? this.emailInvoiceBCC : <any>null;
        data["emailInvoiceCC"] = this.emailInvoiceCC !== undefined ? this.emailInvoiceCC : <any>null;
        data["emailOffer"] = this.emailOffer !== undefined ? this.emailOffer : <any>null;
        data["emailOfferBCC"] = this.emailOfferBCC !== undefined ? this.emailOfferBCC : <any>null;
        data["emailOfferCC"] = this.emailOfferCC !== undefined ? this.emailOfferCC : <any>null;
        data["emailOrder"] = this.emailOrder !== undefined ? this.emailOrder : <any>null;
        data["emailOrderBCC"] = this.emailOrderBCC !== undefined ? this.emailOrderBCC : <any>null;
        data["emailOrderCC"] = this.emailOrderCC !== undefined ? this.emailOrderCC : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["gln"] = this.gln !== undefined ? this.gln : <any>null;
        data["glnDelivery"] = this.glnDelivery !== undefined ? this.glnDelivery : <any>null;
        data["invoiceAdministrationFee"] = this.invoiceAdministrationFee !== undefined ? this.invoiceAdministrationFee : <any>null;
        data["invoiceDiscount"] = this.invoiceDiscount !== undefined ? this.invoiceDiscount : <any>null;
        data["invoiceFreight"] = this.invoiceFreight !== undefined ? this.invoiceFreight : <any>null;
        data["invoiceRemark"] = this.invoiceRemark !== undefined ? this.invoiceRemark : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["organisationNumber"] = this.organisationNumber !== undefined ? this.organisationNumber : <any>null;
        data["ourReference"] = this.ourReference !== undefined ? this.ourReference : <any>null;
        data["phone1"] = this.phone1 !== undefined ? this.phone1 : <any>null;
        data["phone2"] = this.phone2 !== undefined ? this.phone2 : <any>null;
        data["priceList"] = this.priceList !== undefined ? this.priceList : <any>null;
        data["project"] = this.project !== undefined ? this.project : <any>null;
        data["salesAccount"] = this.salesAccount !== undefined ? this.salesAccount : <any>null;
        data["showPriceVATIncluded"] = this.showPriceVATIncluded !== undefined ? this.showPriceVATIncluded : <any>null;
        data["termsOfDelivery"] = this.termsOfDelivery !== undefined ? this.termsOfDelivery : <any>null;
        data["termsOfPayment"] = this.termsOfPayment !== undefined ? this.termsOfPayment : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["vatNumber"] = this.vatNumber !== undefined ? this.vatNumber : <any>null;
        data["vatType"] = this.vatType !== undefined ? this.vatType : <any>null;
        data["visitingAddress"] = this.visitingAddress !== undefined ? this.visitingAddress : <any>null;
        data["visitingCity"] = this.visitingCity !== undefined ? this.visitingCity : <any>null;
        data["visitingCountry"] = this.visitingCountry !== undefined ? this.visitingCountry : <any>null;
        data["visitingCountryCode"] = this.visitingCountryCode !== undefined ? this.visitingCountryCode : <any>null;
        data["visitingZipCode"] = this.visitingZipCode !== undefined ? this.visitingZipCode : <any>null;
        data["www"] = this.www !== undefined ? this.www : <any>null;
        data["wayOfDelivery"] = this.wayOfDelivery !== undefined ? this.wayOfDelivery : <any>null;
        data["yourReference"] = this.yourReference !== undefined ? this.yourReference : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        return data;
    }
}

export interface ICustomer3 {
    url?: string | null;
    active?: boolean | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    country?: string | null;
    comments?: string | null;
    currency?: string | null;
    costCenter?: string | null;
    countryCode?: string | null;
    customerNumber?: string | null;
    defaultDeliveryTypes?: DefaultDeliveryTypes | null;
    defaultTemplates?: DefaultTemplates | null;
    deliveryAddress1?: string | null;
    deliveryAddress2?: string | null;
    deliveryCity?: string | null;
    deliveryCountry?: string | null;
    deliveryCountryCode?: string | null;
    deliveryFax?: string | null;
    deliveryName?: string | null;
    deliveryPhone1?: string | null;
    deliveryPhone2?: string | null;
    deliveryZipCode?: string | null;
    email?: string | null;
    emailInvoice?: string | null;
    emailInvoiceBCC?: string | null;
    emailInvoiceCC?: string | null;
    emailOffer?: string | null;
    emailOfferBCC?: string | null;
    emailOfferCC?: string | null;
    emailOrder?: string | null;
    emailOrderBCC?: string | null;
    emailOrderCC?: string | null;
    externalReference?: string | null;
    fax?: string | null;
    gln?: string | null;
    glnDelivery?: string | null;
    invoiceAdministrationFee?: number | null;
    invoiceDiscount?: number | null;
    invoiceFreight?: number | null;
    invoiceRemark?: string | null;
    name?: string | null;
    organisationNumber?: string | null;
    ourReference?: string | null;
    phone1?: string | null;
    phone2?: string | null;
    priceList?: string | null;
    project?: string | null;
    salesAccount?: string | null;
    showPriceVATIncluded?: boolean | null;
    termsOfDelivery?: string | null;
    termsOfPayment?: string | null;
    type?: CustomerType | null;
    vatNumber?: string | null;
    vatType?: CustomerVATType | null;
    visitingAddress?: string | null;
    visitingCity?: string | null;
    visitingCountry?: string | null;
    visitingCountryCode?: string | null;
    visitingZipCode?: string | null;
    www?: string | null;
    wayOfDelivery?: string | null;
    yourReference?: string | null;
    zipCode?: string | null;
}

export class DefaultDeliveryTypes implements IDefaultDeliveryTypes {
    invoice?: DefaultDeliveryType | null;
    order?: DefaultDeliveryType | null;
    offer?: DefaultDeliveryType | null;

    constructor(data?: IDefaultDeliveryTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoice = _data["invoice"] !== undefined ? _data["invoice"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.offer = _data["offer"] !== undefined ? _data["offer"] : <any>null;
        }
    }

    static fromJS(data: any): DefaultDeliveryTypes {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultDeliveryTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoice"] = this.invoice !== undefined ? this.invoice : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["offer"] = this.offer !== undefined ? this.offer : <any>null;
        return data;
    }
}

export interface IDefaultDeliveryTypes {
    invoice?: DefaultDeliveryType | null;
    order?: DefaultDeliveryType | null;
    offer?: DefaultDeliveryType | null;
}

export enum DefaultDeliveryType {
    Print = 0,
    Email = 1,
    PrintService = 2,
    ElectronicInvoice = 3,
}

export class DefaultTemplates implements IDefaultTemplates {
    order?: string | null;
    offer?: string | null;
    invoice?: string | null;
    cashInvoice?: string | null;

    constructor(data?: IDefaultTemplates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.offer = _data["offer"] !== undefined ? _data["offer"] : <any>null;
            this.invoice = _data["invoice"] !== undefined ? _data["invoice"] : <any>null;
            this.cashInvoice = _data["cashInvoice"] !== undefined ? _data["cashInvoice"] : <any>null;
        }
    }

    static fromJS(data: any): DefaultTemplates {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultTemplates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["offer"] = this.offer !== undefined ? this.offer : <any>null;
        data["invoice"] = this.invoice !== undefined ? this.invoice : <any>null;
        data["cashInvoice"] = this.cashInvoice !== undefined ? this.cashInvoice : <any>null;
        return data;
    }
}

export interface IDefaultTemplates {
    order?: string | null;
    offer?: string | null;
    invoice?: string | null;
    cashInvoice?: string | null;
}

export enum CustomerType {
    Private = 0,
    Company = 1,
    Undefined = 2,
}

export enum CustomerVATType {
    SE_VAT = 0,
    SE_ReversedVAT = 1,
    EU_ReversedVAT = 2,
    EU_VAT = 3,
    Export = 4,
}

export class Invoice implements IInvoice {
    url?: string | null;
    urlTaxReductionList?: string | null;
    accountingMethod?: AccountingMethod | null;
    administrationFee?: number | null;
    administrationFeeVAT?: number | null;
    address1?: string | null;
    address2?: string | null;
    balance?: number | null;
    basisTaxReduction?: number | null;
    booked?: boolean | null;
    cancelled?: boolean | null;
    credit?: boolean | null;
    creditInvoiceReference?: number | null;
    city?: string | null;
    comments?: string | null;
    contractReference?: number | null;
    contributionPercent?: number | null;
    contributionValue?: number | null;
    country?: string | null;
    costCenter?: string | null;
    currency?: string | null;
    currencyRate?: number | null;
    currencyUnit?: number | null;
    customerName?: string | null;
    customerNumber?: string | null;
    deliveryAddress1?: string | null;
    deliveryAddress2?: string | null;
    deliveryCity?: string | null;
    deliveryCountry?: string | null;
    deliveryDate?: string | null;
    deliveryName?: string | null;
    deliveryZipCode?: string | null;
    documentNumber?: number | null;
    dueDate?: string | null;
    ediInformation?: EDIInformation | null;
    emailInformation?: EmailInformation | null;
    euQuarterlyReport?: boolean | null;
    externalInvoiceReference1?: string | null;
    externalInvoiceReference2?: string | null;
    finalPayDate?: string | null;
    freight?: number | null;
    freightVAT?: number | null;
    gross?: number | null;
    houseWork?: boolean | null;
    invoiceDate?: string | null;
    invoicePeriodStart?: string | null;
    invoicePeriodEnd?: string | null;
    invoiceReference?: number | null;
    invoiceRows?: InvoiceRow[] | null;
    invoiceType?: InvoiceType | null;
    labels?: LabelReference[] | null;
    language?: Language | null;
    lastRemindDate?: string | null;
    net?: number | null;
    notCompleted?: boolean | null;
    noxFinans?: boolean | null;
    ocr?: string | null;
    offerReference?: number | null;
    orderReference?: number | null;
    organisationNumber?: string | null;
    ourReference?: string | null;
    paymentWay?: PaymentWay | null;
    phone1?: string | null;
    phone2?: string | null;
    priceList?: string | null;
    printTemplate?: string | null;
    project?: string | null;
    remarks?: string | null;
    reminders?: number | null;
    roundOff?: number | null;
    sent?: boolean | null;
    taxReduction?: number | null;
    taxReductionType?: TaxReductionType | null;
    termsOfDelivery?: string | null;
    termsOfPayment?: string | null;
    total?: number | null;
    totalVAT?: number | null;
    vatIncluded?: boolean | null;
    voucherNumber?: number | null;
    voucherSeries?: string | null;
    voucherYear?: number | null;
    wayOfDelivery?: string | null;
    yourOrderNumber?: string | null;
    yourReference?: string | null;
    zipCode?: string | null;
    warehouseReady?: boolean | null;
    outboundDate?: string | null;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["@url"] !== undefined ? _data["@url"] : <any>null;
            this.urlTaxReductionList = _data["@urlTaxReductionList"] !== undefined ? _data["@urlTaxReductionList"] : <any>null;
            this.accountingMethod = _data["accountingMethod"] !== undefined ? _data["accountingMethod"] : <any>null;
            this.administrationFee = _data["administrationFee"] !== undefined ? _data["administrationFee"] : <any>null;
            this.administrationFeeVAT = _data["administrationFeeVAT"] !== undefined ? _data["administrationFeeVAT"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.balance = _data["balance"] !== undefined ? _data["balance"] : <any>null;
            this.basisTaxReduction = _data["basisTaxReduction"] !== undefined ? _data["basisTaxReduction"] : <any>null;
            this.booked = _data["booked"] !== undefined ? _data["booked"] : <any>null;
            this.cancelled = _data["cancelled"] !== undefined ? _data["cancelled"] : <any>null;
            this.credit = _data["credit"] !== undefined ? _data["credit"] : <any>null;
            this.creditInvoiceReference = _data["creditInvoiceReference"] !== undefined ? _data["creditInvoiceReference"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            this.contractReference = _data["contractReference"] !== undefined ? _data["contractReference"] : <any>null;
            this.contributionPercent = _data["contributionPercent"] !== undefined ? _data["contributionPercent"] : <any>null;
            this.contributionValue = _data["contributionValue"] !== undefined ? _data["contributionValue"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.costCenter = _data["costCenter"] !== undefined ? _data["costCenter"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.currencyRate = _data["currencyRate"] !== undefined ? _data["currencyRate"] : <any>null;
            this.currencyUnit = _data["currencyUnit"] !== undefined ? _data["currencyUnit"] : <any>null;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : <any>null;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : <any>null;
            this.deliveryAddress1 = _data["deliveryAddress1"] !== undefined ? _data["deliveryAddress1"] : <any>null;
            this.deliveryAddress2 = _data["deliveryAddress2"] !== undefined ? _data["deliveryAddress2"] : <any>null;
            this.deliveryCity = _data["deliveryCity"] !== undefined ? _data["deliveryCity"] : <any>null;
            this.deliveryCountry = _data["deliveryCountry"] !== undefined ? _data["deliveryCountry"] : <any>null;
            this.deliveryDate = _data["deliveryDate"] !== undefined ? _data["deliveryDate"] : <any>null;
            this.deliveryName = _data["deliveryName"] !== undefined ? _data["deliveryName"] : <any>null;
            this.deliveryZipCode = _data["deliveryZipCode"] !== undefined ? _data["deliveryZipCode"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.dueDate = _data["dueDate"] !== undefined ? _data["dueDate"] : <any>null;
            this.ediInformation = _data["ediInformation"] ? EDIInformation.fromJS(_data["ediInformation"]) : <any>null;
            this.emailInformation = _data["emailInformation"] ? EmailInformation.fromJS(_data["emailInformation"]) : <any>null;
            this.euQuarterlyReport = _data["euQuarterlyReport"] !== undefined ? _data["euQuarterlyReport"] : <any>null;
            this.externalInvoiceReference1 = _data["externalInvoiceReference1"] !== undefined ? _data["externalInvoiceReference1"] : <any>null;
            this.externalInvoiceReference2 = _data["externalInvoiceReference2"] !== undefined ? _data["externalInvoiceReference2"] : <any>null;
            this.finalPayDate = _data["finalPayDate"] !== undefined ? _data["finalPayDate"] : <any>null;
            this.freight = _data["freight"] !== undefined ? _data["freight"] : <any>null;
            this.freightVAT = _data["freightVAT"] !== undefined ? _data["freightVAT"] : <any>null;
            this.gross = _data["gross"] !== undefined ? _data["gross"] : <any>null;
            this.houseWork = _data["houseWork"] !== undefined ? _data["houseWork"] : <any>null;
            this.invoiceDate = _data["invoiceDate"] !== undefined ? _data["invoiceDate"] : <any>null;
            this.invoicePeriodStart = _data["invoicePeriodStart"] !== undefined ? _data["invoicePeriodStart"] : <any>null;
            this.invoicePeriodEnd = _data["invoicePeriodEnd"] !== undefined ? _data["invoicePeriodEnd"] : <any>null;
            this.invoiceReference = _data["invoiceReference"] !== undefined ? _data["invoiceReference"] : <any>null;
            if (Array.isArray(_data["invoiceRows"])) {
                this.invoiceRows = [] as any;
                for (let item of _data["invoiceRows"])
                    this.invoiceRows!.push(InvoiceRow.fromJS(item));
            }
            else {
                this.invoiceRows = <any>null;
            }
            this.invoiceType = _data["invoiceType"] !== undefined ? _data["invoiceType"] : <any>null;
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(LabelReference.fromJS(item));
            }
            else {
                this.labels = <any>null;
            }
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.lastRemindDate = _data["lastRemindDate"] !== undefined ? _data["lastRemindDate"] : <any>null;
            this.net = _data["net"] !== undefined ? _data["net"] : <any>null;
            this.notCompleted = _data["notCompleted"] !== undefined ? _data["notCompleted"] : <any>null;
            this.noxFinans = _data["noxFinans"] !== undefined ? _data["noxFinans"] : <any>null;
            this.ocr = _data["ocr"] !== undefined ? _data["ocr"] : <any>null;
            this.offerReference = _data["offerReference"] !== undefined ? _data["offerReference"] : <any>null;
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : <any>null;
            this.organisationNumber = _data["organisationNumber"] !== undefined ? _data["organisationNumber"] : <any>null;
            this.ourReference = _data["ourReference"] !== undefined ? _data["ourReference"] : <any>null;
            this.paymentWay = _data["paymentWay"] !== undefined ? _data["paymentWay"] : <any>null;
            this.phone1 = _data["phone1"] !== undefined ? _data["phone1"] : <any>null;
            this.phone2 = _data["phone2"] !== undefined ? _data["phone2"] : <any>null;
            this.priceList = _data["priceList"] !== undefined ? _data["priceList"] : <any>null;
            this.printTemplate = _data["printTemplate"] !== undefined ? _data["printTemplate"] : <any>null;
            this.project = _data["project"] !== undefined ? _data["project"] : <any>null;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : <any>null;
            this.reminders = _data["reminders"] !== undefined ? _data["reminders"] : <any>null;
            this.roundOff = _data["roundOff"] !== undefined ? _data["roundOff"] : <any>null;
            this.sent = _data["sent"] !== undefined ? _data["sent"] : <any>null;
            this.taxReduction = _data["taxReduction"] !== undefined ? _data["taxReduction"] : <any>null;
            this.taxReductionType = _data["taxReductionType"] !== undefined ? _data["taxReductionType"] : <any>null;
            this.termsOfDelivery = _data["termsOfDelivery"] !== undefined ? _data["termsOfDelivery"] : <any>null;
            this.termsOfPayment = _data["termsOfPayment"] !== undefined ? _data["termsOfPayment"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.totalVAT = _data["totalVAT"] !== undefined ? _data["totalVAT"] : <any>null;
            this.vatIncluded = _data["vatIncluded"] !== undefined ? _data["vatIncluded"] : <any>null;
            this.voucherNumber = _data["voucherNumber"] !== undefined ? _data["voucherNumber"] : <any>null;
            this.voucherSeries = _data["voucherSeries"] !== undefined ? _data["voucherSeries"] : <any>null;
            this.voucherYear = _data["voucherYear"] !== undefined ? _data["voucherYear"] : <any>null;
            this.wayOfDelivery = _data["wayOfDelivery"] !== undefined ? _data["wayOfDelivery"] : <any>null;
            this.yourOrderNumber = _data["yourOrderNumber"] !== undefined ? _data["yourOrderNumber"] : <any>null;
            this.yourReference = _data["yourReference"] !== undefined ? _data["yourReference"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.warehouseReady = _data["warehouseReady"] !== undefined ? _data["warehouseReady"] : <any>null;
            this.outboundDate = _data["outboundDate"] !== undefined ? _data["outboundDate"] : <any>null;
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@url"] = this.url !== undefined ? this.url : <any>null;
        data["@urlTaxReductionList"] = this.urlTaxReductionList !== undefined ? this.urlTaxReductionList : <any>null;
        data["accountingMethod"] = this.accountingMethod !== undefined ? this.accountingMethod : <any>null;
        data["administrationFee"] = this.administrationFee !== undefined ? this.administrationFee : <any>null;
        data["administrationFeeVAT"] = this.administrationFeeVAT !== undefined ? this.administrationFeeVAT : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["balance"] = this.balance !== undefined ? this.balance : <any>null;
        data["basisTaxReduction"] = this.basisTaxReduction !== undefined ? this.basisTaxReduction : <any>null;
        data["booked"] = this.booked !== undefined ? this.booked : <any>null;
        data["cancelled"] = this.cancelled !== undefined ? this.cancelled : <any>null;
        data["credit"] = this.credit !== undefined ? this.credit : <any>null;
        data["creditInvoiceReference"] = this.creditInvoiceReference !== undefined ? this.creditInvoiceReference : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        data["contractReference"] = this.contractReference !== undefined ? this.contractReference : <any>null;
        data["contributionPercent"] = this.contributionPercent !== undefined ? this.contributionPercent : <any>null;
        data["contributionValue"] = this.contributionValue !== undefined ? this.contributionValue : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["costCenter"] = this.costCenter !== undefined ? this.costCenter : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["currencyRate"] = this.currencyRate !== undefined ? this.currencyRate : <any>null;
        data["currencyUnit"] = this.currencyUnit !== undefined ? this.currencyUnit : <any>null;
        data["customerName"] = this.customerName !== undefined ? this.customerName : <any>null;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : <any>null;
        data["deliveryAddress1"] = this.deliveryAddress1 !== undefined ? this.deliveryAddress1 : <any>null;
        data["deliveryAddress2"] = this.deliveryAddress2 !== undefined ? this.deliveryAddress2 : <any>null;
        data["deliveryCity"] = this.deliveryCity !== undefined ? this.deliveryCity : <any>null;
        data["deliveryCountry"] = this.deliveryCountry !== undefined ? this.deliveryCountry : <any>null;
        data["deliveryDate"] = this.deliveryDate !== undefined ? this.deliveryDate : <any>null;
        data["deliveryName"] = this.deliveryName !== undefined ? this.deliveryName : <any>null;
        data["deliveryZipCode"] = this.deliveryZipCode !== undefined ? this.deliveryZipCode : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["dueDate"] = this.dueDate !== undefined ? this.dueDate : <any>null;
        data["ediInformation"] = this.ediInformation ? this.ediInformation.toJSON() : <any>null;
        data["emailInformation"] = this.emailInformation ? this.emailInformation.toJSON() : <any>null;
        data["euQuarterlyReport"] = this.euQuarterlyReport !== undefined ? this.euQuarterlyReport : <any>null;
        data["externalInvoiceReference1"] = this.externalInvoiceReference1 !== undefined ? this.externalInvoiceReference1 : <any>null;
        data["externalInvoiceReference2"] = this.externalInvoiceReference2 !== undefined ? this.externalInvoiceReference2 : <any>null;
        data["finalPayDate"] = this.finalPayDate !== undefined ? this.finalPayDate : <any>null;
        data["freight"] = this.freight !== undefined ? this.freight : <any>null;
        data["freightVAT"] = this.freightVAT !== undefined ? this.freightVAT : <any>null;
        data["gross"] = this.gross !== undefined ? this.gross : <any>null;
        data["houseWork"] = this.houseWork !== undefined ? this.houseWork : <any>null;
        data["invoiceDate"] = this.invoiceDate !== undefined ? this.invoiceDate : <any>null;
        data["invoicePeriodStart"] = this.invoicePeriodStart !== undefined ? this.invoicePeriodStart : <any>null;
        data["invoicePeriodEnd"] = this.invoicePeriodEnd !== undefined ? this.invoicePeriodEnd : <any>null;
        data["invoiceReference"] = this.invoiceReference !== undefined ? this.invoiceReference : <any>null;
        if (Array.isArray(this.invoiceRows)) {
            data["invoiceRows"] = [];
            for (let item of this.invoiceRows)
                data["invoiceRows"].push(item.toJSON());
        }
        data["invoiceType"] = this.invoiceType !== undefined ? this.invoiceType : <any>null;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item.toJSON());
        }
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["lastRemindDate"] = this.lastRemindDate !== undefined ? this.lastRemindDate : <any>null;
        data["net"] = this.net !== undefined ? this.net : <any>null;
        data["notCompleted"] = this.notCompleted !== undefined ? this.notCompleted : <any>null;
        data["noxFinans"] = this.noxFinans !== undefined ? this.noxFinans : <any>null;
        data["ocr"] = this.ocr !== undefined ? this.ocr : <any>null;
        data["offerReference"] = this.offerReference !== undefined ? this.offerReference : <any>null;
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : <any>null;
        data["organisationNumber"] = this.organisationNumber !== undefined ? this.organisationNumber : <any>null;
        data["ourReference"] = this.ourReference !== undefined ? this.ourReference : <any>null;
        data["paymentWay"] = this.paymentWay !== undefined ? this.paymentWay : <any>null;
        data["phone1"] = this.phone1 !== undefined ? this.phone1 : <any>null;
        data["phone2"] = this.phone2 !== undefined ? this.phone2 : <any>null;
        data["priceList"] = this.priceList !== undefined ? this.priceList : <any>null;
        data["printTemplate"] = this.printTemplate !== undefined ? this.printTemplate : <any>null;
        data["project"] = this.project !== undefined ? this.project : <any>null;
        data["remarks"] = this.remarks !== undefined ? this.remarks : <any>null;
        data["reminders"] = this.reminders !== undefined ? this.reminders : <any>null;
        data["roundOff"] = this.roundOff !== undefined ? this.roundOff : <any>null;
        data["sent"] = this.sent !== undefined ? this.sent : <any>null;
        data["taxReduction"] = this.taxReduction !== undefined ? this.taxReduction : <any>null;
        data["taxReductionType"] = this.taxReductionType !== undefined ? this.taxReductionType : <any>null;
        data["termsOfDelivery"] = this.termsOfDelivery !== undefined ? this.termsOfDelivery : <any>null;
        data["termsOfPayment"] = this.termsOfPayment !== undefined ? this.termsOfPayment : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["totalVAT"] = this.totalVAT !== undefined ? this.totalVAT : <any>null;
        data["vatIncluded"] = this.vatIncluded !== undefined ? this.vatIncluded : <any>null;
        data["voucherNumber"] = this.voucherNumber !== undefined ? this.voucherNumber : <any>null;
        data["voucherSeries"] = this.voucherSeries !== undefined ? this.voucherSeries : <any>null;
        data["voucherYear"] = this.voucherYear !== undefined ? this.voucherYear : <any>null;
        data["wayOfDelivery"] = this.wayOfDelivery !== undefined ? this.wayOfDelivery : <any>null;
        data["yourOrderNumber"] = this.yourOrderNumber !== undefined ? this.yourOrderNumber : <any>null;
        data["yourReference"] = this.yourReference !== undefined ? this.yourReference : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["warehouseReady"] = this.warehouseReady !== undefined ? this.warehouseReady : <any>null;
        data["outboundDate"] = this.outboundDate !== undefined ? this.outboundDate : <any>null;
        return data;
    }
}

export interface IInvoice {
    url?: string | null;
    urlTaxReductionList?: string | null;
    accountingMethod?: AccountingMethod | null;
    administrationFee?: number | null;
    administrationFeeVAT?: number | null;
    address1?: string | null;
    address2?: string | null;
    balance?: number | null;
    basisTaxReduction?: number | null;
    booked?: boolean | null;
    cancelled?: boolean | null;
    credit?: boolean | null;
    creditInvoiceReference?: number | null;
    city?: string | null;
    comments?: string | null;
    contractReference?: number | null;
    contributionPercent?: number | null;
    contributionValue?: number | null;
    country?: string | null;
    costCenter?: string | null;
    currency?: string | null;
    currencyRate?: number | null;
    currencyUnit?: number | null;
    customerName?: string | null;
    customerNumber?: string | null;
    deliveryAddress1?: string | null;
    deliveryAddress2?: string | null;
    deliveryCity?: string | null;
    deliveryCountry?: string | null;
    deliveryDate?: string | null;
    deliveryName?: string | null;
    deliveryZipCode?: string | null;
    documentNumber?: number | null;
    dueDate?: string | null;
    ediInformation?: EDIInformation | null;
    emailInformation?: EmailInformation | null;
    euQuarterlyReport?: boolean | null;
    externalInvoiceReference1?: string | null;
    externalInvoiceReference2?: string | null;
    finalPayDate?: string | null;
    freight?: number | null;
    freightVAT?: number | null;
    gross?: number | null;
    houseWork?: boolean | null;
    invoiceDate?: string | null;
    invoicePeriodStart?: string | null;
    invoicePeriodEnd?: string | null;
    invoiceReference?: number | null;
    invoiceRows?: InvoiceRow[] | null;
    invoiceType?: InvoiceType | null;
    labels?: LabelReference[] | null;
    language?: Language | null;
    lastRemindDate?: string | null;
    net?: number | null;
    notCompleted?: boolean | null;
    noxFinans?: boolean | null;
    ocr?: string | null;
    offerReference?: number | null;
    orderReference?: number | null;
    organisationNumber?: string | null;
    ourReference?: string | null;
    paymentWay?: PaymentWay | null;
    phone1?: string | null;
    phone2?: string | null;
    priceList?: string | null;
    printTemplate?: string | null;
    project?: string | null;
    remarks?: string | null;
    reminders?: number | null;
    roundOff?: number | null;
    sent?: boolean | null;
    taxReduction?: number | null;
    taxReductionType?: TaxReductionType | null;
    termsOfDelivery?: string | null;
    termsOfPayment?: string | null;
    total?: number | null;
    totalVAT?: number | null;
    vatIncluded?: boolean | null;
    voucherNumber?: number | null;
    voucherSeries?: string | null;
    voucherYear?: number | null;
    wayOfDelivery?: string | null;
    yourOrderNumber?: string | null;
    yourReference?: string | null;
    zipCode?: string | null;
    warehouseReady?: boolean | null;
    outboundDate?: string | null;
}

export enum AccountingMethod {
    Accrual = 0,
    Cash = 1,
}

export class EDIInformation implements IEDIInformation {
    ediGlobalLocationNumber?: string | null;
    ediGlobalLocationNumberDelivery?: string | null;
    ediInvoiceExtra1?: string | null;
    ediInvoiceExtra2?: string | null;
    ediOurElectronicReference?: string | null;
    ediYourElectronicReference?: string | null;
    ediStatus?: string | null;

    constructor(data?: IEDIInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ediGlobalLocationNumber = _data["ediGlobalLocationNumber"] !== undefined ? _data["ediGlobalLocationNumber"] : <any>null;
            this.ediGlobalLocationNumberDelivery = _data["ediGlobalLocationNumberDelivery"] !== undefined ? _data["ediGlobalLocationNumberDelivery"] : <any>null;
            this.ediInvoiceExtra1 = _data["ediInvoiceExtra1"] !== undefined ? _data["ediInvoiceExtra1"] : <any>null;
            this.ediInvoiceExtra2 = _data["ediInvoiceExtra2"] !== undefined ? _data["ediInvoiceExtra2"] : <any>null;
            this.ediOurElectronicReference = _data["ediOurElectronicReference"] !== undefined ? _data["ediOurElectronicReference"] : <any>null;
            this.ediYourElectronicReference = _data["ediYourElectronicReference"] !== undefined ? _data["ediYourElectronicReference"] : <any>null;
            this.ediStatus = _data["ediStatus"] !== undefined ? _data["ediStatus"] : <any>null;
        }
    }

    static fromJS(data: any): EDIInformation {
        data = typeof data === 'object' ? data : {};
        let result = new EDIInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ediGlobalLocationNumber"] = this.ediGlobalLocationNumber !== undefined ? this.ediGlobalLocationNumber : <any>null;
        data["ediGlobalLocationNumberDelivery"] = this.ediGlobalLocationNumberDelivery !== undefined ? this.ediGlobalLocationNumberDelivery : <any>null;
        data["ediInvoiceExtra1"] = this.ediInvoiceExtra1 !== undefined ? this.ediInvoiceExtra1 : <any>null;
        data["ediInvoiceExtra2"] = this.ediInvoiceExtra2 !== undefined ? this.ediInvoiceExtra2 : <any>null;
        data["ediOurElectronicReference"] = this.ediOurElectronicReference !== undefined ? this.ediOurElectronicReference : <any>null;
        data["ediYourElectronicReference"] = this.ediYourElectronicReference !== undefined ? this.ediYourElectronicReference : <any>null;
        data["ediStatus"] = this.ediStatus !== undefined ? this.ediStatus : <any>null;
        return data;
    }
}

export interface IEDIInformation {
    ediGlobalLocationNumber?: string | null;
    ediGlobalLocationNumberDelivery?: string | null;
    ediInvoiceExtra1?: string | null;
    ediInvoiceExtra2?: string | null;
    ediOurElectronicReference?: string | null;
    ediYourElectronicReference?: string | null;
    ediStatus?: string | null;
}

export class EmailInformation implements IEmailInformation {
    emailAddressFrom?: string | null;
    emailAddressTo?: string | null;
    emailAddressCC?: string | null;
    emailAddressBCC?: string | null;
    emailSubject?: string | null;
    emailBody?: string | null;

    constructor(data?: IEmailInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddressFrom = _data["emailAddressFrom"] !== undefined ? _data["emailAddressFrom"] : <any>null;
            this.emailAddressTo = _data["emailAddressTo"] !== undefined ? _data["emailAddressTo"] : <any>null;
            this.emailAddressCC = _data["emailAddressCC"] !== undefined ? _data["emailAddressCC"] : <any>null;
            this.emailAddressBCC = _data["emailAddressBCC"] !== undefined ? _data["emailAddressBCC"] : <any>null;
            this.emailSubject = _data["emailSubject"] !== undefined ? _data["emailSubject"] : <any>null;
            this.emailBody = _data["emailBody"] !== undefined ? _data["emailBody"] : <any>null;
        }
    }

    static fromJS(data: any): EmailInformation {
        data = typeof data === 'object' ? data : {};
        let result = new EmailInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddressFrom"] = this.emailAddressFrom !== undefined ? this.emailAddressFrom : <any>null;
        data["emailAddressTo"] = this.emailAddressTo !== undefined ? this.emailAddressTo : <any>null;
        data["emailAddressCC"] = this.emailAddressCC !== undefined ? this.emailAddressCC : <any>null;
        data["emailAddressBCC"] = this.emailAddressBCC !== undefined ? this.emailAddressBCC : <any>null;
        data["emailSubject"] = this.emailSubject !== undefined ? this.emailSubject : <any>null;
        data["emailBody"] = this.emailBody !== undefined ? this.emailBody : <any>null;
        return data;
    }
}

export interface IEmailInformation {
    emailAddressFrom?: string | null;
    emailAddressTo?: string | null;
    emailAddressCC?: string | null;
    emailAddressBCC?: string | null;
    emailSubject?: string | null;
    emailBody?: string | null;
}

export class InvoiceRow implements IInvoiceRow {
    accountNumber?: number | null;
    articleNumber?: string | null;
    contributionPercent?: number | null;
    contributionValue?: number | null;
    costCenter?: string | null;
    deliveredQuantity?: number | null;
    description?: string | null;
    discount?: number | null;
    discountType?: DiscountType | null;
    houseWork?: boolean | null;
    houseWorkHoursToReport?: number | null;
    houseWorkType?: HouseworkType | null;
    price?: number | null;
    priceExcludingVAT?: number | null;
    project?: string | null;
    total?: number | null;
    totalExcludingVAT?: number | null;
    unit?: string | null;
    vat?: number | null;
    rowId?: number | null;
    stockPointCode?: string | null;

    constructor(data?: IInvoiceRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : <any>null;
            this.articleNumber = _data["articleNumber"] !== undefined ? _data["articleNumber"] : <any>null;
            this.contributionPercent = _data["contributionPercent"] !== undefined ? _data["contributionPercent"] : <any>null;
            this.contributionValue = _data["contributionValue"] !== undefined ? _data["contributionValue"] : <any>null;
            this.costCenter = _data["costCenter"] !== undefined ? _data["costCenter"] : <any>null;
            this.deliveredQuantity = _data["deliveredQuantity"] !== undefined ? _data["deliveredQuantity"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.discount = _data["discount"] !== undefined ? _data["discount"] : <any>null;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : <any>null;
            this.houseWork = _data["houseWork"] !== undefined ? _data["houseWork"] : <any>null;
            this.houseWorkHoursToReport = _data["houseWorkHoursToReport"] !== undefined ? _data["houseWorkHoursToReport"] : <any>null;
            this.houseWorkType = _data["houseWorkType"] !== undefined ? _data["houseWorkType"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.priceExcludingVAT = _data["priceExcludingVAT"] !== undefined ? _data["priceExcludingVAT"] : <any>null;
            this.project = _data["project"] !== undefined ? _data["project"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.totalExcludingVAT = _data["totalExcludingVAT"] !== undefined ? _data["totalExcludingVAT"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.rowId = _data["rowId"] !== undefined ? _data["rowId"] : <any>null;
            this.stockPointCode = _data["stockPointCode"] !== undefined ? _data["stockPointCode"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceRow {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : <any>null;
        data["articleNumber"] = this.articleNumber !== undefined ? this.articleNumber : <any>null;
        data["contributionPercent"] = this.contributionPercent !== undefined ? this.contributionPercent : <any>null;
        data["contributionValue"] = this.contributionValue !== undefined ? this.contributionValue : <any>null;
        data["costCenter"] = this.costCenter !== undefined ? this.costCenter : <any>null;
        data["deliveredQuantity"] = this.deliveredQuantity !== undefined ? this.deliveredQuantity : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["discount"] = this.discount !== undefined ? this.discount : <any>null;
        data["discountType"] = this.discountType !== undefined ? this.discountType : <any>null;
        data["houseWork"] = this.houseWork !== undefined ? this.houseWork : <any>null;
        data["houseWorkHoursToReport"] = this.houseWorkHoursToReport !== undefined ? this.houseWorkHoursToReport : <any>null;
        data["houseWorkType"] = this.houseWorkType !== undefined ? this.houseWorkType : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["priceExcludingVAT"] = this.priceExcludingVAT !== undefined ? this.priceExcludingVAT : <any>null;
        data["project"] = this.project !== undefined ? this.project : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["totalExcludingVAT"] = this.totalExcludingVAT !== undefined ? this.totalExcludingVAT : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["rowId"] = this.rowId !== undefined ? this.rowId : <any>null;
        data["stockPointCode"] = this.stockPointCode !== undefined ? this.stockPointCode : <any>null;
        return data;
    }
}

export interface IInvoiceRow {
    accountNumber?: number | null;
    articleNumber?: string | null;
    contributionPercent?: number | null;
    contributionValue?: number | null;
    costCenter?: string | null;
    deliveredQuantity?: number | null;
    description?: string | null;
    discount?: number | null;
    discountType?: DiscountType | null;
    houseWork?: boolean | null;
    houseWorkHoursToReport?: number | null;
    houseWorkType?: HouseworkType | null;
    price?: number | null;
    priceExcludingVAT?: number | null;
    project?: string | null;
    total?: number | null;
    totalExcludingVAT?: number | null;
    unit?: string | null;
    vat?: number | null;
    rowId?: number | null;
    stockPointCode?: string | null;
}

export enum DiscountType {
    Amount = 0,
    Percent = 1,
}

export enum HouseworkType {
    Construction = 0,
    Electricity = 1,
    GlassMetalWork = 2,
    GroundDrainageWork = 3,
    Masonry = 4,
    PaintingWallpapering = 5,
    HVAC = 6,
    MajorApplianceRepair = 7,
    MovingServices = 8,
    ITServices = 9,
    Cleaning = 10,
    TextileClothing = 11,
    Snowplowing = 12,
    Gardening = 13,
    Babysitting = 14,
    OtherCare = 15,
    OtherCosts = 16,
    Cooking = 17,
    Tutoring = 18,
    SolarCells = 19,
    StorageSelfProducedElectricity = 20,
    ChargingStationElectricVehicle = 21,
    HomeMaintenance = 22,
    Furnishing = 23,
    TransportationServices = 24,
    WashingAndCareOfClothing = 25,
    EmptyHousework = 26,
    Blank = 27,
}

export enum InvoiceType {
    Invoice = 0,
    AgreementInvoice = 1,
    IntrestInvoice = 2,
    SummaryInvoice = 3,
    CashInvoice = 4,
}

export class LabelReference implements ILabelReference {
    id?: number | null;

    constructor(data?: ILabelReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): LabelReference {
        data = typeof data === 'object' ? data : {};
        let result = new LabelReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface ILabelReference {
    id?: number | null;
}

export enum Language {
    Swedish = 0,
    English = 1,
}

export enum PaymentWay {
    Cash = 0,
    Card = 1,
    AutoGiro = 2,
}

export enum TaxReductionType {
    ROT = 0,
    RUT = 1,
    Green = 2,
    None = 3,
}

export class InvoiceSubset implements IInvoiceSubset {
    url?: string | null;
    balance?: number | null;
    booked?: boolean | null;
    cancelled?: boolean | null;
    costCenter?: string | null;
    currency?: string | null;
    currencyRate?: number | null;
    currencyUnit?: number | null;
    customerName?: string | null;
    customerNumber?: string | null;
    documentNumber?: number | null;
    dueDate?: string | null;
    externalInvoiceReference1?: string | null;
    externalInvoiceReference2?: string | null;
    finalPayDate?: string | null;
    invoiceDate?: string | null;
    invoiceType?: InvoiceType | null;
    noxFinans?: boolean | null;
    ocr?: string | null;
    project?: string | null;
    sent?: boolean | null;
    termsOfPayment?: string | null;
    total?: number | null;
    wayOfDelivery?: string | null;

    constructor(data?: IInvoiceSubset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["@url"] !== undefined ? _data["@url"] : <any>null;
            this.balance = _data["balance"] !== undefined ? _data["balance"] : <any>null;
            this.booked = _data["booked"] !== undefined ? _data["booked"] : <any>null;
            this.cancelled = _data["cancelled"] !== undefined ? _data["cancelled"] : <any>null;
            this.costCenter = _data["costCenter"] !== undefined ? _data["costCenter"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.currencyRate = _data["currencyRate"] !== undefined ? _data["currencyRate"] : <any>null;
            this.currencyUnit = _data["currencyUnit"] !== undefined ? _data["currencyUnit"] : <any>null;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : <any>null;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.dueDate = _data["dueDate"] !== undefined ? _data["dueDate"] : <any>null;
            this.externalInvoiceReference1 = _data["externalInvoiceReference1"] !== undefined ? _data["externalInvoiceReference1"] : <any>null;
            this.externalInvoiceReference2 = _data["externalInvoiceReference2"] !== undefined ? _data["externalInvoiceReference2"] : <any>null;
            this.finalPayDate = _data["finalPayDate"] !== undefined ? _data["finalPayDate"] : <any>null;
            this.invoiceDate = _data["invoiceDate"] !== undefined ? _data["invoiceDate"] : <any>null;
            this.invoiceType = _data["invoiceType"] !== undefined ? _data["invoiceType"] : <any>null;
            this.noxFinans = _data["noxFinans"] !== undefined ? _data["noxFinans"] : <any>null;
            this.ocr = _data["ocr"] !== undefined ? _data["ocr"] : <any>null;
            this.project = _data["project"] !== undefined ? _data["project"] : <any>null;
            this.sent = _data["sent"] !== undefined ? _data["sent"] : <any>null;
            this.termsOfPayment = _data["termsOfPayment"] !== undefined ? _data["termsOfPayment"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.wayOfDelivery = _data["wayOfDelivery"] !== undefined ? _data["wayOfDelivery"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceSubset {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSubset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@url"] = this.url !== undefined ? this.url : <any>null;
        data["balance"] = this.balance !== undefined ? this.balance : <any>null;
        data["booked"] = this.booked !== undefined ? this.booked : <any>null;
        data["cancelled"] = this.cancelled !== undefined ? this.cancelled : <any>null;
        data["costCenter"] = this.costCenter !== undefined ? this.costCenter : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["currencyRate"] = this.currencyRate !== undefined ? this.currencyRate : <any>null;
        data["currencyUnit"] = this.currencyUnit !== undefined ? this.currencyUnit : <any>null;
        data["customerName"] = this.customerName !== undefined ? this.customerName : <any>null;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["dueDate"] = this.dueDate !== undefined ? this.dueDate : <any>null;
        data["externalInvoiceReference1"] = this.externalInvoiceReference1 !== undefined ? this.externalInvoiceReference1 : <any>null;
        data["externalInvoiceReference2"] = this.externalInvoiceReference2 !== undefined ? this.externalInvoiceReference2 : <any>null;
        data["finalPayDate"] = this.finalPayDate !== undefined ? this.finalPayDate : <any>null;
        data["invoiceDate"] = this.invoiceDate !== undefined ? this.invoiceDate : <any>null;
        data["invoiceType"] = this.invoiceType !== undefined ? this.invoiceType : <any>null;
        data["noxFinans"] = this.noxFinans !== undefined ? this.noxFinans : <any>null;
        data["ocr"] = this.ocr !== undefined ? this.ocr : <any>null;
        data["project"] = this.project !== undefined ? this.project : <any>null;
        data["sent"] = this.sent !== undefined ? this.sent : <any>null;
        data["termsOfPayment"] = this.termsOfPayment !== undefined ? this.termsOfPayment : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["wayOfDelivery"] = this.wayOfDelivery !== undefined ? this.wayOfDelivery : <any>null;
        return data;
    }
}

export interface IInvoiceSubset {
    url?: string | null;
    balance?: number | null;
    booked?: boolean | null;
    cancelled?: boolean | null;
    costCenter?: string | null;
    currency?: string | null;
    currencyRate?: number | null;
    currencyUnit?: number | null;
    customerName?: string | null;
    customerNumber?: string | null;
    documentNumber?: number | null;
    dueDate?: string | null;
    externalInvoiceReference1?: string | null;
    externalInvoiceReference2?: string | null;
    finalPayDate?: string | null;
    invoiceDate?: string | null;
    invoiceType?: InvoiceType | null;
    noxFinans?: boolean | null;
    ocr?: string | null;
    project?: string | null;
    sent?: boolean | null;
    termsOfPayment?: string | null;
    total?: number | null;
    wayOfDelivery?: string | null;
}

export class InvoiceSearch extends BaseSearch implements IInvoiceSearch {
    sortBy?: Invoice2 | null;
    filterBy?: Invoice3 | null;
    credit?: string | null;
    costCenter?: string | null;
    currency?: string | null;
    customerName?: string | null;
    customerNumber?: string | null;
    documentNumber?: string | null;
    externalInvoiceReference1?: string | null;
    externalInvoiceReference2?: string | null;
    invoiceType?: string | null;
    notCompleted?: string | null;
    ocr?: string | null;
    ourReference?: string | null;
    project?: string | null;
    sent?: string | null;
    yourOrderNumber?: string | null;
    yourReference?: string | null;
    accountNumberFrom?: string | null;
    accountNumberTo?: string | null;
    labelReference?: number | null;

    constructor(data?: IInvoiceSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : <any>null;
            this.filterBy = _data["filterBy"] !== undefined ? _data["filterBy"] : <any>null;
            this.credit = _data["credit"] !== undefined ? _data["credit"] : <any>null;
            this.costCenter = _data["costCenter"] !== undefined ? _data["costCenter"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : <any>null;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.externalInvoiceReference1 = _data["externalInvoiceReference1"] !== undefined ? _data["externalInvoiceReference1"] : <any>null;
            this.externalInvoiceReference2 = _data["externalInvoiceReference2"] !== undefined ? _data["externalInvoiceReference2"] : <any>null;
            this.invoiceType = _data["invoiceType"] !== undefined ? _data["invoiceType"] : <any>null;
            this.notCompleted = _data["notCompleted"] !== undefined ? _data["notCompleted"] : <any>null;
            this.ocr = _data["ocr"] !== undefined ? _data["ocr"] : <any>null;
            this.ourReference = _data["ourReference"] !== undefined ? _data["ourReference"] : <any>null;
            this.project = _data["project"] !== undefined ? _data["project"] : <any>null;
            this.sent = _data["sent"] !== undefined ? _data["sent"] : <any>null;
            this.yourOrderNumber = _data["yourOrderNumber"] !== undefined ? _data["yourOrderNumber"] : <any>null;
            this.yourReference = _data["yourReference"] !== undefined ? _data["yourReference"] : <any>null;
            this.accountNumberFrom = _data["accountNumberFrom"] !== undefined ? _data["accountNumberFrom"] : <any>null;
            this.accountNumberTo = _data["accountNumberTo"] !== undefined ? _data["accountNumberTo"] : <any>null;
            this.labelReference = _data["labelReference"] !== undefined ? _data["labelReference"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceSearch {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : <any>null;
        data["filterBy"] = this.filterBy !== undefined ? this.filterBy : <any>null;
        data["credit"] = this.credit !== undefined ? this.credit : <any>null;
        data["costCenter"] = this.costCenter !== undefined ? this.costCenter : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["customerName"] = this.customerName !== undefined ? this.customerName : <any>null;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["externalInvoiceReference1"] = this.externalInvoiceReference1 !== undefined ? this.externalInvoiceReference1 : <any>null;
        data["externalInvoiceReference2"] = this.externalInvoiceReference2 !== undefined ? this.externalInvoiceReference2 : <any>null;
        data["invoiceType"] = this.invoiceType !== undefined ? this.invoiceType : <any>null;
        data["notCompleted"] = this.notCompleted !== undefined ? this.notCompleted : <any>null;
        data["ocr"] = this.ocr !== undefined ? this.ocr : <any>null;
        data["ourReference"] = this.ourReference !== undefined ? this.ourReference : <any>null;
        data["project"] = this.project !== undefined ? this.project : <any>null;
        data["sent"] = this.sent !== undefined ? this.sent : <any>null;
        data["yourOrderNumber"] = this.yourOrderNumber !== undefined ? this.yourOrderNumber : <any>null;
        data["yourReference"] = this.yourReference !== undefined ? this.yourReference : <any>null;
        data["accountNumberFrom"] = this.accountNumberFrom !== undefined ? this.accountNumberFrom : <any>null;
        data["accountNumberTo"] = this.accountNumberTo !== undefined ? this.accountNumberTo : <any>null;
        data["labelReference"] = this.labelReference !== undefined ? this.labelReference : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceSearch extends IBaseSearch {
    sortBy?: Invoice2 | null;
    filterBy?: Invoice3 | null;
    credit?: string | null;
    costCenter?: string | null;
    currency?: string | null;
    customerName?: string | null;
    customerNumber?: string | null;
    documentNumber?: string | null;
    externalInvoiceReference1?: string | null;
    externalInvoiceReference2?: string | null;
    invoiceType?: string | null;
    notCompleted?: string | null;
    ocr?: string | null;
    ourReference?: string | null;
    project?: string | null;
    sent?: string | null;
    yourOrderNumber?: string | null;
    yourReference?: string | null;
    accountNumberFrom?: string | null;
    accountNumberTo?: string | null;
    labelReference?: number | null;
}

export enum Invoice2 {
    CustomerName = 0,
    CustomerNumber = 1,
    DocumentNumber = 2,
    InvoiceDate = 3,
    OCR = 4,
    Total = 5,
}

export enum Invoice3 {
    FullyPaid = 0,
    Cancelled = 1,
    Unpaid = 2,
    UnpaidOverdue = 3,
    Unbooked = 4,
}

export class EntityCollectionOfInvoiceSubset implements IEntityCollectionOfInvoiceSubset {
    entities!: InvoiceSubset[];
    metaInformation?: MetaInformation | null;
    totalResources!: number;
    totalPages!: number;
    currentPage!: number;

    constructor(data?: IEntityCollectionOfInvoiceSubset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(InvoiceSubset.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
            this.metaInformation = _data["metaInformation"] ? MetaInformation.fromJS(_data["metaInformation"]) : <any>null;
            this.totalResources = _data["totalResources"] !== undefined ? _data["totalResources"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : <any>null;
        }
    }

    static fromJS(data: any): EntityCollectionOfInvoiceSubset {
        data = typeof data === 'object' ? data : {};
        let result = new EntityCollectionOfInvoiceSubset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        data["metaInformation"] = this.metaInformation ? this.metaInformation.toJSON() : <any>null;
        data["totalResources"] = this.totalResources !== undefined ? this.totalResources : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : <any>null;
        return data;
    }
}

export interface IEntityCollectionOfInvoiceSubset {
    entities: InvoiceSubset[];
    metaInformation?: MetaInformation | null;
    totalResources: number;
    totalPages: number;
    currentPage: number;
}

export class ArticleSubset implements IArticleSubset {
    url?: string | null;
    articleNumber?: string | null;
    description?: string | null;
    disposableQuantity?: number | null;
    ean?: string | null;
    housework?: boolean | null;
    purchasePrice?: number | null;
    salesPrice?: number | null;
    stockPlace?: string | null;
    stockValue?: number | null;
    unit?: string | null;
    vat?: number | null;
    webshopArticle?: boolean | null;

    constructor(data?: IArticleSubset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["@url"] !== undefined ? _data["@url"] : <any>null;
            this.articleNumber = _data["articleNumber"] !== undefined ? _data["articleNumber"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.disposableQuantity = _data["disposableQuantity"] !== undefined ? _data["disposableQuantity"] : <any>null;
            this.ean = _data["ean"] !== undefined ? _data["ean"] : <any>null;
            this.housework = _data["housework"] !== undefined ? _data["housework"] : <any>null;
            this.purchasePrice = _data["purchasePrice"] !== undefined ? _data["purchasePrice"] : <any>null;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : <any>null;
            this.stockPlace = _data["stockPlace"] !== undefined ? _data["stockPlace"] : <any>null;
            this.stockValue = _data["stockValue"] !== undefined ? _data["stockValue"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.webshopArticle = _data["webshopArticle"] !== undefined ? _data["webshopArticle"] : <any>null;
        }
    }

    static fromJS(data: any): ArticleSubset {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleSubset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@url"] = this.url !== undefined ? this.url : <any>null;
        data["articleNumber"] = this.articleNumber !== undefined ? this.articleNumber : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["disposableQuantity"] = this.disposableQuantity !== undefined ? this.disposableQuantity : <any>null;
        data["ean"] = this.ean !== undefined ? this.ean : <any>null;
        data["housework"] = this.housework !== undefined ? this.housework : <any>null;
        data["purchasePrice"] = this.purchasePrice !== undefined ? this.purchasePrice : <any>null;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : <any>null;
        data["stockPlace"] = this.stockPlace !== undefined ? this.stockPlace : <any>null;
        data["stockValue"] = this.stockValue !== undefined ? this.stockValue : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["webshopArticle"] = this.webshopArticle !== undefined ? this.webshopArticle : <any>null;
        return data;
    }
}

export interface IArticleSubset {
    url?: string | null;
    articleNumber?: string | null;
    description?: string | null;
    disposableQuantity?: number | null;
    ean?: string | null;
    housework?: boolean | null;
    purchasePrice?: number | null;
    salesPrice?: number | null;
    stockPlace?: string | null;
    stockValue?: number | null;
    unit?: string | null;
    vat?: number | null;
    webshopArticle?: boolean | null;
}

export class ArticleSearch extends BaseSearch implements IArticleSearch {
    sortBy?: Article | null;
    filterBy?: Article2 | null;
    articleNumber?: string | null;
    description?: string | null;
    ean?: string | null;
    manufacturer?: string | null;
    manufacturerArticleNumber?: string | null;
    supplierNumber?: string | null;

    constructor(data?: IArticleSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : <any>null;
            this.filterBy = _data["filterBy"] !== undefined ? _data["filterBy"] : <any>null;
            this.articleNumber = _data["articleNumber"] !== undefined ? _data["articleNumber"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.ean = _data["ean"] !== undefined ? _data["ean"] : <any>null;
            this.manufacturer = _data["manufacturer"] !== undefined ? _data["manufacturer"] : <any>null;
            this.manufacturerArticleNumber = _data["manufacturerArticleNumber"] !== undefined ? _data["manufacturerArticleNumber"] : <any>null;
            this.supplierNumber = _data["supplierNumber"] !== undefined ? _data["supplierNumber"] : <any>null;
        }
    }

    static fromJS(data: any): ArticleSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : <any>null;
        data["filterBy"] = this.filterBy !== undefined ? this.filterBy : <any>null;
        data["articleNumber"] = this.articleNumber !== undefined ? this.articleNumber : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["ean"] = this.ean !== undefined ? this.ean : <any>null;
        data["manufacturer"] = this.manufacturer !== undefined ? this.manufacturer : <any>null;
        data["manufacturerArticleNumber"] = this.manufacturerArticleNumber !== undefined ? this.manufacturerArticleNumber : <any>null;
        data["supplierNumber"] = this.supplierNumber !== undefined ? this.supplierNumber : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IArticleSearch extends IBaseSearch {
    sortBy?: Article | null;
    filterBy?: Article2 | null;
    articleNumber?: string | null;
    description?: string | null;
    ean?: string | null;
    manufacturer?: string | null;
    manufacturerArticleNumber?: string | null;
    supplierNumber?: string | null;
}

export enum Article {
    ArticleNumber = 0,
    QuantityInStock = 1,
    ReservedQuantity = 2,
    StockValue = 3,
}

export enum Article2 {
    Active = 0,
    Inactive = 1,
}

export class EntityCollectionOfArticleSubset implements IEntityCollectionOfArticleSubset {
    entities!: ArticleSubset[];
    metaInformation?: MetaInformation | null;
    totalResources!: number;
    totalPages!: number;
    currentPage!: number;

    constructor(data?: IEntityCollectionOfArticleSubset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ArticleSubset.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
            this.metaInformation = _data["metaInformation"] ? MetaInformation.fromJS(_data["metaInformation"]) : <any>null;
            this.totalResources = _data["totalResources"] !== undefined ? _data["totalResources"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : <any>null;
        }
    }

    static fromJS(data: any): EntityCollectionOfArticleSubset {
        data = typeof data === 'object' ? data : {};
        let result = new EntityCollectionOfArticleSubset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        data["metaInformation"] = this.metaInformation ? this.metaInformation.toJSON() : <any>null;
        data["totalResources"] = this.totalResources !== undefined ? this.totalResources : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : <any>null;
        return data;
    }
}

export interface IEntityCollectionOfArticleSubset {
    entities: ArticleSubset[];
    metaInformation?: MetaInformation | null;
    totalResources: number;
    totalPages: number;
    currentPage: number;
}

export class Article3 implements IArticle3 {
    url?: string | null;
    active?: boolean | null;
    articleNumber?: string | null;
    bulky?: boolean | null;
    constructionAccount?: number | null;
    depth?: number | null;
    description?: string | null;
    disposableQuantity?: number | null;
    ean?: string | null;
    euAccount?: number | null;
    euvatAccount?: number | null;
    exportAccount?: number | null;
    height?: number | null;
    housework?: boolean | null;
    houseworkType?: HouseworkType | null;
    manufacturer?: string | null;
    manufacturerArticleNumber?: string | null;
    note?: string | null;
    purchaseAccount?: number | null;
    purchasePrice?: number | null;
    quantityInStock?: number | null;
    reservedQuantity?: number | null;
    salesAccount?: number | null;
    salesPrice?: number | null;
    stockGoods?: boolean | null;
    stockPlace?: string | null;
    stockValue?: number | null;
    stockWarning?: number | null;
    supplierName?: string | null;
    supplierNumber?: string | null;
    type?: ArticleType | null;
    unit?: string | null;
    vat?: number | null;
    webshopArticle?: boolean | null;
    weight?: number | null;
    width?: number | null;
    expired?: boolean | null;
    costCalculationMethod?: string | null;
    stockAccount?: number | null;
    directCost?: number | null;
    freightCost?: number | null;
    otherCost?: number | null;

    constructor(data?: IArticle3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["@url"] !== undefined ? _data["@url"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.articleNumber = _data["articleNumber"] !== undefined ? _data["articleNumber"] : <any>null;
            this.bulky = _data["bulky"] !== undefined ? _data["bulky"] : <any>null;
            this.constructionAccount = _data["constructionAccount"] !== undefined ? _data["constructionAccount"] : <any>null;
            this.depth = _data["depth"] !== undefined ? _data["depth"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.disposableQuantity = _data["disposableQuantity"] !== undefined ? _data["disposableQuantity"] : <any>null;
            this.ean = _data["ean"] !== undefined ? _data["ean"] : <any>null;
            this.euAccount = _data["euAccount"] !== undefined ? _data["euAccount"] : <any>null;
            this.euvatAccount = _data["euvatAccount"] !== undefined ? _data["euvatAccount"] : <any>null;
            this.exportAccount = _data["exportAccount"] !== undefined ? _data["exportAccount"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.housework = _data["housework"] !== undefined ? _data["housework"] : <any>null;
            this.houseworkType = _data["houseworkType"] !== undefined ? _data["houseworkType"] : <any>null;
            this.manufacturer = _data["manufacturer"] !== undefined ? _data["manufacturer"] : <any>null;
            this.manufacturerArticleNumber = _data["manufacturerArticleNumber"] !== undefined ? _data["manufacturerArticleNumber"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.purchaseAccount = _data["purchaseAccount"] !== undefined ? _data["purchaseAccount"] : <any>null;
            this.purchasePrice = _data["purchasePrice"] !== undefined ? _data["purchasePrice"] : <any>null;
            this.quantityInStock = _data["quantityInStock"] !== undefined ? _data["quantityInStock"] : <any>null;
            this.reservedQuantity = _data["reservedQuantity"] !== undefined ? _data["reservedQuantity"] : <any>null;
            this.salesAccount = _data["salesAccount"] !== undefined ? _data["salesAccount"] : <any>null;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : <any>null;
            this.stockGoods = _data["stockGoods"] !== undefined ? _data["stockGoods"] : <any>null;
            this.stockPlace = _data["stockPlace"] !== undefined ? _data["stockPlace"] : <any>null;
            this.stockValue = _data["stockValue"] !== undefined ? _data["stockValue"] : <any>null;
            this.stockWarning = _data["stockWarning"] !== undefined ? _data["stockWarning"] : <any>null;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : <any>null;
            this.supplierNumber = _data["supplierNumber"] !== undefined ? _data["supplierNumber"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.webshopArticle = _data["webshopArticle"] !== undefined ? _data["webshopArticle"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.expired = _data["expired"] !== undefined ? _data["expired"] : <any>null;
            this.costCalculationMethod = _data["costCalculationMethod"] !== undefined ? _data["costCalculationMethod"] : <any>null;
            this.stockAccount = _data["stockAccount"] !== undefined ? _data["stockAccount"] : <any>null;
            this.directCost = _data["directCost"] !== undefined ? _data["directCost"] : <any>null;
            this.freightCost = _data["freightCost"] !== undefined ? _data["freightCost"] : <any>null;
            this.otherCost = _data["otherCost"] !== undefined ? _data["otherCost"] : <any>null;
        }
    }

    static fromJS(data: any): Article3 {
        data = typeof data === 'object' ? data : {};
        let result = new Article3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@url"] = this.url !== undefined ? this.url : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["articleNumber"] = this.articleNumber !== undefined ? this.articleNumber : <any>null;
        data["bulky"] = this.bulky !== undefined ? this.bulky : <any>null;
        data["constructionAccount"] = this.constructionAccount !== undefined ? this.constructionAccount : <any>null;
        data["depth"] = this.depth !== undefined ? this.depth : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["disposableQuantity"] = this.disposableQuantity !== undefined ? this.disposableQuantity : <any>null;
        data["ean"] = this.ean !== undefined ? this.ean : <any>null;
        data["euAccount"] = this.euAccount !== undefined ? this.euAccount : <any>null;
        data["euvatAccount"] = this.euvatAccount !== undefined ? this.euvatAccount : <any>null;
        data["exportAccount"] = this.exportAccount !== undefined ? this.exportAccount : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["housework"] = this.housework !== undefined ? this.housework : <any>null;
        data["houseworkType"] = this.houseworkType !== undefined ? this.houseworkType : <any>null;
        data["manufacturer"] = this.manufacturer !== undefined ? this.manufacturer : <any>null;
        data["manufacturerArticleNumber"] = this.manufacturerArticleNumber !== undefined ? this.manufacturerArticleNumber : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["purchaseAccount"] = this.purchaseAccount !== undefined ? this.purchaseAccount : <any>null;
        data["purchasePrice"] = this.purchasePrice !== undefined ? this.purchasePrice : <any>null;
        data["quantityInStock"] = this.quantityInStock !== undefined ? this.quantityInStock : <any>null;
        data["reservedQuantity"] = this.reservedQuantity !== undefined ? this.reservedQuantity : <any>null;
        data["salesAccount"] = this.salesAccount !== undefined ? this.salesAccount : <any>null;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : <any>null;
        data["stockGoods"] = this.stockGoods !== undefined ? this.stockGoods : <any>null;
        data["stockPlace"] = this.stockPlace !== undefined ? this.stockPlace : <any>null;
        data["stockValue"] = this.stockValue !== undefined ? this.stockValue : <any>null;
        data["stockWarning"] = this.stockWarning !== undefined ? this.stockWarning : <any>null;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : <any>null;
        data["supplierNumber"] = this.supplierNumber !== undefined ? this.supplierNumber : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["webshopArticle"] = this.webshopArticle !== undefined ? this.webshopArticle : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["expired"] = this.expired !== undefined ? this.expired : <any>null;
        data["costCalculationMethod"] = this.costCalculationMethod !== undefined ? this.costCalculationMethod : <any>null;
        data["stockAccount"] = this.stockAccount !== undefined ? this.stockAccount : <any>null;
        data["directCost"] = this.directCost !== undefined ? this.directCost : <any>null;
        data["freightCost"] = this.freightCost !== undefined ? this.freightCost : <any>null;
        data["otherCost"] = this.otherCost !== undefined ? this.otherCost : <any>null;
        return data;
    }
}

export interface IArticle3 {
    url?: string | null;
    active?: boolean | null;
    articleNumber?: string | null;
    bulky?: boolean | null;
    constructionAccount?: number | null;
    depth?: number | null;
    description?: string | null;
    disposableQuantity?: number | null;
    ean?: string | null;
    euAccount?: number | null;
    euvatAccount?: number | null;
    exportAccount?: number | null;
    height?: number | null;
    housework?: boolean | null;
    houseworkType?: HouseworkType | null;
    manufacturer?: string | null;
    manufacturerArticleNumber?: string | null;
    note?: string | null;
    purchaseAccount?: number | null;
    purchasePrice?: number | null;
    quantityInStock?: number | null;
    reservedQuantity?: number | null;
    salesAccount?: number | null;
    salesPrice?: number | null;
    stockGoods?: boolean | null;
    stockPlace?: string | null;
    stockValue?: number | null;
    stockWarning?: number | null;
    supplierName?: string | null;
    supplierNumber?: string | null;
    type?: ArticleType | null;
    unit?: string | null;
    vat?: number | null;
    webshopArticle?: boolean | null;
    weight?: number | null;
    width?: number | null;
    expired?: boolean | null;
    costCalculationMethod?: string | null;
    stockAccount?: number | null;
    directCost?: number | null;
    freightCost?: number | null;
    otherCost?: number | null;
}

export enum ArticleType {
    Stock = 0,
    Service = 1,
}

export class ApiResultOfInvoiceEntity implements IApiResultOfInvoiceEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: InvoiceEntity | null;

    constructor(data?: IApiResultOfInvoiceEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? InvoiceEntity.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfInvoiceEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfInvoiceEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfInvoiceEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: InvoiceEntity | null;
}

export class ApiResultOfListOfInvoiceEntity implements IApiResultOfListOfInvoiceEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: InvoiceEntity[] | null;

    constructor(data?: IApiResultOfListOfInvoiceEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InvoiceEntity.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): ApiResultOfListOfInvoiceEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfListOfInvoiceEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApiResultOfListOfInvoiceEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: InvoiceEntity[] | null;
}

export class ApiResultOfOrderEntity implements IApiResultOfOrderEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: OrderEntity | null;

    constructor(data?: IApiResultOfOrderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? OrderEntity.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfOrderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfOrderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfOrderEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: OrderEntity | null;
}

export class ApiResultOfGuid implements IApiResultOfGuid {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data!: string;

    constructor(data?: IApiResultOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data;
    }
}

export interface IApiResultOfGuid {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data: string;
}

export class OrderProductCreditDto implements IOrderProductCreditDto {
    orderId!: string;
    productId!: string;
    unit!: UnitEnums;
    quantity!: number;

    constructor(data?: IOrderProductCreditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
        }
    }

    static fromJS(data: any): OrderProductCreditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductCreditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId !== undefined ? this.orderId : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        return data;
    }
}

export interface IOrderProductCreditDto {
    orderId: string;
    productId: string;
    unit: UnitEnums;
    quantity: number;
}

export class ApiResultOfBoolean implements IApiResultOfBoolean {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data!: boolean;

    constructor(data?: IApiResultOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data;
    }
}

export interface IApiResultOfBoolean {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data: boolean;
}

export class OrderDTO implements IOrderDTO {
    id!: string;
    orderId?: string | null;
    orderStatus!: OrderStatusEnums;
    paymentStatus!: PaymentStatusEnums;
    customer?: OrderCustomerDTO | null;
    sellerAlias?: string | null;
    products?: OrderProductDTO[] | null;
    deliveryDate!: string;
    currency?: string | null;
    isOutDated!: boolean;

    constructor(data?: IOrderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : <any>null;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : <any>null;
            this.paymentStatus = _data["paymentStatus"] !== undefined ? _data["paymentStatus"] : <any>null;
            this.customer = _data["customer"] ? OrderCustomerDTO.fromJS(_data["customer"]) : <any>null;
            this.sellerAlias = _data["sellerAlias"] !== undefined ? _data["sellerAlias"] : <any>null;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(OrderProductDTO.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
            this.deliveryDate = _data["deliveryDate"] !== undefined ? _data["deliveryDate"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.isOutDated = _data["isOutDated"] !== undefined ? _data["isOutDated"] : <any>null;
        }
    }

    static fromJS(data: any): OrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["orderId"] = this.orderId !== undefined ? this.orderId : <any>null;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : <any>null;
        data["paymentStatus"] = this.paymentStatus !== undefined ? this.paymentStatus : <any>null;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>null;
        data["sellerAlias"] = this.sellerAlias !== undefined ? this.sellerAlias : <any>null;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["deliveryDate"] = this.deliveryDate !== undefined ? this.deliveryDate : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["isOutDated"] = this.isOutDated !== undefined ? this.isOutDated : <any>null;
        return data;
    }
}

export interface IOrderDTO {
    id: string;
    orderId?: string | null;
    orderStatus: OrderStatusEnums;
    paymentStatus: PaymentStatusEnums;
    customer?: OrderCustomerDTO | null;
    sellerAlias?: string | null;
    products?: OrderProductDTO[] | null;
    deliveryDate: string;
    currency?: string | null;
    isOutDated: boolean;
}

export class OrderCustomerDTO implements IOrderCustomerDTO {
    id!: string;
    customerMode!: CustomerModeEnums;
    companyType!: CompanyEnums;
    customerNo?: string | null;
    companyNo?: string | null;
    companyName?: string | null;
    vatNo?: string | null;
    firstName?: string | null;
    lastName?: string | null;

    constructor(data?: IOrderCustomerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.customerMode = _data["customerMode"] !== undefined ? _data["customerMode"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : <any>null;
            this.companyNo = _data["companyNo"] !== undefined ? _data["companyNo"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.vatNo = _data["vatNo"] !== undefined ? _data["vatNo"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): OrderCustomerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["customerMode"] = this.customerMode !== undefined ? this.customerMode : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : <any>null;
        data["companyNo"] = this.companyNo !== undefined ? this.companyNo : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["vatNo"] = this.vatNo !== undefined ? this.vatNo : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data;
    }
}

export interface IOrderCustomerDTO {
    id: string;
    customerMode: CustomerModeEnums;
    companyType: CompanyEnums;
    customerNo?: string | null;
    companyNo?: string | null;
    companyName?: string | null;
    vatNo?: string | null;
    firstName?: string | null;
    lastName?: string | null;
}

export class OrderProductDTO implements IOrderProductDTO {
    productFK!: string;
    name?: string | null;
    pieces!: number;
    packingSorting!: number;
    storageLocation?: string | null;
    quantity!: number;
    unit!: UnitEnums;
    price!: number;
    vat!: number;
    weight!: number;
    cartonWeight!: number;
    productNumber?: string | null;

    constructor(data?: IOrderProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productFK = _data["productFK"] !== undefined ? _data["productFK"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.pieces = _data["pieces"] !== undefined ? _data["pieces"] : <any>null;
            this.packingSorting = _data["packingSorting"] !== undefined ? _data["packingSorting"] : <any>null;
            this.storageLocation = _data["storageLocation"] !== undefined ? _data["storageLocation"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
            this.cartonWeight = _data["cartonWeight"] !== undefined ? _data["cartonWeight"] : <any>null;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : <any>null;
        }
    }

    static fromJS(data: any): OrderProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productFK"] = this.productFK !== undefined ? this.productFK : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["pieces"] = this.pieces !== undefined ? this.pieces : <any>null;
        data["packingSorting"] = this.packingSorting !== undefined ? this.packingSorting : <any>null;
        data["storageLocation"] = this.storageLocation !== undefined ? this.storageLocation : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["cartonWeight"] = this.cartonWeight !== undefined ? this.cartonWeight : <any>null;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : <any>null;
        return data;
    }
}

export interface IOrderProductDTO {
    productFK: string;
    name?: string | null;
    pieces: number;
    packingSorting: number;
    storageLocation?: string | null;
    quantity: number;
    unit: UnitEnums;
    price: number;
    vat: number;
    weight: number;
    cartonWeight: number;
    productNumber?: string | null;
}

export class PriceTemplateViewModel implements IPriceTemplateViewModel {
    id?: string | null;
    name?: string | null;
    currencyISO?: string | null;
    products?: ProductEntity[] | null;

    constructor(data?: IPriceTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.currencyISO = _data["currencyISO"] !== undefined ? _data["currencyISO"] : <any>null;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductEntity.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
        }
    }

    static fromJS(data: any): PriceTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["currencyISO"] = this.currencyISO !== undefined ? this.currencyISO : <any>null;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPriceTemplateViewModel {
    id?: string | null;
    name?: string | null;
    currencyISO?: string | null;
    products?: ProductEntity[] | null;
}

export class ApiResultOfPriceTemplateViewModel implements IApiResultOfPriceTemplateViewModel {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: PriceTemplateViewModel | null;

    constructor(data?: IApiResultOfPriceTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? PriceTemplateViewModel.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfPriceTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfPriceTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfPriceTemplateViewModel {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: PriceTemplateViewModel | null;
}

export class ApiResultOfProductEntity implements IApiResultOfProductEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: ProductEntity | null;

    constructor(data?: IApiResultOfProductEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? ProductEntity.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfProductEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfProductEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfProductEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: ProductEntity | null;
}

export class ApiResultOfDouble implements IApiResultOfDouble {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data!: number;

    constructor(data?: IApiResultOfDouble) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfDouble {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfDouble();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data;
    }
}

export interface IApiResultOfDouble {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data: number;
}

export class ApiResultOfProviderEntity implements IApiResultOfProviderEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: ProviderEntity | null;

    constructor(data?: IApiResultOfProviderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? ProviderEntity.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfProviderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfProviderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfProviderEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: ProviderEntity | null;
}

export class ApiResultOfProvider_Product_LogEntity implements IApiResultOfProvider_Product_LogEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: Provider_Product_LogEntity | null;

    constructor(data?: IApiResultOfProvider_Product_LogEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? Provider_Product_LogEntity.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfProvider_Product_LogEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfProvider_Product_LogEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfProvider_Product_LogEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: Provider_Product_LogEntity | null;
}

export class ApiResultOfPurchaseEntity implements IApiResultOfPurchaseEntity {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: PurchaseEntity | null;

    constructor(data?: IApiResultOfPurchaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] ? PurchaseEntity.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfPurchaseEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfPurchaseEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }
}

export interface IApiResultOfPurchaseEntity {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: PurchaseEntity | null;
}

export class AskProductResponse implements IAskProductResponse {
    weekProducts?: AskProductDto[] | null;
    weekEvenProducts?: AskProductDto[] | null;
    weekOddProducts?: AskProductDto[] | null;
    monthProducts?: AskProductDto[] | null;

    constructor(data?: IAskProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weekProducts"])) {
                this.weekProducts = [] as any;
                for (let item of _data["weekProducts"])
                    this.weekProducts!.push(AskProductDto.fromJS(item));
            }
            else {
                this.weekProducts = <any>null;
            }
            if (Array.isArray(_data["weekEvenProducts"])) {
                this.weekEvenProducts = [] as any;
                for (let item of _data["weekEvenProducts"])
                    this.weekEvenProducts!.push(AskProductDto.fromJS(item));
            }
            else {
                this.weekEvenProducts = <any>null;
            }
            if (Array.isArray(_data["weekOddProducts"])) {
                this.weekOddProducts = [] as any;
                for (let item of _data["weekOddProducts"])
                    this.weekOddProducts!.push(AskProductDto.fromJS(item));
            }
            else {
                this.weekOddProducts = <any>null;
            }
            if (Array.isArray(_data["monthProducts"])) {
                this.monthProducts = [] as any;
                for (let item of _data["monthProducts"])
                    this.monthProducts!.push(AskProductDto.fromJS(item));
            }
            else {
                this.monthProducts = <any>null;
            }
        }
    }

    static fromJS(data: any): AskProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AskProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weekProducts)) {
            data["weekProducts"] = [];
            for (let item of this.weekProducts)
                data["weekProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.weekEvenProducts)) {
            data["weekEvenProducts"] = [];
            for (let item of this.weekEvenProducts)
                data["weekEvenProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.weekOddProducts)) {
            data["weekOddProducts"] = [];
            for (let item of this.weekOddProducts)
                data["weekOddProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.monthProducts)) {
            data["monthProducts"] = [];
            for (let item of this.monthProducts)
                data["monthProducts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAskProductResponse {
    weekProducts?: AskProductDto[] | null;
    weekEvenProducts?: AskProductDto[] | null;
    weekOddProducts?: AskProductDto[] | null;
    monthProducts?: AskProductDto[] | null;
}

export class AskProductDto implements IAskProductDto {
    productFk!: string;
    productNumber?: string | null;
    productName?: string | null;
    unit!: UnitEnums;
    pieces!: number;
    quantity!: number;
    price!: number;
    orderDate!: string;
    rate!: number;

    constructor(data?: IAskProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productFk = _data["productFk"] !== undefined ? _data["productFk"] : <any>null;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.pieces = _data["pieces"] !== undefined ? _data["pieces"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.orderDate = _data["orderDate"] !== undefined ? _data["orderDate"] : <any>null;
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): AskProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new AskProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productFk"] = this.productFk !== undefined ? this.productFk : <any>null;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["pieces"] = this.pieces !== undefined ? this.pieces : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["orderDate"] = this.orderDate !== undefined ? this.orderDate : <any>null;
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        return data;
    }
}

export interface IAskProductDto {
    productFk: string;
    productNumber?: string | null;
    productName?: string | null;
    unit: UnitEnums;
    pieces: number;
    quantity: number;
    price: number;
    orderDate: string;
    rate: number;
}

export class StockViewModel implements IStockViewModel {
    productId!: string;
    productNumber?: string | null;
    mainProviderFK?: string | null;
    name?: string | null;
    inStock!: number;
    unit!: ProductUnitEnums;
    daysLeft!: number;
    minPointDays!: number;
    sevenDays!: number;
    thirtyDays!: number;
    threeMonths!: number;
    providers?: ProviderEntity[] | null;
    incoming?: PurchaseProductEntity[] | null;
    customers?: CustomerEntity[] | null;

    constructor(data?: IStockViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : <any>null;
            this.mainProviderFK = _data["mainProviderFK"] !== undefined ? _data["mainProviderFK"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.inStock = _data["inStock"] !== undefined ? _data["inStock"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.daysLeft = _data["daysLeft"] !== undefined ? _data["daysLeft"] : <any>null;
            this.minPointDays = _data["minPointDays"] !== undefined ? _data["minPointDays"] : <any>null;
            this.sevenDays = _data["sevenDays"] !== undefined ? _data["sevenDays"] : <any>null;
            this.thirtyDays = _data["thirtyDays"] !== undefined ? _data["thirtyDays"] : <any>null;
            this.threeMonths = _data["threeMonths"] !== undefined ? _data["threeMonths"] : <any>null;
            if (Array.isArray(_data["providers"])) {
                this.providers = [] as any;
                for (let item of _data["providers"])
                    this.providers!.push(ProviderEntity.fromJS(item));
            }
            else {
                this.providers = <any>null;
            }
            if (Array.isArray(_data["incoming"])) {
                this.incoming = [] as any;
                for (let item of _data["incoming"])
                    this.incoming!.push(PurchaseProductEntity.fromJS(item));
            }
            else {
                this.incoming = <any>null;
            }
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(CustomerEntity.fromJS(item));
            }
            else {
                this.customers = <any>null;
            }
        }
    }

    static fromJS(data: any): StockViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : <any>null;
        data["mainProviderFK"] = this.mainProviderFK !== undefined ? this.mainProviderFK : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["inStock"] = this.inStock !== undefined ? this.inStock : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["daysLeft"] = this.daysLeft !== undefined ? this.daysLeft : <any>null;
        data["minPointDays"] = this.minPointDays !== undefined ? this.minPointDays : <any>null;
        data["sevenDays"] = this.sevenDays !== undefined ? this.sevenDays : <any>null;
        data["thirtyDays"] = this.thirtyDays !== undefined ? this.thirtyDays : <any>null;
        data["threeMonths"] = this.threeMonths !== undefined ? this.threeMonths : <any>null;
        if (Array.isArray(this.providers)) {
            data["providers"] = [];
            for (let item of this.providers)
                data["providers"].push(item.toJSON());
        }
        if (Array.isArray(this.incoming)) {
            data["incoming"] = [];
            for (let item of this.incoming)
                data["incoming"].push(item.toJSON());
        }
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStockViewModel {
    productId: string;
    productNumber?: string | null;
    mainProviderFK?: string | null;
    name?: string | null;
    inStock: number;
    unit: ProductUnitEnums;
    daysLeft: number;
    minPointDays: number;
    sevenDays: number;
    thirtyDays: number;
    threeMonths: number;
    providers?: ProviderEntity[] | null;
    incoming?: PurchaseProductEntity[] | null;
    customers?: CustomerEntity[] | null;
}

export class StockValueViewModel implements IStockValueViewModel {
    artNumber?: string | null;
    artikelName?: string | null;
    stockQuantity!: number;
    unit?: string | null;
    priceAverage!: number;
    stockValue!: number;

    constructor(data?: IStockValueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.artNumber = _data["artNumber"] !== undefined ? _data["artNumber"] : <any>null;
            this.artikelName = _data["artikelName"] !== undefined ? _data["artikelName"] : <any>null;
            this.stockQuantity = _data["stockQuantity"] !== undefined ? _data["stockQuantity"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.priceAverage = _data["priceAverage"] !== undefined ? _data["priceAverage"] : <any>null;
            this.stockValue = _data["stockValue"] !== undefined ? _data["stockValue"] : <any>null;
        }
    }

    static fromJS(data: any): StockValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["artNumber"] = this.artNumber !== undefined ? this.artNumber : <any>null;
        data["artikelName"] = this.artikelName !== undefined ? this.artikelName : <any>null;
        data["stockQuantity"] = this.stockQuantity !== undefined ? this.stockQuantity : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["priceAverage"] = this.priceAverage !== undefined ? this.priceAverage : <any>null;
        data["stockValue"] = this.stockValue !== undefined ? this.stockValue : <any>null;
        return data;
    }
}

export interface IStockValueViewModel {
    artNumber?: string | null;
    artikelName?: string | null;
    stockQuantity: number;
    unit?: string | null;
    priceAverage: number;
    stockValue: number;
}

export class ApiResultOfString implements IApiResultOfString {
    title?: string | null;
    isSuccess!: boolean;
    messages?: string[] | null;
    data?: string | null;

    constructor(data?: IApiResultOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            else {
                this.messages = <any>null;
            }
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): ApiResultOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data;
    }
}

export interface IApiResultOfString {
    title?: string | null;
    isSuccess: boolean;
    messages?: string[] | null;
    data?: string | null;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}